(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[613],{

/***/ 2790:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ ArticleCardType; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(315);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2991);
/* harmony import */ var _helpers_LangHelper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7868);
/* harmony import */ var _hook_useWindowSize__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8766);
/* harmony import */ var _categories_categories__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8324);
/* harmony import */ var _icons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3203);
/* harmony import */ var _lazy_background_image_lazy_background_image__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(204);
/* harmony import */ var _skeleton_load_article_card_skeleton_article_card_skeleton__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8533);
/* harmony import */ var _article_card_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2316);
/* harmony import */ var _article_card_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_article_card_module_scss__WEBPACK_IMPORTED_MODULE_9__);










var ArticleCardType;
(function(ArticleCardType) {
    ArticleCardType["Small"] = "small";
    ArticleCardType["Large"] = "large";
})(ArticleCardType || (ArticleCardType = {}));
const ArticleCard = (props)=>{
    const { locale  } = (0,_helpers_LangHelper__WEBPACK_IMPORTED_MODULE_3__/* .useLocale */ .bU)();
    const [isLoading, setLoading] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const { article , type , fixedWidth  } = props;
    const windowSize = (0,_hook_useWindowSize__WEBPACK_IMPORTED_MODULE_4__/* .useWindowSize */ .i)();
    const getClassSkeletonImage = ()=>{
        if (isLoading) {
            return "loading";
        } else {
            return "";
        }
    };
    const targetUrl = (0,_helpers_LangHelper__WEBPACK_IMPORTED_MODULE_3__/* .localifyLink */ .Bj)("/".concat(locale).concat(article.articleUrl), locale);
    const articleImage = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(()=>{
        // Horiz image for small card
        let articleImage = article.leadImage || article.leadPortraitImage;
        let imageWidth = 500;
        var _width;
        if (((_width = windowSize.width) !== null && _width !== void 0 ? _width : 0) > 768 && type === ArticleCardType.Large) {
            // Portrait image for Large card
            articleImage = article.leadPortraitImage || article.leadImage;
            imageWidth = 800;
        }
        return {
            url: articleImage,
            width: imageWidth
        };
    }, [
        type,
        windowSize.width,
        article
    ]);
    return isLoading || !article ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_skeleton_load_article_card_skeleton_article_card_skeleton__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        type
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_article_card_module_scss__WEBPACK_IMPORTED_MODULE_9___default().articleCard), (_article_card_module_scss__WEBPACK_IMPORTED_MODULE_9___default())[type], {
            [(_article_card_module_scss__WEBPACK_IMPORTED_MODULE_9___default().fixedWidth)]: fixedWidth
        }),
        style: {
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_article_card_module_scss__WEBPACK_IMPORTED_MODULE_9___default().articleCardImageWrapper) + " " + (_article_card_module_scss__WEBPACK_IMPORTED_MODULE_9___default())[getClassSkeletonImage()],
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_lazy_background_image_lazy_background_image__WEBPACK_IMPORTED_MODULE_7__/* .LazyBackgroundImage */ .I, {
                    className: (_article_card_module_scss__WEBPACK_IMPORTED_MODULE_9___default().articleCardImage),
                    imageUrl: articleImage.url,
                    imageWidth: articleImage.width
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_article_card_module_scss__WEBPACK_IMPORTED_MODULE_9___default().articleCardContentWrapper),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_article_card_module_scss__WEBPACK_IMPORTED_MODULE_9___default().categoriesList),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_categories_categories__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            type: "SMALL",
                            categories: article.categories
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_article_card_module_scss__WEBPACK_IMPORTED_MODULE_9___default().articleCardContent),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "".concat((_article_card_module_scss__WEBPACK_IMPORTED_MODULE_9___default().articleCardContentTitle), " ").concat((_article_card_module_scss__WEBPACK_IMPORTED_MODULE_9___default().threeLinesLimit)),
                                children: article.title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "".concat((_article_card_module_scss__WEBPACK_IMPORTED_MODULE_9___default().articleCardContentDescription), " ").concat((_article_card_module_scss__WEBPACK_IMPORTED_MODULE_9___default().threeLinesLimit)),
                                children: article.description
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                        href: targetUrl,
                        target: "_self",
                        className: (_article_card_module_scss__WEBPACK_IMPORTED_MODULE_9___default().articleCardButtonReadMore),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: (_article_card_module_scss__WEBPACK_IMPORTED_MODULE_9___default().businessButtonText),
                                children: "Read more"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icons__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                type: _icons__WEBPACK_IMPORTED_MODULE_6__/* .IconType.ArrowRightMedium */ .T.ArrowRightMedium
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                href: targetUrl,
                target: "_self",
                className: (_article_card_module_scss__WEBPACK_IMPORTED_MODULE_9___default().articleCardLink)
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ArticleCard);


/***/ }),

/***/ 1834:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ article_grid; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(315);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(2991);
// EXTERNAL MODULE: ./helpers/cookieUtils.ts
var cookieUtils = __webpack_require__(5443);
// EXTERNAL MODULE: ./hook/useWindowSize.ts
var useWindowSize = __webpack_require__(8766);
// EXTERNAL MODULE: ./shared/sharedContext.tsx
var sharedContext = __webpack_require__(6224);
// EXTERNAL MODULE: ./components/article-card/article-card.tsx
var article_card = __webpack_require__(2790);
// EXTERNAL MODULE: ./components/icons/index.tsx + 82 modules
var icons = __webpack_require__(3203);
// EXTERNAL MODULE: ./components/sign-up-card/sign-up-card.tsx + 1 modules
var sign_up_card = __webpack_require__(5338);
// EXTERNAL MODULE: ./components/skeleton-load/article-card-skeleton/article-card-skeleton.tsx + 2 modules
var article_card_skeleton = __webpack_require__(8533);
// EXTERNAL MODULE: ./components/skeleton-load/article-grid-skeleton/article-grid-skeleton.module.scss
var article_grid_skeleton_module = __webpack_require__(3551);
var article_grid_skeleton_module_default = /*#__PURE__*/__webpack_require__.n(article_grid_skeleton_module);
;// CONCATENATED MODULE: ./components/skeleton-load/article-grid-skeleton/article-grid-skeleton.tsx





const dummyArticleGridSkeleton = [
    {
        type: article_card/* ArticleCardType.Small */._.Small
    },
    {
        type: article_card/* ArticleCardType.Large */._.Large
    },
    {
        type: article_card/* ArticleCardType.Small */._.Small
    },
    {
        type: article_card/* ArticleCardType.Small */._.Small
    },
    {
        type: article_card/* ArticleCardType.Small */._.Small
    },
    {
        type: article_card/* ArticleCardType.Large */._.Large
    },
    {
        type: article_card/* ArticleCardType.Small */._.Small
    },
    {
        type: article_card/* ArticleCardType.Small */._.Small
    },
    {
        type: article_card/* ArticleCardType.Small */._.Small
    },
    {
        type: article_card/* ArticleCardType.Small */._.Small
    }
];
const ArticleGridSkeleton = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (article_grid_skeleton_module_default()).articleGridSkeleton,
        children: dummyArticleGridSkeleton.map((articleSkeleton, index)=>{
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(article_card_skeleton/* default */.Z, {
                type: articleSkeleton.type
            }, "article_skeleton_".concat(index));
        })
    });
};
/* harmony default export */ var article_grid_skeleton = (ArticleGridSkeleton);

// EXTERNAL MODULE: ./components/article-grid/article-grid.module.scss
var article_grid_module = __webpack_require__(4688);
var article_grid_module_default = /*#__PURE__*/__webpack_require__.n(article_grid_module);
;// CONCATENATED MODULE: ./components/article-grid/article-grid.tsx










const CardType = {
    SMALL: "SMALL",
    LARGE: "LARGE",
    NEWSLETTER: "NEWSLETTER"
};
const templates = [
    [
        CardType.SMALL,
        CardType.LARGE
    ],
    [
        CardType.SMALL,
        CardType.SMALL,
        CardType.SMALL
    ],
    [
        CardType.LARGE,
        CardType.SMALL
    ],
    [
        CardType.SMALL,
        CardType.SMALL,
        CardType.SMALL
    ]
];
const tabletTemplate = [
    [
        CardType.SMALL,
        CardType.SMALL
    ],
    [
        CardType.LARGE,
        CardType.SMALL
    ]
];
const ArticleGrid = (props)=>{
    const { articles , setOffsetArticle , offsetArticle , isLoadingMoreArticles  } = props;
    const [haveNewsletterCookie, setNewsLetterCookie] = (0,react.useState)(false);
    const windowSize = (0,useWindowSize/* useWindowSize */.i)();
    const [filteredArticles, setFilteredArticles] = (0,react.useState)([]);
    const categoryCtx = (0,react.useContext)(sharedContext/* CategoryCtx */.N);
    (0,react.useEffect)(()=>{
        if (!categoryCtx) return;
        const newsletterSignUpCookie = (0,cookieUtils/* getCookie */.ej)("NewsletterSignUp");
        if (newsletterSignUpCookie && newsletterSignUpCookie !== "") {
            setNewsLetterCookie(true);
        }
        return ()=>{
            if (categoryCtx === null || categoryCtx === void 0 ? void 0 : categoryCtx.setCategoriesToFilter) {
                categoryCtx.setCategoriesToFilter([]);
            }
        };
    }, []);
    (0,react.useEffect)(()=>{
        setFilteredArticles(articles);
        if (categoryCtx === null || categoryCtx === void 0 ? void 0 : categoryCtx.setAllCategories) {
            const categories = {};
            articles.forEach((article)=>{
                article.categories.forEach((category)=>{
                    categories[category.id] = category;
                });
            });
            categoryCtx === null || categoryCtx === void 0 ? void 0 : categoryCtx.setAllCategories(Object.values(categories));
        }
    }, [
        articles
    ]);
    (0,react.useEffect)(()=>{
        if (!categoryCtx.categoriesToFilter || categoryCtx.categoriesToFilter.length === 0) {
            setFilteredArticles(articles);
            return;
        }
        const categoryIds = categoryCtx.categoriesToFilter.map((category)=>category.id);
        const updateFilteredArticles = articles.filter((article)=>article.categories.some((category)=>categoryIds.includes(category.id)));
        setFilteredArticles(updateFilteredArticles);
    }, [
        articles,
        categoryCtx.categoriesToFilter
    ]);
    const getIsMobile = ()=>{
        const windowWidth = windowSize.width || 0;
        if (windowWidth < 992) {
            return true;
        } else {
            return false;
        }
    };
    const isMobile = getIsMobile();
    const handleCards = ()=>{
        const maxTotalRows = filteredArticles.length;
        const cards = [];
        let articleIndex = 0;
        const cardTemplate = (windowSize.width || 0) > 1200 ? templates : tabletTemplate;
        for(let rowNumber = 0; rowNumber < maxTotalRows; rowNumber += 1){
            const templateIndex = rowNumber % cardTemplate.length;
            const templateRow = cardTemplate[templateIndex];
            if (articleIndex >= maxTotalRows) {
                break;
            }
            for(let colNumber = 0; colNumber < templateRow.length; colNumber++){
                const cartType = templateRow[colNumber];
                if (articleIndex >= maxTotalRows) {
                    break;
                }
                if (isMobile && !haveNewsletterCookie && rowNumber === 0 && colNumber === 1) {
                    cards.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(sign_up_card/* default */.Z, {}, "sign_up_card_".concat(articleIndex)));
                    continue;
                }
                if (!isMobile && !haveNewsletterCookie && rowNumber === 1 && colNumber === 2) {
                    cards.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(sign_up_card/* default */.Z, {}, "sign_up_card_".concat(articleIndex)));
                    continue;
                }
                const article = filteredArticles[articleIndex];
                if (cartType === CardType.SMALL) {
                    cards.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(article_card/* default */.Z, {
                        type: article_card/* ArticleCardType.Small */._.Small,
                        article: article
                    }, "article_card_".concat(articleIndex)));
                }
                if (cartType === CardType.LARGE) {
                    cards.push(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (article_grid_module_default()).articleLarge,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(article_card/* default */.Z, {
                            type: article_card/* ArticleCardType.Large */._.Large,
                            article: article
                        })
                    }, "article_card_".concat(article.url || Math.random())));
                }
                articleIndex += 1;
            }
        }
        return cards;
    };
    const handleLoadMoreArticle = ()=>{
        const count = offsetArticle + (offsetArticle === 0 ? 9 : 10);
        setOffsetArticle(count);
    };
    const renderButtonLoadMore = ()=>{
        if (articles.length < 9 || offsetArticle > articles.length) {
            return null;
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (article_grid_module_default()).buttonLoadMore + " " + (isLoadingMoreArticles ? (article_grid_module_default()).loading : (article_grid_module_default()).loaded),
            onClick: ()=>handleLoadMoreArticle(),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (article_grid_module_default()).buttonLoadMoreContent,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "Load more posts"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                        type: icons/* IconType.ArrowDown */.T.ArrowDown
                    })
                ]
            })
        });
    };
    const renderArticleContent = ()=>{
        if (articles.length === 0 && !isLoadingMoreArticles) {
            return null;
        }
        if (articles.length === 0) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(article_grid_skeleton, {});
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (article_grid_module_default()).articlesContainer,
            children: handleCards().map((card)=>card)
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (article_grid_module_default()).articleGrid,
        children: [
            renderArticleContent(),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (article_grid_module_default()).loadMoreContainer,
                children: [
                    renderButtonLoadMore(),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (article_grid_module_default()).spinnerLoadMore + " " + (isLoadingMoreArticles ? (article_grid_module_default()).loading : (article_grid_module_default()).loaded)
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var article_grid = (/*#__PURE__*/(0,react.memo)(ArticleGrid));


/***/ }),

/***/ 8324:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(315);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2991);
/* harmony import */ var _helpers_LangHelper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7868);
/* harmony import */ var _categories_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8625);
/* harmony import */ var _categories_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_categories_module_scss__WEBPACK_IMPORTED_MODULE_3__);




const CategoriesComponent = (props)=>{
    const { locale  } = (0,_helpers_LangHelper__WEBPACK_IMPORTED_MODULE_2__/* .useLocale */ .bU)();
    const { categories , type , color ="grey"  } = props;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_categories_module_scss__WEBPACK_IMPORTED_MODULE_3___default().categoriesList) + " " + (_categories_module_scss__WEBPACK_IMPORTED_MODULE_3___default())[type],
        children: (categories || []).map((item, index)=>{
            var _categoryUrl;
            const url = (0,_helpers_LangHelper__WEBPACK_IMPORTED_MODULE_2__/* .replaceOrAddLocale */ .yM)((_categoryUrl = item.categoryUrl) !== null && _categoryUrl !== void 0 ? _categoryUrl : "", locale);
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                className: (_categories_module_scss__WEBPACK_IMPORTED_MODULE_3___default().categoryName) + " " + (_categories_module_scss__WEBPACK_IMPORTED_MODULE_3___default())[color],
                href: url,
                children: item.name
            }, index);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CategoriesComponent);


/***/ }),

/***/ 3145:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(315);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2991);


const ArrowRightMedium = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M0.5 8.5H15.5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M10.5 3.5L15.5 8.5L10.5 13.5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ArrowRightMedium);


/***/ }),

/***/ 7763:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(315);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2991);


const Download = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M6 9V1",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M10 10L2 10",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M10 5L6 9L2 5",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Download);


/***/ }),

/***/ 3203:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": function() { return /* binding */ IconType; },
  "Z": function() { return /* binding */ icons; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(315);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(2991);
;// CONCATENATED MODULE: ./components/icons/Icons/AfterPay.tsx


const AfterPay = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "121",
        height: "24",
        viewBox: "0 0 121 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.95859 11.7444C9.95859 9.5873 8.43108 8.07125 6.55474 8.07125C4.6784 8.07125 3.15087 9.61286 3.15087 11.7444C3.15087 13.8503 4.6784 15.4175 6.55474 15.4175C8.43299 15.4155 9.95859 13.9015 9.95859 11.7444ZM9.98543 18.1645V16.4951C9.05972 17.6513 7.68169 18.369 6.03151 18.369C2.60273 18.369 0 15.5433 0 11.7444C0 7.969 2.70239 5.0942 6.10817 5.0942C7.71044 5.0942 9.06163 5.81389 9.98735 6.94257V5.32427H13.0654V18.1645H9.98543Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M28.0167 15.3133C26.9396 15.3133 26.6406 14.9023 26.6406 13.8248V8.12434H28.6185V5.32427H26.6406V2.19189H23.4859V5.32427H19.4227V4.54363C19.4227 3.46411 19.8233 3.05314 20.9253 3.05314H21.6172V0.561789H20.0993C17.4965 0.561789 16.2699 1.43484 16.2699 4.10513V5.3223H14.5182V8.12237H16.2699V18.1625H19.4246V8.12237H23.4878V14.4147C23.4878 17.0338 24.4633 18.1645 27.0162 18.1645H28.6434V15.3133H28.0167Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M39.3303 10.5882C39.1061 8.91874 37.7779 7.91787 36.2273 7.91787C34.6749 7.91787 33.3985 8.89318 33.0746 10.5882H39.3303ZM33.0477 12.5919C33.2739 14.4914 34.6002 15.5709 36.2772 15.5709C37.6035 15.5709 38.6307 14.9279 39.2306 13.9015H42.4601C41.7088 16.6229 39.3303 18.369 36.2024 18.369C32.4229 18.369 29.7704 15.6476 29.7704 11.7699C29.7704 7.89231 32.5743 5.09224 36.2791 5.09224C40.0088 5.09224 42.7112 7.91787 42.7112 11.7699C42.7112 12.0531 42.6862 12.3343 42.6364 12.5919H33.0477Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M62.7683 11.7444C62.7683 9.66399 61.2408 8.07125 59.3644 8.07125C57.4881 8.07125 55.9606 9.61286 55.9606 11.7444C55.9606 13.8503 57.4881 15.4175 59.3644 15.4175C61.2408 15.4155 62.7683 13.8248 62.7683 11.7444ZM52.8557 5.32427H55.9337V6.99369C56.8594 5.81192 58.2355 5.0942 59.8876 5.0942C63.2666 5.0942 65.9192 7.9454 65.9192 11.7188C65.9192 15.4942 63.2168 18.371 59.8129 18.371C58.2356 18.371 56.9342 17.728 56.0334 16.6504V23.448H52.8557V5.32427Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M77.0143 11.7444C77.0143 9.5873 75.4887 8.07125 73.6104 8.07125C71.7341 8.07125 70.2066 9.61286 70.2066 11.7444C70.2066 13.8503 71.7341 15.4175 73.6104 15.4175C75.4887 15.4155 77.0143 13.9015 77.0143 11.7444ZM77.0411 18.1645V16.4951C76.1154 17.6513 74.7374 18.369 73.0872 18.369C69.6584 18.369 67.0557 15.5433 67.0557 11.7444C67.0557 7.969 69.7581 5.0942 73.1619 5.0942C74.7642 5.0942 76.1154 5.81389 77.0411 6.94257V5.32427H80.1191V18.1645H77.0411Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M47.3072 6.58273C47.3072 6.58273 48.091 5.0942 50.0096 5.0942C50.8299 5.0942 51.3608 5.38326 51.3608 5.38326V8.65918C51.3608 8.65918 50.2031 7.92574 49.1394 8.07322C48.0757 8.22069 47.403 9.22353 47.4068 10.5646V18.1665H44.2291V5.32624H47.3072V6.58273Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M94.4955 5.32426L86.7237 23.4067H83.4464L86.4976 16.4164L81.3381 5.32426H85.0525L88.0711 12.7354L91.1683 5.32426H94.4955Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M119.304 5.03325L111.599 0.471336C109.338 -0.867743 106.511 0.805615 106.511 3.48574V3.95373C106.511 4.37649 106.731 4.76779 107.087 4.97819L108.542 5.83945C108.97 6.09311 109.502 5.77653 109.502 5.27118V4.1071C109.502 3.52507 110.116 3.16129 110.606 3.45231L117.28 7.40466C117.771 7.69568 117.771 8.42323 117.28 8.71228L110.606 12.6646C110.116 12.9556 109.502 12.5919 109.502 12.0098V11.3904C109.502 8.71031 106.675 7.03499 104.412 8.37603L96.7072 12.9379C94.4457 14.277 94.4457 17.6277 96.7072 18.9668L104.412 23.5287C106.673 24.8677 109.502 23.1944 109.502 20.5143V20.0463C109.502 19.6235 109.282 19.2342 108.925 19.0218L107.471 18.1586C107.043 17.9049 106.511 18.2215 106.511 18.7269V19.8909C106.511 20.473 105.897 20.8367 105.407 20.5457L98.7331 16.5934C98.2424 16.3024 98.2424 15.5748 98.7331 15.2838L105.407 11.3314C105.897 11.0404 106.511 11.4042 106.511 11.9862V12.6056C106.511 15.2858 109.338 16.9611 111.599 15.62L119.304 11.0581C121.565 9.72298 121.565 6.37233 119.304 5.03325Z",
                fill: "white"
            })
        ]
    });
};
/* harmony default export */ var Icons_AfterPay = (AfterPay);

;// CONCATENATED MODULE: ./components/icons/Icons/ArrowBack.tsx


const ArrowBack = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2.5 16.5H16.5C20.366 16.5 23.5 13.366 23.5 9.5C23.5 5.634 20.366 2.5 16.5 2.5H9.5",
                stroke: "black",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.5 11.5L2.5 16.5L7.5 21.5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            })
        ]
    });
};
/* harmony default export */ var Icons_ArrowBack = (ArrowBack);

;// CONCATENATED MODULE: ./components/icons/Icons/ArrowDown.tsx


const ArrowDown = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6 11.5V0.5",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10 7.5L6 11.5L2 7.5",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ var Icons_ArrowDown = (ArrowDown);

;// CONCATENATED MODULE: ./components/icons/Icons/ArrowRightBig.tsx


const ArrowRightBig = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2.5 12.5H22.5",
                stroke: "black",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.5 5.5L22.5 12.5L15.5 19.5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            })
        ]
    });
};
/* harmony default export */ var Icons_ArrowRightBig = (ArrowRightBig);

// EXTERNAL MODULE: ./components/icons/Icons/ArrowRightMedium.tsx
var ArrowRightMedium = __webpack_require__(3145);
;// CONCATENATED MODULE: ./components/icons/Icons/ArrowRightOutline.tsx


const ArrowRightOutline = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1.5 12.5H14.5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.5 17.5V7.5L21.5 12.5L14.5 17.5Z",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            })
        ]
    });
};
/* harmony default export */ var Icons_ArrowRightOutline = (ArrowRightOutline);

;// CONCATENATED MODULE: ./components/icons/Icons/ArrowRightSmall.tsx


const ArrowRightSmall = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.5 6H0.5",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.5 2L11.5 6L7.5 10",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ var Icons_ArrowRightSmall = (ArrowRightSmall);

;// CONCATENATED MODULE: ./components/icons/Icons/ArrowUpBig.tsx


const ArrowUpBig = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M11.5 8.5L6 2.5L0.5 8.5",
            stroke: "black",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
/* harmony default export */ var Icons_ArrowUpBig = (ArrowUpBig);

;// CONCATENATED MODULE: ./components/icons/Icons/Barcode.tsx


const Barcode = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.5 2C5.5 1.72386 5.27614 1.5 5 1.5C4.72386 1.5 4.5 1.72386 4.5 2V14C4.5 14.2761 4.72386 14.5 5 14.5C5.27614 14.5 5.5 14.2761 5.5 14V2Z",
                stroke: "black"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.5 2C8.5 1.72386 8.27614 1.5 8 1.5C7.72386 1.5 7.5 1.72386 7.5 2V14C7.5 14.2761 7.72386 14.5 8 14.5C8.27614 14.5 8.5 14.2761 8.5 14V2Z",
                stroke: "black"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.5 2C13.5 1.72386 13.2761 1.5 13 1.5C12.7239 1.5 12.5 1.72386 12.5 2V14C12.5 14.2761 12.7239 14.5 13 14.5C13.2761 14.5 13.5 14.2761 13.5 14V2Z",
                stroke: "black"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.500001 1.5L0.5 14.5",
                stroke: "black",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2.5 1.5V14.5",
                stroke: "black",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.5 1.5V14.5",
                stroke: "black",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.5 1.5V14.5",
                stroke: "black",
                strokeLinecap: "round"
            })
        ]
    });
};
/* harmony default export */ var Icons_Barcode = (Barcode);

;// CONCATENATED MODULE: ./components/icons/Icons/Business.tsx


const Business = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "105",
        height: "30",
        viewBox: "0 0 105 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.853 19.7V21H13.393V7.4H15.933V12.22C16.333 11.7667 16.793 11.42 17.313 11.18C17.8464 10.94 18.413 10.82 19.013 10.82C20.373 10.82 21.513 11.3133 22.433 12.3C23.3664 13.2867 23.833 14.5133 23.833 15.98C23.833 17.4333 23.3597 18.66 22.413 19.66C21.4797 20.66 20.3264 21.16 18.953 21.16C18.3264 21.16 17.7464 21.04 17.213 20.8C16.6797 20.5467 16.2264 20.18 15.853 19.7ZM15.873 16C15.873 16.8133 16.133 17.4933 16.653 18.04C17.1864 18.5867 17.833 18.86 18.593 18.86C19.353 18.86 19.993 18.5867 20.513 18.04C21.0464 17.48 21.313 16.8 21.313 16C21.313 15.2 21.0464 14.5267 20.513 13.98C19.993 13.42 19.353 13.14 18.593 13.14C17.833 13.14 17.1864 13.4133 16.653 13.96C16.133 14.5067 15.873 15.1867 15.873 16ZM33.9862 11V21H31.5262V19.76C31.2995 20.1733 30.9328 20.5133 30.4262 20.78C29.9328 21.0333 29.3795 21.16 28.7662 21.16C27.6995 21.16 26.8595 20.8533 26.2462 20.24C25.6462 19.6267 25.3462 18.78 25.3462 17.7V11H27.8862V17.3C27.8862 17.82 28.0395 18.2333 28.3462 18.54C28.6528 18.8333 29.0728 18.98 29.6062 18.98C30.1395 18.98 30.5795 18.8267 30.9262 18.52C31.2862 18.2133 31.4662 17.82 31.4662 17.34V11H33.9862ZM40.1693 10.82C41.4493 10.82 42.4893 11.1 43.2893 11.66C44.1026 12.22 44.5626 13.0067 44.6693 14.02H42.2893C42.156 13.6067 41.896 13.3 41.5093 13.1C41.136 12.8867 40.636 12.78 40.0093 12.78C39.4226 12.78 38.956 12.8733 38.6093 13.06C38.276 13.2333 38.1093 13.48 38.1093 13.8C38.1093 14.08 38.256 14.3 38.5493 14.46C38.856 14.62 39.5293 14.76 40.5693 14.88C41.3826 14.9867 41.9826 15.0867 42.3693 15.18C42.7693 15.2733 43.1093 15.3867 43.3893 15.52C43.896 15.7467 44.2693 16.0533 44.5093 16.44C44.7493 16.8133 44.8693 17.2733 44.8693 17.82C44.8693 18.8333 44.4293 19.6467 43.5493 20.26C42.6826 20.86 41.5426 21.16 40.1293 21.16C38.7426 21.16 37.6426 20.88 36.8293 20.32C36.016 19.76 35.5493 18.9467 35.4293 17.88H37.8893C38.0493 18.3467 38.316 18.6867 38.6893 18.9C39.0626 19.1133 39.5826 19.22 40.2493 19.22C40.9026 19.22 41.416 19.12 41.7893 18.92C42.176 18.72 42.3693 18.44 42.3693 18.08C42.3693 17.7867 42.2093 17.5533 41.8893 17.38C41.5826 17.2067 40.896 17.06 39.8293 16.94C39.0293 16.8333 38.4293 16.74 38.0293 16.66C37.6426 16.5667 37.3093 16.4533 37.0293 16.32C36.536 16.0933 36.1693 15.7933 35.9293 15.42C35.6893 15.0467 35.5693 14.5933 35.5693 14.06C35.5693 13.0733 35.9826 12.2867 36.8093 11.7C37.636 11.1133 38.756 10.82 40.1693 10.82ZM49.1023 8.32C49.1023 8.70667 48.9556 9.04667 48.6623 9.34C48.3823 9.62 48.0489 9.76 47.6623 9.76C47.2756 9.76 46.9356 9.62 46.6423 9.34C46.3623 9.04667 46.2223 8.70667 46.2223 8.32C46.2223 7.93333 46.3623 7.6 46.6423 7.32C46.9356 7.02667 47.2756 6.88 47.6623 6.88C48.0489 6.88 48.3823 7.02667 48.6623 7.32C48.9556 7.6 49.1023 7.93333 49.1023 8.32ZM48.9023 11V21H46.3823V11H48.9023ZM59.6502 14.32V21H57.1302V14.78C57.1302 14.26 56.9702 13.8467 56.6502 13.54C56.3436 13.2333 55.9236 13.08 55.3902 13.08C54.8569 13.08 54.4169 13.24 54.0702 13.56C53.7236 13.8667 53.5502 14.2667 53.5502 14.76V21H51.0102V11H53.4702V12.26C53.7236 11.8333 54.0969 11.4867 54.5902 11.22C55.0969 10.9533 55.6502 10.82 56.2502 10.82C57.3036 10.82 58.1302 11.1333 58.7302 11.76C59.3436 12.3867 59.6502 13.24 59.6502 14.32ZM71.5334 16.02C71.5334 16.1267 71.5267 16.24 71.5134 16.36C71.5 16.4667 71.4867 16.5667 71.4734 16.66H63.8134C63.8934 17.3667 64.1667 17.9333 64.6334 18.36C65.1134 18.7733 65.7 18.98 66.3934 18.98C66.9 18.98 67.3534 18.8667 67.7534 18.64C68.1667 18.4133 68.5 18.0933 68.7534 17.68H71.3334C71.0267 18.7467 70.4267 19.5933 69.5334 20.22C68.64 20.8467 67.5734 21.16 66.3334 21.16C64.8267 21.16 63.5934 20.68 62.6334 19.72C61.6734 18.76 61.1934 17.5267 61.1934 16.02C61.1934 14.5267 61.6867 13.2867 62.6734 12.3C63.66 11.3133 64.9 10.82 66.3934 10.82C67.8867 10.82 69.1134 11.3133 70.0734 12.3C71.0467 13.2733 71.5334 14.5133 71.5334 16.02ZM66.3534 13.02C65.7134 13.02 65.16 13.2067 64.6934 13.58C64.24 13.9533 63.9534 14.46 63.8334 15.1H68.8334C68.7534 14.4733 68.48 13.9733 68.0134 13.6C67.56 13.2133 67.0067 13.02 66.3534 13.02ZM77.181 10.82C78.461 10.82 79.501 11.1 80.301 11.66C81.1143 12.22 81.5743 13.0067 81.681 14.02H79.301C79.1677 13.6067 78.9077 13.3 78.521 13.1C78.1477 12.8867 77.6477 12.78 77.021 12.78C76.4343 12.78 75.9677 12.8733 75.621 13.06C75.2877 13.2333 75.121 13.48 75.121 13.8C75.121 14.08 75.2677 14.3 75.561 14.46C75.8677 14.62 76.541 14.76 77.581 14.88C78.3943 14.9867 78.9943 15.0867 79.381 15.18C79.781 15.2733 80.121 15.3867 80.401 15.52C80.9077 15.7467 81.281 16.0533 81.521 16.44C81.761 16.8133 81.881 17.2733 81.881 17.82C81.881 18.8333 81.441 19.6467 80.561 20.26C79.6943 20.86 78.5543 21.16 77.141 21.16C75.7543 21.16 74.6543 20.88 73.841 20.32C73.0277 19.76 72.561 18.9467 72.441 17.88H74.901C75.061 18.3467 75.3277 18.6867 75.701 18.9C76.0743 19.1133 76.5943 19.22 77.261 19.22C77.9143 19.22 78.4277 19.12 78.801 18.92C79.1877 18.72 79.381 18.44 79.381 18.08C79.381 17.7867 79.221 17.5533 78.901 17.38C78.5943 17.2067 77.9077 17.06 76.841 16.94C76.041 16.8333 75.441 16.74 75.041 16.66C74.6543 16.5667 74.321 16.4533 74.041 16.32C73.5477 16.0933 73.181 15.7933 72.941 15.42C72.701 15.0467 72.581 14.5933 72.581 14.06C72.581 13.0733 72.9943 12.2867 73.821 11.7C74.6477 11.1133 75.7677 10.82 77.181 10.82ZM87.474 10.82C88.754 10.82 89.794 11.1 90.594 11.66C91.4073 12.22 91.8673 13.0067 91.974 14.02H89.594C89.4607 13.6067 89.2007 13.3 88.814 13.1C88.4407 12.8867 87.9407 12.78 87.314 12.78C86.7273 12.78 86.2607 12.8733 85.914 13.06C85.5807 13.2333 85.414 13.48 85.414 13.8C85.414 14.08 85.5607 14.3 85.854 14.46C86.1607 14.62 86.834 14.76 87.874 14.88C88.6873 14.9867 89.2873 15.0867 89.674 15.18C90.074 15.2733 90.414 15.3867 90.694 15.52C91.2007 15.7467 91.574 16.0533 91.814 16.44C92.054 16.8133 92.174 17.2733 92.174 17.82C92.174 18.8333 91.734 19.6467 90.854 20.26C89.9873 20.86 88.8473 21.16 87.434 21.16C86.0473 21.16 84.9473 20.88 84.134 20.32C83.3207 19.76 82.854 18.9467 82.734 17.88H85.194C85.354 18.3467 85.6207 18.6867 85.994 18.9C86.3673 19.1133 86.8873 19.22 87.554 19.22C88.2073 19.22 88.7207 19.12 89.094 18.92C89.4807 18.72 89.674 18.44 89.674 18.08C89.674 17.7867 89.514 17.5533 89.194 17.38C88.8873 17.2067 88.2007 17.06 87.134 16.94C86.334 16.8333 85.734 16.74 85.334 16.66C84.9473 16.5667 84.614 16.4533 84.334 16.32C83.8407 16.0933 83.474 15.7933 83.234 15.42C82.994 15.0467 82.874 14.5933 82.874 14.06C82.874 13.0733 83.2873 12.2867 84.114 11.7C84.9407 11.1133 86.0607 10.82 87.474 10.82Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "1",
                y: "1",
                width: "103",
                height: "28",
                rx: "14",
                stroke: "white",
                strokeWidth: "2"
            })
        ]
    });
};
/* harmony default export */ var Icons_Business = (Business);

;// CONCATENATED MODULE: ./components/icons/Icons/BusinessSmall.tsx


const BusinessSmall = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "89",
        height: "28",
        viewBox: "0 0 89 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18.436 18.09V19H16.714V9.48H18.492V12.854C18.772 12.5367 19.094 12.294 19.458 12.126C19.8313 11.958 20.228 11.874 20.648 11.874C21.6 11.874 22.398 12.2193 23.042 12.91C23.6953 13.6007 24.022 14.4593 24.022 15.486C24.022 16.5033 23.6907 17.362 23.028 18.062C22.3747 18.762 21.5673 19.112 20.606 19.112C20.1673 19.112 19.7613 19.028 19.388 18.86C19.0147 18.6827 18.6973 18.426 18.436 18.09ZM18.45 15.5C18.45 16.0693 18.632 16.5453 18.996 16.928C19.3693 17.3107 19.822 17.502 20.354 17.502C20.886 17.502 21.334 17.3107 21.698 16.928C22.0713 16.536 22.258 16.06 22.258 15.5C22.258 14.94 22.0713 14.4687 21.698 14.086C21.334 13.694 20.886 13.498 20.354 13.498C19.822 13.498 19.3693 13.6893 18.996 14.072C18.632 14.4547 18.45 14.9307 18.45 15.5ZM31.1292 12V19H29.4072V18.132C29.2485 18.4213 28.9919 18.6593 28.6372 18.846C28.2919 19.0233 27.9045 19.112 27.4752 19.112C26.7285 19.112 26.1405 18.8973 25.7112 18.468C25.2912 18.0387 25.0812 17.446 25.0812 16.69V12H26.8592V16.41C26.8592 16.774 26.9665 17.0633 27.1812 17.278C27.3959 17.4833 27.6899 17.586 28.0632 17.586C28.4365 17.586 28.7445 17.4787 28.9872 17.264C29.2392 17.0493 29.3652 16.774 29.3652 16.438V12H31.1292ZM35.4574 11.874C36.3534 11.874 37.0814 12.07 37.6414 12.462C38.2107 12.854 38.5327 13.4047 38.6074 14.114H36.9414C36.848 13.8247 36.666 13.61 36.3954 13.47C36.134 13.3207 35.784 13.246 35.3454 13.246C34.9347 13.246 34.608 13.3113 34.3654 13.442C34.132 13.5633 34.0154 13.736 34.0154 13.96C34.0154 14.156 34.118 14.31 34.3234 14.422C34.538 14.534 35.0094 14.632 35.7374 14.716C36.3067 14.7907 36.7267 14.8607 36.9974 14.926C37.2774 14.9913 37.5154 15.0707 37.7114 15.164C38.066 15.3227 38.3274 15.5373 38.4954 15.808C38.6634 16.0693 38.7474 16.3913 38.7474 16.774C38.7474 17.4833 38.4394 18.0527 37.8234 18.482C37.2167 18.902 36.4187 19.112 35.4294 19.112C34.4587 19.112 33.6887 18.916 33.1194 18.524C32.55 18.132 32.2234 17.5627 32.1394 16.816H33.8614C33.9734 17.1427 34.16 17.3807 34.4214 17.53C34.6827 17.6793 35.0467 17.754 35.5134 17.754C35.9707 17.754 36.33 17.684 36.5914 17.544C36.862 17.404 36.9974 17.208 36.9974 16.956C36.9974 16.7507 36.8854 16.5873 36.6614 16.466C36.4467 16.3447 35.966 16.242 35.2194 16.158C34.6594 16.0833 34.2394 16.018 33.9594 15.962C33.6887 15.8967 33.4554 15.8173 33.2594 15.724C32.914 15.5653 32.6574 15.3553 32.4894 15.094C32.3214 14.8327 32.2374 14.5153 32.2374 14.142C32.2374 13.4513 32.5267 12.9007 33.1054 12.49C33.684 12.0793 34.468 11.874 35.4574 11.874ZM41.7105 10.124C41.7105 10.3947 41.6078 10.6327 41.4025 10.838C41.2065 11.034 40.9731 11.132 40.7025 11.132C40.4318 11.132 40.1938 11.034 39.9885 10.838C39.7925 10.6327 39.6945 10.3947 39.6945 10.124C39.6945 9.85333 39.7925 9.62 39.9885 9.424C40.1938 9.21867 40.4318 9.116 40.7025 9.116C40.9731 9.116 41.2065 9.21867 41.4025 9.424C41.6078 9.62 41.7105 9.85333 41.7105 10.124ZM41.5705 12V19H39.8065V12H41.5705ZM49.094 14.324V19H47.33V14.646C47.33 14.282 47.218 13.9927 46.994 13.778C46.7794 13.5633 46.4854 13.456 46.112 13.456C45.7387 13.456 45.4307 13.568 45.188 13.792C44.9454 14.0067 44.824 14.2867 44.824 14.632V19H43.046V12H44.768V12.882C44.9454 12.5833 45.2067 12.3407 45.552 12.154C45.9067 11.9673 46.294 11.874 46.714 11.874C47.4514 11.874 48.03 12.0933 48.45 12.532C48.8794 12.9707 49.094 13.568 49.094 14.324ZM57.4122 15.514C57.4122 15.5887 57.4076 15.668 57.3982 15.752C57.3889 15.8267 57.3796 15.8967 57.3702 15.962H52.0082C52.0642 16.4567 52.2556 16.8533 52.5822 17.152C52.9182 17.4413 53.3289 17.586 53.8142 17.586C54.1689 17.586 54.4862 17.5067 54.7662 17.348C55.0556 17.1893 55.2889 16.9653 55.4662 16.676H57.2722C57.0576 17.4227 56.6376 18.0153 56.0122 18.454C55.3869 18.8927 54.6402 19.112 53.7722 19.112C52.7176 19.112 51.8542 18.776 51.1822 18.104C50.5102 17.432 50.1742 16.5687 50.1742 15.514C50.1742 14.4687 50.5196 13.6007 51.2102 12.91C51.9009 12.2193 52.7689 11.874 53.8142 11.874C54.8596 11.874 55.7182 12.2193 56.3902 12.91C57.0716 13.5913 57.4122 14.4593 57.4122 15.514ZM53.7862 13.414C53.3382 13.414 52.9509 13.5447 52.6242 13.806C52.3069 14.0673 52.1062 14.422 52.0222 14.87H55.5222C55.4662 14.4313 55.2749 14.0813 54.9482 13.82C54.6309 13.5493 54.2436 13.414 53.7862 13.414ZM61.3656 11.874C62.2616 11.874 62.9896 12.07 63.5496 12.462C64.1189 12.854 64.4409 13.4047 64.5156 14.114H62.8496C62.7562 13.8247 62.5742 13.61 62.3036 13.47C62.0422 13.3207 61.6922 13.246 61.2536 13.246C60.8429 13.246 60.5162 13.3113 60.2736 13.442C60.0402 13.5633 59.9236 13.736 59.9236 13.96C59.9236 14.156 60.0262 14.31 60.2316 14.422C60.4462 14.534 60.9176 14.632 61.6456 14.716C62.2149 14.7907 62.6349 14.8607 62.9056 14.926C63.1856 14.9913 63.4236 15.0707 63.6196 15.164C63.9742 15.3227 64.2356 15.5373 64.4036 15.808C64.5716 16.0693 64.6556 16.3913 64.6556 16.774C64.6556 17.4833 64.3476 18.0527 63.7316 18.482C63.1249 18.902 62.3269 19.112 61.3376 19.112C60.3669 19.112 59.5969 18.916 59.0276 18.524C58.4582 18.132 58.1316 17.5627 58.0476 16.816H59.7696C59.8816 17.1427 60.0682 17.3807 60.3296 17.53C60.5909 17.6793 60.9549 17.754 61.4216 17.754C61.8789 17.754 62.2382 17.684 62.4996 17.544C62.7702 17.404 62.9056 17.208 62.9056 16.956C62.9056 16.7507 62.7936 16.5873 62.5696 16.466C62.3549 16.3447 61.8742 16.242 61.1276 16.158C60.5676 16.0833 60.1476 16.018 59.8676 15.962C59.5969 15.8967 59.3636 15.8173 59.1676 15.724C58.8222 15.5653 58.5656 15.3553 58.3976 15.094C58.2296 14.8327 58.1456 14.5153 58.1456 14.142C58.1456 13.4513 58.4349 12.9007 59.0136 12.49C59.5922 12.0793 60.3762 11.874 61.3656 11.874ZM68.5707 11.874C69.4667 11.874 70.1947 12.07 70.7547 12.462C71.324 12.854 71.646 13.4047 71.7207 14.114H70.0547C69.9613 13.8247 69.7793 13.61 69.5087 13.47C69.2473 13.3207 68.8973 13.246 68.4587 13.246C68.048 13.246 67.7213 13.3113 67.4787 13.442C67.2453 13.5633 67.1287 13.736 67.1287 13.96C67.1287 14.156 67.2313 14.31 67.4367 14.422C67.6513 14.534 68.1227 14.632 68.8507 14.716C69.42 14.7907 69.84 14.8607 70.1107 14.926C70.3907 14.9913 70.6287 15.0707 70.8247 15.164C71.1793 15.3227 71.4407 15.5373 71.6087 15.808C71.7767 16.0693 71.8607 16.3913 71.8607 16.774C71.8607 17.4833 71.5527 18.0527 70.9367 18.482C70.33 18.902 69.532 19.112 68.5427 19.112C67.572 19.112 66.802 18.916 66.2327 18.524C65.6633 18.132 65.3367 17.5627 65.2527 16.816H66.9747C67.0867 17.1427 67.2733 17.3807 67.5347 17.53C67.796 17.6793 68.16 17.754 68.6267 17.754C69.084 17.754 69.4433 17.684 69.7047 17.544C69.9753 17.404 70.1107 17.208 70.1107 16.956C70.1107 16.7507 69.9987 16.5873 69.7747 16.466C69.56 16.3447 69.0793 16.242 68.3327 16.158C67.7727 16.0833 67.3527 16.018 67.0727 15.962C66.802 15.8967 66.5687 15.8173 66.3727 15.724C66.0273 15.5653 65.7707 15.3553 65.6027 15.094C65.4347 14.8327 65.3507 14.5153 65.3507 14.142C65.3507 13.4513 65.64 12.9007 66.2187 12.49C66.7973 12.0793 67.5813 11.874 68.5707 11.874Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "1",
                y: "1",
                width: "87",
                height: "26",
                rx: "13",
                stroke: "white",
                strokeWidth: "2"
            })
        ]
    });
};
/* harmony default export */ var Icons_BusinessSmall = (BusinessSmall);

;// CONCATENATED MODULE: ./components/icons/Icons/Chat.tsx


const Chat = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10 17H4C2.3 17 1 18.3 1 20V23H13V20C13 18.3 11.7 17 10 17Z",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7 14C5.3 14 4 12.7 4 11V10C4 8.3 5.3 7 7 7C8.7 7 10 8.3 10 10V11C10 12.7 8.7 14 7 14Z",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13 1V11L17 8H23V1H13Z",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            })
        ]
    });
};
/* harmony default export */ var Icons_Chat = (Chat);

;// CONCATENATED MODULE: ./components/icons/Icons/CheckIn.tsx


const CheckIn = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8 11.5H15.5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13 9L15.5 11.5L13 14",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.5 5.5H15.5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.5 7.5V3.5C15.5 2.948 15.052 2.5 14.5 2.5H1.5C0.948 2.5 0.5 2.948 0.5 3.5V14.5C0.5 15.052 0.948 15.5 1.5 15.5H10.5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.5 0.5V2.5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.5 0.5V2.5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ var Icons_CheckIn = (CheckIn);

;// CONCATENATED MODULE: ./components/icons/Icons/CheckOut.tsx


const CheckOut = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8 11.5H0.5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3 9L0.5 11.5L3 14",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.5 5.5H0.5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.5 7.5V3.5C0.5 2.948 0.948 2.5 1.5 2.5H14.5C15.052 2.5 15.5 2.948 15.5 3.5V14.5C15.5 15.052 15.052 15.5 14.5 15.5H5.5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.5 0.5V2.5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.5 0.5V2.5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ var Icons_CheckOut = (CheckOut);

;// CONCATENATED MODULE: ./components/icons/Icons/Close.tsx


const Close = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "8",
                cy: "8",
                r: "8",
                fill: "#333333"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.375 5.375L10.625 10.625",
                stroke: "white",
                strokeMiterlimit: "10",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.375 10.625L10.625 5.375",
                stroke: "white",
                strokeMiterlimit: "10",
                strokeLinecap: "round"
            })
        ]
    });
};
/* harmony default export */ var Icons_Close = (Close);

;// CONCATENATED MODULE: ./components/icons/Icons/CreditCard.tsx


const CreditCard = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.5 10.5H6.5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.5 10.5H12.5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.5 6.5H0.5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.5 13.5H1.5C0.948 13.5 0.5 13.052 0.5 12.5V3.5C0.5 2.948 0.948 2.5 1.5 2.5H14.5C15.052 2.5 15.5 2.948 15.5 3.5V12.5C15.5 13.052 15.052 13.5 14.5 13.5Z",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ var Icons_CreditCard = (CreditCard);

;// CONCATENATED MODULE: ./components/icons/Icons/CreditCardBig.tsx


const CreditCardBig = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1 7.5H23",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1 11.5H23",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21 21.5H3C1.895 21.5 1 20.605 1 19.5V5.5C1 4.395 1.895 3.5 3 3.5H16H21C22.105 3.5 23 4.395 23 5.5V19.5C23 20.605 22.105 21.5 21 21.5Z",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5 16.5H10",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18 16.5H19",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            })
        ]
    });
};
/* harmony default export */ var Icons_CreditCardBig = (CreditCardBig);

;// CONCATENATED MODULE: ./components/icons/Icons/CreditCardFilled.tsx


const CreditCardFilled = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16 5V3C16 2.4 15.6 2 15 2H1C0.4 2 0 2.4 0 3V5H16Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0 7V13C0 13.6 0.4 14 1 14H15C15.6 14 16 13.6 16 13V7H0ZM6 11H2V10H6V11ZM14 11H12V10H14V11Z",
                fill: "black"
            })
        ]
    });
};
/* harmony default export */ var Icons_CreditCardFilled = (CreditCardFilled);

;// CONCATENATED MODULE: ./components/icons/Icons/Dollar.tsx


const Dollar = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.5 23.5C18.5751 23.5 23.5 18.5751 23.5 12.5C23.5 6.42487 18.5751 1.5 12.5 1.5C6.42487 1.5 1.5 6.42487 1.5 12.5C1.5 18.5751 6.42487 23.5 12.5 23.5Z",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.5 5.5V19.5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.875 7.71876C14.254 6.82776 9.148 6.16276 9.148 9.23176C9.148 12.9058 15.632 11.6088 15.632 14.8508C15.632 18.0928 11.418 17.8488 8.5 16.7958",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            })
        ]
    });
};
/* harmony default export */ var Icons_Dollar = (Dollar);

;// CONCATENATED MODULE: ./components/icons/Icons/Dot.tsx


const Dot = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M8 0C3.589 0 0 3.589 0 8C0 12.411 3.589 16 8 16C12.411 16 16 12.411 16 8C16 3.589 12.411 0 8 0ZM13.91 9H8.677L6.929 4.628L5.071 5.372L6.523 9H2.09C2.035 8.674 2 8.341 2 8C2 4.691 4.691 2 8 2C11.309 2 14 4.691 14 8C14 8.341 13.965 8.674 13.91 9Z",
            fill: "black"
        })
    });
};
/* harmony default export */ var Icons_Dot = (Dot);

;// CONCATENATED MODULE: ./components/icons/Icons/Down.tsx


const Down = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M3 5L6 8L9 5",
            stroke: "black",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
/* harmony default export */ var Icons_Down = (Down);

// EXTERNAL MODULE: ./components/icons/Icons/Download.tsx
var Download = __webpack_require__(7763);
;// CONCATENATED MODULE: ./components/icons/Icons/External.tsx


const External = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10 1.99997L6 6",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6 2H10V6",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4 2H2V10H10V8",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ var Icons_External = (External);

;// CONCATENATED MODULE: ./components/icons/Icons/FacebookFilled.tsx


const FacebookFilled = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M9.14945 5.85957C9.14945 5.7349 9.16677 5.46565 9.2014 5.05355C9.23863 4.64058 9.39446 4.20856 9.6741 3.7549C9.95115 3.30297 10.4005 2.89693 11.0256 2.53764C11.648 2.18008 12.5476 2 13.7215 2H17.0288V5.60417H14.6072C14.3674 5.60417 14.144 5.69421 13.9423 5.87169C13.7423 6.04918 13.6393 6.218 13.6393 6.3747V8.61703H17.0279C16.9924 9.05597 16.9534 9.48279 16.9084 9.8949L16.7742 10.984C16.7206 11.352 16.666 11.6931 16.6123 12.0074H13.6151V22H9.14945V12.0065H6.97119V8.61703H9.14945V5.85957Z",
            fill: "#141414"
        })
    });
};
/* harmony default export */ var Icons_FacebookFilled = (FacebookFilled);

;// CONCATENATED MODULE: ./components/icons/Icons/FChat.tsx


const FChat = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.5 0.5H1.5C0.948 0.5 0.5 0.948 0.5 1.5V11.5C0.5 12.052 0.948 12.5 1.5 12.5H5.5L8 15.5L10.5 12.5H14.5C15.052 12.5 15.5 12.052 15.5 11.5V1.5C15.5 0.948 15.052 0.5 14.5 0.5Z",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.5 4.5H12.5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.5 8.5H12.5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ var Icons_FChat = (FChat);

;// CONCATENATED MODULE: ./components/icons/Icons/Filter.tsx


const Filter = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M16.5 2.25H1.5L7.5 9.345V14.25L10.5 15.75V9.345L16.5 2.25Z",
            stroke: "black",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
/* harmony default export */ var Icons_Filter = (Filter);

;// CONCATENATED MODULE: ./components/icons/Icons/FlashFilled.tsx


const FlashFilled = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M14.9999 6.00016H8.39994L9.99994 1.30016C10.2999 0.300164 9.09995 -0.499837 8.29994 0.300164L0.299945 8.30016C-0.300055 8.90016 0.0999443 10.0002 0.999945 10.0002H7.59994L5.99994 14.7002C5.69994 15.7002 6.89994 16.5002 7.69994 15.7002L15.6999 7.70016C16.2999 7.10016 15.8999 6.00016 14.9999 6.00016Z",
                    fill: "black"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Icons_FlashFilled = (FlashFilled);

;// CONCATENATED MODULE: ./components/icons/Icons/HomeFilled.tsx


const HomeFilled = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M10.9996 16.0002H12.9996C13.5996 16.0002 13.9996 15.6002 13.9996 15.0002V8.0002H14.9996C15.2996 8.0002 15.5996 7.9002 15.7996 7.7002C16.1996 7.3002 16.0996 6.7002 15.6996 6.3002L8.69956 0.300195C8.29956 0.000195384 7.79956 0.000195384 7.39956 0.300195L0.399562 6.3002C-0.000438601 6.7002 -0.100438 7.3002 0.299562 7.7002C0.399562 7.9002 0.699562 8.0002 0.999562 8.0002C1.19956 8.0002 1.99956 8.0002 1.99956 8.0002V15.0002C1.99956 15.6002 2.39956 16.0002 2.99956 16.0002H4.99956C5.59956 16.0002 5.99956 15.6002 5.99956 15.0002V12.0002H9.99956V15.0002C9.99956 15.6002 10.3996 16.0002 10.9996 16.0002Z",
                    fill: "black"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Icons_HomeFilled = (HomeFilled);

;// CONCATENATED MODULE: ./components/icons/Icons/Info.tsx


const Info = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8 15.5C12.1421 15.5 15.5 12.1421 15.5 8C15.5 3.85786 12.1421 0.5 8 0.5C3.85786 0.5 0.5 3.85786 0.5 8C0.5 12.1421 3.85786 15.5 8 15.5Z",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9 8C9 7.44772 8.55228 7 8 7C7.44772 7 7 7.44772 7 8V11C7 11.5523 7.44772 12 8 12C8.55228 12 9 11.5523 9 11V8Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9 5C9 4.44772 8.55228 4 8 4C7.44772 4 7 4.44772 7 5C7 5.55228 7.44772 6 8 6C8.55228 6 9 5.55228 9 5Z",
                fill: "black"
            })
        ]
    });
};
/* harmony default export */ var Icons_Info = (Info);

;// CONCATENATED MODULE: ./components/icons/Icons/InfoBig.tsx


const InfoBig = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 23.25C18.2132 23.25 23.25 18.2132 23.25 12C23.25 5.7868 18.2132 0.75 12 0.75C5.7868 0.75 0.75 5.7868 0.75 12C0.75 18.2132 5.7868 23.25 12 23.25Z",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13 11C13 10.4477 12.5523 10 12 10C11.4477 10 11 10.4477 11 11V17C11 17.5523 11.4477 18 12 18C12.5523 18 13 17.5523 13 17V11Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13 7C13 6.44772 12.5523 6 12 6C11.4477 6 11 6.44772 11 7C11 7.55228 11.4477 8 12 8C12.5523 8 13 7.55228 13 7Z",
                fill: "black"
            })
        ]
    });
};
/* harmony default export */ var Icons_InfoBig = (InfoBig);

;// CONCATENATED MODULE: ./components/icons/Icons/Instagram.tsx


const Instagram = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M23.9763 7.05607C23.9201 5.78085 23.7139 4.90416 23.4185 4.14449C23.1137 3.33812 22.6449 2.61617 22.0306 2.01602C21.4305 1.40652 20.7038 0.932921 19.9067 0.632936C19.1427 0.337529 18.2706 0.131312 16.9954 0.0750879C15.7106 0.0141019 15.3028 0 12.0443 0C8.78588 0 8.37802 0.0141019 7.09805 0.0703262C5.82284 0.126551 4.94614 0.332951 4.18666 0.628174C3.3801 0.932922 2.65816 1.40176 2.05801 2.01602C1.44852 2.61617 0.975096 3.34288 0.674927 4.13991C0.379521 4.90416 0.173304 5.77609 0.11708 7.0513C0.056094 8.33604 0.0419922 8.7439 0.0419922 12.0023C0.0419922 15.2608 0.056094 15.6686 0.112318 16.9486C0.168543 18.2238 0.374943 19.1005 0.670349 19.8602C0.975096 20.6666 1.44852 21.3885 2.05801 21.9887C2.65816 22.5982 3.38487 23.0718 4.18189 23.3718C4.94614 23.6672 5.81808 23.8734 7.09347 23.9296C8.37326 23.986 8.7813 23.9999 12.0397 23.9999C15.2982 23.9999 15.706 23.986 16.986 23.9296C18.2612 23.8734 19.1379 23.6672 19.8974 23.3718C21.5103 22.7482 22.7855 21.4729 23.4091 19.8602C23.7044 19.096 23.9108 18.2238 23.967 16.9486C24.0232 15.6686 24.0373 15.2608 24.0373 12.0023C24.0373 8.7439 24.0325 8.33604 23.9763 7.05607ZM21.8151 16.8549C21.7634 18.027 21.5666 18.6599 21.4025 19.0819C20.9992 20.1274 20.1694 20.9572 19.1238 21.3605C18.7019 21.5246 18.0643 21.7215 16.8968 21.7729C15.631 21.8293 15.2513 21.8433 12.0491 21.8433C8.84686 21.8433 8.46245 21.8293 7.20116 21.7729C6.02905 21.7215 5.39612 21.5246 4.97416 21.3605C4.45386 21.1682 3.98026 20.8634 3.59584 20.4649C3.19733 20.0758 2.89258 19.6069 2.70028 19.0866C2.53619 18.6647 2.33931 18.027 2.28785 16.8596C2.23144 15.5937 2.21752 15.2139 2.21752 12.0117C2.21752 8.80946 2.23144 8.42505 2.28785 7.16394C2.33931 5.99183 2.53619 5.3589 2.70028 4.93694C2.89258 4.41645 3.19733 3.94303 3.60061 3.55843C3.9896 3.15992 4.45844 2.85517 4.97892 2.66306C5.40088 2.49896 6.03858 2.30209 7.20592 2.25044C8.47179 2.19422 8.85162 2.18011 12.0537 2.18011C15.2606 2.18011 15.6403 2.19422 16.9016 2.25044C18.0737 2.30209 18.7066 2.49896 19.1286 2.66306C19.6489 2.85517 20.1225 3.15992 20.5069 3.55843C20.9054 3.94761 21.2102 4.41645 21.4025 4.93694C21.5666 5.3589 21.7634 5.99641 21.8151 7.16394C21.8713 8.42981 21.8854 8.80946 21.8854 12.0117C21.8854 15.2139 21.8713 15.589 21.8151 16.8549Z",
                        fill: "#141414"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M12.0447 5.83716C8.64098 5.83716 5.87939 8.59856 5.87939 12.0024C5.87939 15.4063 8.64098 18.1677 12.0447 18.1677C15.4485 18.1677 18.2099 15.4063 18.2099 12.0024C18.2099 8.59856 15.4485 5.83716 12.0447 5.83716ZM12.0447 16.0017C9.83653 16.0017 8.04541 14.2108 8.04541 12.0024C8.04541 9.79411 9.83653 8.00317 12.0447 8.00317C14.253 8.00317 16.0439 9.79411 16.0439 12.0024C16.0439 14.2108 14.253 16.0017 12.0447 16.0017Z",
                        fill: "#141414"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M19.893 5.59336C19.893 6.3882 19.2485 7.03267 18.4535 7.03267C17.6586 7.03267 17.0142 6.3882 17.0142 5.59336C17.0142 4.79835 17.6586 4.15405 18.4535 4.15405C19.2485 4.15405 19.893 4.79835 19.893 5.59336Z",
                        fill: "#141414"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "24",
                        height: "24",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Icons_Instagram = (Instagram);

;// CONCATENATED MODULE: ./components/icons/Icons/Left.tsx


const Left = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M7 3L4 6L7 9",
            stroke: "black",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
/* harmony default export */ var Icons_Left = (Left);

;// CONCATENATED MODULE: ./components/icons/Icons/Like.tsx


const Like = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8 21.9999H18.229C18.6568 22 19.0734 21.8629 19.4175 21.6088C19.7616 21.3546 20.0152 20.9968 20.141 20.5879L22.91 11.5879C23.002 11.2889 23.0225 10.9725 22.97 10.6641C22.9175 10.3558 22.7934 10.064 22.6076 9.8123C22.4218 9.5606 22.1796 9.35599 21.9004 9.2149C21.6212 9.07381 21.3128 9.00018 21 8.99993H14V4.99993C14 2.62693 12.749 1.50593 11.236 1.13993C11.0884 1.10526 10.9348 1.10441 10.7868 1.13744C10.6389 1.17048 10.5002 1.23654 10.3814 1.33069C10.2625 1.42484 10.1665 1.54464 10.1004 1.68113C10.0344 1.81763 10.0001 1.96729 10 2.11893V5.99993L5 11.9999",
                stroke: "black",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5 10H1V22H5V10Z",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            })
        ]
    });
};
/* harmony default export */ var Icons_Like = (Like);

;// CONCATENATED MODULE: ./components/icons/Icons/LinkedInFilled.tsx


const LinkedInFilled = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M2.67055 3.07418C3.11772 2.65328 3.70143 2.44263 4.42183 2.44263C5.14227 2.44263 5.71973 2.6531 6.15359 3.07418C6.58748 3.49517 6.80899 4.02671 6.81766 4.66917C6.82628 5.30287 6.60714 5.83236 6.16015 6.25759C5.71317 6.68305 5.12498 6.89562 4.39574 6.89562H4.3697C3.65792 6.89562 3.08493 6.68287 2.65103 6.25759C2.21699 5.83236 2 5.30268 2 4.66917C2 4.02667 2.22342 3.49517 2.67055 3.07418ZM20.6458 9.83223C19.7432 8.84696 18.5494 8.35423 17.0651 8.35423C16.5183 8.35423 16.0212 8.4215 15.574 8.55613C15.127 8.69067 14.7495 8.87943 14.4413 9.12251C14.1332 9.36559 13.8878 9.59125 13.7057 9.79949C13.5325 9.99728 13.3631 10.2277 13.1978 10.4883V8.6535H8.91379L8.92692 9.27858C8.93572 9.69537 8.94006 10.98 8.94006 13.1327C8.94006 15.2855 8.93139 18.0936 8.91397 21.5571H13.1978V14.3565C13.1978 13.9139 13.2453 13.5624 13.341 13.3018C13.5234 12.8588 13.7987 12.488 14.1679 12.1887C14.5369 11.8889 14.9947 11.7392 15.5417 11.7392C16.288 11.7392 16.8373 11.9974 17.1889 12.5139C17.5404 13.0304 17.7162 13.7444 17.7162 14.6559V21.5567H22V14.1614C21.9997 12.2602 21.5486 10.8172 20.6458 9.83223ZM6.54414 8.65359H2.24731V21.557H6.54414V8.65359Z",
            fill: "#141414"
        })
    });
};
/* harmony default export */ var Icons_LinkedInFilled = (LinkedInFilled);

;// CONCATENATED MODULE: ./components/icons/Icons/LogoAfterPay.tsx


const LogoAfterPay = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "30",
        height: "30",
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "30",
                height: "30",
                rx: "15",
                fill: "#B2FCE4"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21.9558 10.9361L17.2124 8.27495C15.8201 7.49382 14.0796 8.46994 14.0796 10.0333V10.3063C14.0796 10.553 14.2153 10.7812 14.4348 10.9039L15.3304 11.4063C15.5935 11.5543 15.9215 11.3696 15.9215 11.0749V10.3958C15.9215 10.0563 16.2991 9.84409 16.6012 10.0138L20.7097 12.3194C21.0118 12.4891 21.0118 12.9135 20.7097 13.0822L16.6012 15.3877C16.2991 15.5575 15.9215 15.3453 15.9215 15.0057V14.6444C15.9215 13.081 14.1811 12.1037 12.7876 12.886L8.04425 15.5471C6.65192 16.3283 6.65192 18.2828 8.04425 19.0639L12.7876 21.7251C14.1799 22.5062 15.9215 21.5301 15.9215 19.9667V19.6937C15.9215 19.447 15.7858 19.2199 15.5664 19.0961L14.6708 18.5925C14.4077 18.4445 14.0796 18.6292 14.0796 18.924V19.603C14.0796 19.9426 13.7021 20.1548 13.4 19.985L9.29144 17.6795C8.98938 17.5097 8.98938 17.0853 9.29144 16.9155L13.4 14.61C13.7021 14.4402 14.0796 14.6524 14.0796 14.992V15.3533C14.0796 16.9167 15.8201 17.894 17.2124 17.1117L21.9558 14.4506C23.3481 13.6717 23.3481 11.7172 21.9558 10.9361Z",
                fill: "black"
            })
        ]
    });
};
/* harmony default export */ var Icons_LogoAfterPay = (LogoAfterPay);

;// CONCATENATED MODULE: ./components/icons/Icons/LogoAfterPayBusiness.tsx


const LogoAfterPayBusiness = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "218",
        height: "28",
        viewBox: "0 0 218 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.95859 13.7444C9.95859 11.5873 8.43108 10.0712 6.55474 10.0712C4.6784 10.0712 3.15087 11.6129 3.15087 13.7444C3.15087 15.8503 4.6784 17.4175 6.55474 17.4175C8.43299 17.4155 9.95859 15.9015 9.95859 13.7444ZM9.98543 20.1645V18.4951C9.05972 19.6513 7.68169 20.369 6.03151 20.369C2.60273 20.369 0 17.5433 0 13.7444C0 9.969 2.70239 7.0942 6.10817 7.0942C7.71044 7.0942 9.06163 7.81389 9.98735 8.94257V7.32427H13.0654V20.1645H9.98543Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M28.0167 17.3133C26.9396 17.3133 26.6406 16.9023 26.6406 15.8248V10.1243H28.6185V7.32427H26.6406V4.19189H23.4859V7.32427H19.4227V6.54363C19.4227 5.46411 19.8233 5.05314 20.9253 5.05314H21.6172V2.56179H20.0993C17.4965 2.56179 16.2699 3.43484 16.2699 6.10513V7.3223H14.5182V10.1224H16.2699V20.1625H19.4246V10.1224H23.4878V16.4147C23.4878 19.0338 24.4633 20.1645 27.0162 20.1645H28.6434V17.3133H28.0167Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M39.3303 12.5882C39.1061 10.9187 37.7779 9.91787 36.2273 9.91787C34.6749 9.91787 33.3985 10.8932 33.0746 12.5882H39.3303ZM33.0477 14.5919C33.2739 16.4914 34.6002 17.5709 36.2772 17.5709C37.6035 17.5709 38.6307 16.9279 39.2306 15.9015H42.4601C41.7088 18.6229 39.3303 20.369 36.2024 20.369C32.4229 20.369 29.7704 17.6476 29.7704 13.7699C29.7704 9.89231 32.5743 7.09224 36.2791 7.09224C40.0088 7.09224 42.7112 9.91787 42.7112 13.7699C42.7112 14.0531 42.6862 14.3343 42.6364 14.5919H33.0477Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M62.7683 13.7444C62.7683 11.664 61.2408 10.0712 59.3644 10.0712C57.4881 10.0712 55.9606 11.6129 55.9606 13.7444C55.9606 15.8503 57.4881 17.4175 59.3644 17.4175C61.2408 17.4155 62.7683 15.8248 62.7683 13.7444ZM52.8557 7.32427H55.9337V8.99369C56.8594 7.81192 58.2355 7.0942 59.8876 7.0942C63.2666 7.0942 65.9192 9.9454 65.9192 13.7188C65.9192 17.4942 63.2168 20.371 59.8129 20.371C58.2356 20.371 56.9342 19.728 56.0334 18.6504V25.448H52.8557V7.32427Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M77.0143 13.7444C77.0143 11.5873 75.4887 10.0712 73.6104 10.0712C71.7341 10.0712 70.2066 11.6129 70.2066 13.7444C70.2066 15.8503 71.7341 17.4175 73.6104 17.4175C75.4887 17.4155 77.0143 15.9015 77.0143 13.7444ZM77.0411 20.1645V18.4951C76.1154 19.6513 74.7374 20.369 73.0872 20.369C69.6584 20.369 67.0557 17.5433 67.0557 13.7444C67.0557 9.969 69.7581 7.0942 73.1619 7.0942C74.7642 7.0942 76.1154 7.81389 77.0411 8.94257V7.32427H80.1191V20.1645H77.0411Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M47.3072 8.58273C47.3072 8.58273 48.091 7.0942 50.0096 7.0942C50.8299 7.0942 51.3608 7.38326 51.3608 7.38326V10.6592C51.3608 10.6592 50.2031 9.92574 49.1394 10.0732C48.0757 10.2207 47.403 11.2235 47.4068 12.5646V20.1665H44.2291V7.32624H47.3072V8.58273Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M94.4955 7.32426L86.7237 25.4067H83.4464L86.4976 18.4164L81.3381 7.32426H85.0525L88.0711 14.7354L91.1683 7.32426H94.4955Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M119.304 7.03325L111.599 2.47134C109.338 1.13226 106.511 2.80561 106.511 5.48574V5.95373C106.511 6.37649 106.731 6.76779 107.087 6.97819L108.542 7.83945C108.97 8.09311 109.502 7.77653 109.502 7.27118V6.1071C109.502 5.52507 110.116 5.16129 110.606 5.45231L117.28 9.40466C117.771 9.69568 117.771 10.4232 117.28 10.7123L110.606 14.6646C110.116 14.9556 109.502 14.5919 109.502 14.0098V13.3904C109.502 10.7103 106.675 9.03499 104.412 10.376L96.7072 14.9379C94.4457 16.277 94.4457 19.6277 96.7072 20.9668L104.412 25.5287C106.673 26.8677 109.502 25.1944 109.502 22.5143V22.0463C109.502 21.6235 109.282 21.2342 108.925 21.0218L107.471 20.1586C107.043 19.9049 106.511 20.2215 106.511 20.7269V21.8909C106.511 22.473 105.897 22.8367 105.407 22.5457L98.7331 18.5934C98.2424 18.3024 98.2424 17.5748 98.7331 17.2838L105.407 13.3314C105.897 13.0404 106.511 13.4042 106.511 13.9862V14.6056C106.511 17.2858 109.338 18.9611 111.599 17.62L119.304 13.0581C121.565 11.723 121.565 8.37233 119.304 7.03325Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M147.436 18.09V19H145.714V9.48H147.492V12.854C147.772 12.5367 148.094 12.294 148.458 12.126C148.831 11.958 149.228 11.874 149.648 11.874C150.6 11.874 151.398 12.2193 152.042 12.91C152.695 13.6007 153.022 14.4593 153.022 15.486C153.022 16.5033 152.691 17.362 152.028 18.062C151.375 18.762 150.567 19.112 149.606 19.112C149.167 19.112 148.761 19.028 148.388 18.86C148.015 18.6827 147.697 18.426 147.436 18.09ZM147.45 15.5C147.45 16.0693 147.632 16.5453 147.996 16.928C148.369 17.3107 148.822 17.502 149.354 17.502C149.886 17.502 150.334 17.3107 150.698 16.928C151.071 16.536 151.258 16.06 151.258 15.5C151.258 14.94 151.071 14.4687 150.698 14.086C150.334 13.694 149.886 13.498 149.354 13.498C148.822 13.498 148.369 13.6893 147.996 14.072C147.632 14.4547 147.45 14.9307 147.45 15.5ZM160.129 12V19H158.407V18.132C158.249 18.4213 157.992 18.6593 157.637 18.846C157.292 19.0233 156.905 19.112 156.475 19.112C155.729 19.112 155.141 18.8973 154.711 18.468C154.291 18.0387 154.081 17.446 154.081 16.69V12H155.859V16.41C155.859 16.774 155.967 17.0633 156.181 17.278C156.396 17.4833 156.69 17.586 157.063 17.586C157.437 17.586 157.745 17.4787 157.987 17.264C158.239 17.0493 158.365 16.774 158.365 16.438V12H160.129ZM164.457 11.874C165.353 11.874 166.081 12.07 166.641 12.462C167.211 12.854 167.533 13.4047 167.607 14.114H165.941C165.848 13.8247 165.666 13.61 165.395 13.47C165.134 13.3207 164.784 13.246 164.345 13.246C163.935 13.246 163.608 13.3113 163.365 13.442C163.132 13.5633 163.015 13.736 163.015 13.96C163.015 14.156 163.118 14.31 163.323 14.422C163.538 14.534 164.009 14.632 164.737 14.716C165.307 14.7907 165.727 14.8607 165.997 14.926C166.277 14.9913 166.515 15.0707 166.711 15.164C167.066 15.3227 167.327 15.5373 167.495 15.808C167.663 16.0693 167.747 16.3913 167.747 16.774C167.747 17.4833 167.439 18.0527 166.823 18.482C166.217 18.902 165.419 19.112 164.429 19.112C163.459 19.112 162.689 18.916 162.119 18.524C161.55 18.132 161.223 17.5627 161.139 16.816H162.861C162.973 17.1427 163.16 17.3807 163.421 17.53C163.683 17.6793 164.047 17.754 164.513 17.754C164.971 17.754 165.33 17.684 165.591 17.544C165.862 17.404 165.997 17.208 165.997 16.956C165.997 16.7507 165.885 16.5873 165.661 16.466C165.447 16.3447 164.966 16.242 164.219 16.158C163.659 16.0833 163.239 16.018 162.959 15.962C162.689 15.8967 162.455 15.8173 162.259 15.724C161.914 15.5653 161.657 15.3553 161.489 15.094C161.321 14.8327 161.237 14.5153 161.237 14.142C161.237 13.4513 161.527 12.9007 162.105 12.49C162.684 12.0793 163.468 11.874 164.457 11.874ZM170.71 10.124C170.71 10.3947 170.608 10.6327 170.402 10.838C170.206 11.034 169.973 11.132 169.702 11.132C169.432 11.132 169.194 11.034 168.988 10.838C168.792 10.6327 168.694 10.3947 168.694 10.124C168.694 9.85333 168.792 9.62 168.988 9.424C169.194 9.21867 169.432 9.116 169.702 9.116C169.973 9.116 170.206 9.21867 170.402 9.424C170.608 9.62 170.71 9.85333 170.71 10.124ZM170.57 12V19H168.806V12H170.57ZM178.094 14.324V19H176.33V14.646C176.33 14.282 176.218 13.9927 175.994 13.778C175.779 13.5633 175.485 13.456 175.112 13.456C174.739 13.456 174.431 13.568 174.188 13.792C173.945 14.0067 173.824 14.2867 173.824 14.632V19H172.046V12H173.768V12.882C173.945 12.5833 174.207 12.3407 174.552 12.154C174.907 11.9673 175.294 11.874 175.714 11.874C176.451 11.874 177.03 12.0933 177.45 12.532C177.879 12.9707 178.094 13.568 178.094 14.324ZM186.412 15.514C186.412 15.5887 186.408 15.668 186.398 15.752C186.389 15.8267 186.38 15.8967 186.37 15.962H181.008C181.064 16.4567 181.256 16.8533 181.582 17.152C181.918 17.4413 182.329 17.586 182.814 17.586C183.169 17.586 183.486 17.5067 183.766 17.348C184.056 17.1893 184.289 16.9653 184.466 16.676H186.272C186.058 17.4227 185.638 18.0153 185.012 18.454C184.387 18.8927 183.64 19.112 182.772 19.112C181.718 19.112 180.854 18.776 180.182 18.104C179.51 17.432 179.174 16.5687 179.174 15.514C179.174 14.4687 179.52 13.6007 180.21 12.91C180.901 12.2193 181.769 11.874 182.814 11.874C183.86 11.874 184.718 12.2193 185.39 12.91C186.072 13.5913 186.412 14.4593 186.412 15.514ZM182.786 13.414C182.338 13.414 181.951 13.5447 181.624 13.806C181.307 14.0673 181.106 14.422 181.022 14.87H184.522C184.466 14.4313 184.275 14.0813 183.948 13.82C183.631 13.5493 183.244 13.414 182.786 13.414ZM190.366 11.874C191.262 11.874 191.99 12.07 192.55 12.462C193.119 12.854 193.441 13.4047 193.516 14.114H191.85C191.756 13.8247 191.574 13.61 191.304 13.47C191.042 13.3207 190.692 13.246 190.254 13.246C189.843 13.246 189.516 13.3113 189.274 13.442C189.04 13.5633 188.924 13.736 188.924 13.96C188.924 14.156 189.026 14.31 189.232 14.422C189.446 14.534 189.918 14.632 190.646 14.716C191.215 14.7907 191.635 14.8607 191.906 14.926C192.186 14.9913 192.424 15.0707 192.62 15.164C192.974 15.3227 193.236 15.5373 193.404 15.808C193.572 16.0693 193.656 16.3913 193.656 16.774C193.656 17.4833 193.348 18.0527 192.732 18.482C192.125 18.902 191.327 19.112 190.338 19.112C189.367 19.112 188.597 18.916 188.028 18.524C187.458 18.132 187.132 17.5627 187.048 16.816H188.77C188.882 17.1427 189.068 17.3807 189.33 17.53C189.591 17.6793 189.955 17.754 190.422 17.754C190.879 17.754 191.238 17.684 191.5 17.544C191.77 17.404 191.906 17.208 191.906 16.956C191.906 16.7507 191.794 16.5873 191.57 16.466C191.355 16.3447 190.874 16.242 190.128 16.158C189.568 16.0833 189.148 16.018 188.868 15.962C188.597 15.8967 188.364 15.8173 188.168 15.724C187.822 15.5653 187.566 15.3553 187.398 15.094C187.23 14.8327 187.146 14.5153 187.146 14.142C187.146 13.4513 187.435 12.9007 188.014 12.49C188.592 12.0793 189.376 11.874 190.366 11.874ZM197.571 11.874C198.467 11.874 199.195 12.07 199.755 12.462C200.324 12.854 200.646 13.4047 200.721 14.114H199.055C198.961 13.8247 198.779 13.61 198.509 13.47C198.247 13.3207 197.897 13.246 197.459 13.246C197.048 13.246 196.721 13.3113 196.479 13.442C196.245 13.5633 196.129 13.736 196.129 13.96C196.129 14.156 196.231 14.31 196.437 14.422C196.651 14.534 197.123 14.632 197.851 14.716C198.42 14.7907 198.84 14.8607 199.111 14.926C199.391 14.9913 199.629 15.0707 199.825 15.164C200.179 15.3227 200.441 15.5373 200.609 15.808C200.777 16.0693 200.861 16.3913 200.861 16.774C200.861 17.4833 200.553 18.0527 199.937 18.482C199.33 18.902 198.532 19.112 197.543 19.112C196.572 19.112 195.802 18.916 195.233 18.524C194.663 18.132 194.337 17.5627 194.253 16.816H195.975C196.087 17.1427 196.273 17.3807 196.535 17.53C196.796 17.6793 197.16 17.754 197.627 17.754C198.084 17.754 198.443 17.684 198.705 17.544C198.975 17.404 199.111 17.208 199.111 16.956C199.111 16.7507 198.999 16.5873 198.775 16.466C198.56 16.3447 198.079 16.242 197.333 16.158C196.773 16.0833 196.353 16.018 196.073 15.962C195.802 15.8967 195.569 15.8173 195.373 15.724C195.027 15.5653 194.771 15.3553 194.603 15.094C194.435 14.8327 194.351 14.5153 194.351 14.142C194.351 13.4513 194.64 12.9007 195.219 12.49C195.797 12.0793 196.581 11.874 197.571 11.874Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "130",
                y: "1",
                width: "87",
                height: "26",
                rx: "13",
                stroke: "white",
                strokeWidth: "2"
            })
        ]
    });
};
/* harmony default export */ var Icons_LogoAfterPayBusiness = (LogoAfterPayBusiness);

;// CONCATENATED MODULE: ./components/icons/Icons/Menu.tsx


const Menu = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M1 0C0.447715 0 0 0.447715 0 1C0 1.55228 0.447715 2 1 2H15C15.5523 2 16 1.55228 16 1C16 0.447715 15.5523 0 15 0H1ZM0 8C0 7.44772 0.447715 7 1 7H15C15.5523 7 16 7.44772 16 8C16 8.55229 15.5523 9 15 9H1C0.447715 9 0 8.55229 0 8ZM0 15C0 14.4477 0.447715 14 1 14H15C15.5523 14 16 14.4477 16 15C16 15.5523 15.5523 16 15 16H1C0.447715 16 0 15.5523 0 15Z",
            fill: "black"
        })
    });
};
/* harmony default export */ var Icons_Menu = (Menu);

;// CONCATENATED MODULE: ./components/icons/Icons/MenuHeader.tsx


const MenuHeader = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M1 3C0.447715 3 0 3.44772 0 4C0 4.55228 0.447715 5 1 5L23 5C23.5523 5 24 4.55228 24 4C24 3.44772 23.5523 3 23 3L1 3ZM0 12C0 11.4477 0.447715 11 1 11L23 11C23.5523 11 24 11.4477 24 12C24 12.5523 23.5523 13 23 13L1 13C0.447715 13 0 12.5523 0 12ZM0 20C0 19.4477 0.447715 19 1 19H23C23.5523 19 24 19.4477 24 20C24 20.5523 23.5523 21 23 21L1 21C0.447715 21 0 20.5523 0 20Z",
            fill: "white"
        })
    });
};
/* harmony default export */ var Icons_MenuHeader = (MenuHeader);

;// CONCATENATED MODULE: ./components/icons/Icons/OpeningTime.tsx


const OpeningTime = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.5 5.5H15.5",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.5 5.5V3.5C15.5 3.23478 15.3946 2.98043 15.2071 2.79289C15.0196 2.60536 14.7652 2.5 14.5 2.5H1.5C1.23478 2.5 0.98043 2.60536 0.792893 2.79289C0.605357 2.98043 0.5 3.23478 0.5 3.5V14.5C0.5 14.7652 0.605357 15.0196 0.792893 15.2071C0.98043 15.3946 1.23478 15.5 1.5 15.5H6.5",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.5 0.5V2.5",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.5 0.5V2.5",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.5 15.5C13.7091 15.5 15.5 13.7091 15.5 11.5C15.5 9.29086 13.7091 7.5 11.5 7.5C9.29086 7.5 7.5 9.29086 7.5 11.5C7.5 13.7091 9.29086 15.5 11.5 15.5Z",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.5 9.5V11.5H13.5",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ var Icons_OpeningTime = (OpeningTime);

;// CONCATENATED MODULE: ./components/icons/Icons/PasswordHide.tsx


const PasswordHide = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.5 8C0.5 8 3.5 2.5 8 2.5C12.5 2.5 15.5 8 15.5 8C15.5 8 12.5 13.5 8 13.5C3.5 13.5 0.5 8 0.5 8Z",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5 8C5 6.343 6.343 5 8 5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11 8C11 9.657 9.657 11 8 11",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1 15L15 1",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ var Icons_PasswordHide = (PasswordHide);

;// CONCATENATED MODULE: ./components/icons/Icons/PasswordShow.tsx


const PasswordShow = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.5 8C0.5 8 3.5 2.5 8 2.5C12.5 2.5 15.5 8 15.5 8C15.5 8 12.5 13.5 8 13.5C3.5 13.5 0.5 8 0.5 8Z",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8 10.5C9.38071 10.5 10.5 9.38071 10.5 8C10.5 6.61929 9.38071 5.5 8 5.5C6.61929 5.5 5.5 6.61929 5.5 8C5.5 9.38071 6.61929 10.5 8 10.5Z",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ var Icons_PasswordShow = (PasswordShow);

;// CONCATENATED MODULE: ./components/icons/Icons/PeopleCircle.tsx


const PeopleCircle = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8 8.5C9.38071 8.5 10.5 7.38071 10.5 6C10.5 4.61929 9.38071 3.5 8 3.5C6.61929 3.5 5.5 4.61929 5.5 6C5.5 7.38071 6.61929 8.5 8 8.5Z",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.9529 13.6211C12.5057 12.6867 11.8033 11.8979 10.9269 11.3457C10.0505 10.7935 9.03575 10.5005 7.99988 10.5005C6.964 10.5005 5.94926 10.7935 5.07283 11.3457C4.19641 11.8979 3.49404 12.6867 3.04688 13.6211",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8 15.5C12.1421 15.5 15.5 12.1421 15.5 8C15.5 3.85786 12.1421 0.5 8 0.5C3.85786 0.5 0.5 3.85786 0.5 8C0.5 12.1421 3.85786 15.5 8 15.5Z",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ var Icons_PeopleCircle = (PeopleCircle);

;// CONCATENATED MODULE: ./components/icons/Icons/PeopleCircleFilled.tsx


const PeopleCircleFilled = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8 10C9.65685 10 11 8.65685 11 7C11 5.34315 9.65685 4 8 4C6.34315 4 5 5.34315 5 7C5 8.65685 6.34315 10 8 10Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM12 12.4C11.4 11.7 10.6 11 9 11H7C5.4 11 4.6 11.7 4 12.4C2.8 11.3 2 9.8 2 8C2 4.7 4.7 2 8 2C11.3 2 14 4.7 14 8C14 9.8 13.2 11.3 12 12.4Z",
                fill: "black"
            })
        ]
    });
};
/* harmony default export */ var Icons_PeopleCircleFilled = (PeopleCircleFilled);

;// CONCATENATED MODULE: ./components/icons/Icons/PeopleCircleOutline.tsx


const PeopleCircleOutline = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19.4996 20.9859V20.2409C19.4996 19.1639 18.9226 18.1699 17.9876 17.6359L14.7686 15.7939",
                stroke: "black",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.227 15.792L7.012 17.636C6.077 18.17 5.5 19.164 5.5 20.241V20.986",
                stroke: "black",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.5 16.5C10.291 16.5 8.5 14.709 8.5 12.5V10.5C8.5 8.291 10.291 6.5 12.5 6.5C14.709 6.5 16.5 8.291 16.5 10.5V12.5C16.5 14.709 14.709 16.5 12.5 16.5Z",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.5 23.5C18.5751 23.5 23.5 18.5751 23.5 12.5C23.5 6.42487 18.5751 1.5 12.5 1.5C6.42487 1.5 1.5 6.42487 1.5 12.5C1.5 18.5751 6.42487 23.5 12.5 23.5Z",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            })
        ]
    });
};
/* harmony default export */ var Icons_PeopleCircleOutline = (PeopleCircleOutline);

;// CONCATENATED MODULE: ./components/icons/Icons/PieChart.tsx


const PieChart = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7 2C3.1 2 0 5.1 0 9C0 12.9 3.1 16 7 16C10.9 16 14 12.9 14 9H7V2Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9 0V7H16C16 3.1 12.9 0 9 0Z",
                fill: "black"
            })
        ]
    });
};
/* harmony default export */ var Icons_PieChart = (PieChart);

;// CONCATENATED MODULE: ./components/icons/Icons/ReadBook.tsx


const ReadBook = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2 3H8C9.06087 3 10.0783 3.42143 10.8284 4.17157C11.5786 4.92172 12 5.93913 12 7V21C12 20.2044 11.6839 19.4413 11.1213 18.8787C10.5587 18.3161 9.79565 18 9 18H2V3Z",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22 3H16C14.9391 3 13.9217 3.42143 13.1716 4.17157C12.4214 4.92172 12 5.93913 12 7V21C12 20.2044 12.3161 19.4413 12.8787 18.8787C13.4413 18.3161 14.2044 18 15 18H22V3Z",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ var Icons_ReadBook = (ReadBook);

;// CONCATENATED MODULE: ./components/icons/Icons/ReceiptList.tsx


const ReceiptList = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.5 1.5H21.5V22.5L18.5 20.5L15.5 22.5L12.5 20.5L9.5 22.5L6.5 20.5L3.5 22.5V1.5Z",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.5 7.5H12.5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.5 7.5H17.5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.5 11.5H12.5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.5 11.5H17.5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.5 15.5H12.5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.5 15.5H17.5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            })
        ]
    });
};
/* harmony default export */ var Icons_ReceiptList = (ReceiptList);

;// CONCATENATED MODULE: ./components/icons/Icons/ReceiptListFilled.tsx


const ReceiptListFilled = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "17",
        height: "17",
        viewBox: "0 0 17 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M14.0017 0.00170278H2.0017C1.86829 -0.00631686 1.73469 0.0140548 1.60973 0.0614728C1.48477 0.108891 1.37129 0.182276 1.27678 0.276784C1.18228 0.371292 1.10889 0.484772 1.06147 0.609732C1.01405 0.734692 0.993685 0.868289 1.0017 1.0017V16.0017L4.0017 14.0017L6.0017 16.0017L8.0017 14.0017L10.0017 16.0017L12.0017 14.0017L15.0017 16.0017V1.0017C15.0097 0.868289 14.9894 0.734692 14.9419 0.609732C14.8945 0.484772 14.8211 0.371292 14.7266 0.276784C14.6321 0.182276 14.5186 0.108891 14.3937 0.0614728C14.2687 0.0140548 14.1351 -0.00631686 14.0017 0.00170278ZM8.0017 10.0017H4.0017V8.0017H8.0017V10.0017ZM8.0017 6.0017H4.0017V4.0017H8.0017V6.0017ZM11.0017 10.0017C10.8039 10.0017 10.6106 9.94305 10.4461 9.83317C10.2817 9.72329 10.1535 9.56711 10.0778 9.38439C10.0021 9.20166 9.98233 9.00059 10.0209 8.80661C10.0595 8.61263 10.1547 8.43445 10.2946 8.2946C10.4344 8.15474 10.6126 8.0595 10.8066 8.02092C11.0006 7.98233 11.2017 8.00214 11.3844 8.07782C11.5671 8.15351 11.7233 8.28168 11.8332 8.44613C11.9431 8.61058 12.0017 8.80392 12.0017 9.0017C12.0017 9.26692 11.8963 9.52127 11.7088 9.70881C11.5213 9.89635 11.2669 10.0017 11.0017 10.0017ZM11.0017 6.0017C10.8039 6.0017 10.6106 5.94305 10.4461 5.83317C10.2817 5.72329 10.1535 5.56711 10.0778 5.38439C10.0021 5.20166 9.98233 5.00059 10.0209 4.80661C10.0595 4.61263 10.1547 4.43445 10.2946 4.2946C10.4344 4.15474 10.6126 4.0595 10.8066 4.02092C11.0006 3.98233 11.2017 4.00214 11.3844 4.07782C11.5671 4.15351 11.7233 4.28168 11.8332 4.44613C11.9431 4.61058 12.0017 4.80392 12.0017 5.0017C12.0017 5.26692 11.8963 5.52127 11.7088 5.70881C11.5213 5.89635 11.2669 6.0017 11.0017 6.0017Z",
            fill: "black"
        })
    });
};
/* harmony default export */ var Icons_ReceiptListFilled = (ReceiptListFilled);

;// CONCATENATED MODULE: ./components/icons/Icons/Remove.tsx


const Remove = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19.5 5.5L5.5 19.5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19.5 19.5L5.5 5.5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            })
        ]
    });
};
/* harmony default export */ var Icons_Remove = (Remove);

;// CONCATENATED MODULE: ./components/icons/Icons/RemoveBold.tsx


const RemoveBold = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M5.63603 4.29289C5.24551 3.90237 4.61234 3.90237 4.22182 4.29289C3.83129 4.68342 3.83129 5.31658 4.22182 5.70711L11.5147 13L4.22187 20.2928C3.83135 20.6833 3.83135 21.3165 4.22187 21.707C4.61239 22.0976 5.24556 22.0976 5.63608 21.707L12.9289 14.4142L19.7782 21.2635C20.1687 21.654 20.8019 21.654 21.1924 21.2635C21.5829 20.8729 21.5829 20.2398 21.1924 19.8492L14.3431 13L21.1924 6.15069C21.583 5.76016 21.583 5.127 21.1924 4.73647C20.8019 4.34595 20.1687 4.34595 19.7782 4.73647L12.9289 11.5858L5.63603 4.29289Z",
            fill: "white"
        })
    });
};
/* harmony default export */ var Icons_RemoveBold = (RemoveBold);

;// CONCATENATED MODULE: ./components/icons/Icons/RemoveCircle.tsx


const RemoveCircle = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "8",
                cy: "8",
                r: "8",
                fill: "#333333"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.375 5.375L10.625 10.625",
                stroke: "white",
                strokeMiterlimit: "10",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.375 10.625L10.625 5.375",
                stroke: "white",
                strokeMiterlimit: "10",
                strokeLinecap: "round"
            })
        ]
    });
};
/* harmony default export */ var Icons_RemoveCircle = (RemoveCircle);

;// CONCATENATED MODULE: ./components/icons/Icons/Resource.tsx


const Resource = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.5 9.40002L7.5 4.21002",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21 16V8.00002C20.9996 7.6493 20.9071 7.30483 20.7315 7.00119C20.556 6.69754 20.3037 6.44539 20 6.27002L13 2.27002C12.696 2.09449 12.3511 2.00208 12 2.00208C11.6489 2.00208 11.304 2.09449 11 2.27002L4 6.27002C3.69626 6.44539 3.44398 6.69754 3.26846 7.00119C3.09294 7.30483 3.00036 7.6493 3 8.00002V16C3.00036 16.3508 3.09294 16.6952 3.26846 16.9989C3.44398 17.3025 3.69626 17.5547 4 17.73L11 21.73C11.304 21.9056 11.6489 21.998 12 21.998C12.3511 21.998 12.696 21.9056 13 21.73L20 17.73C20.3037 17.5547 20.556 17.3025 20.7315 16.9989C20.9071 16.6952 20.9996 16.3508 21 16Z",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.27002 6.96002L12 12.01L20.73 6.96002",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 22.08V12",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ var Icons_Resource = (Resource);

;// CONCATENATED MODULE: ./components/icons/Icons/Right.tsx


const Right = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M5 9L8 6L5 3",
            stroke: "black",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
/* harmony default export */ var Icons_Right = (Right);

;// CONCATENATED MODULE: ./components/icons/Icons/Schedule.tsx


const Schedule = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.5 16.5V18.5H19.5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.5 23.5C20.2614 23.5 22.5 21.2614 22.5 18.5C22.5 15.7386 20.2614 13.5 17.5 13.5C14.7386 13.5 12.5 15.7386 12.5 18.5C12.5 21.2614 14.7386 23.5 17.5 23.5Z",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.5 22.5H1.5V4.5H23.5V11.5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.5 1.5V4.5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.5 1.5V4.5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1.5 8.5H23.5",
                stroke: "black",
                strokeMiterlimit: "10"
            })
        ]
    });
};
/* harmony default export */ var Icons_Schedule = (Schedule);

;// CONCATENATED MODULE: ./components/icons/Icons/Search.tsx


const Search = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.5 13.5C10.8137 13.5 13.5 10.8137 13.5 7.5C13.5 4.18629 10.8137 1.5 7.5 1.5C4.18629 1.5 1.5 4.18629 1.5 7.5C1.5 10.8137 4.18629 13.5 7.5 13.5Z",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.5002 15.5002L11.7422 11.7422",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ var Icons_Search = (Search);

;// CONCATENATED MODULE: ./components/icons/Icons/SearchBig.tsx


const SearchBig = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22.5002 22.4998L16.1562 16.1558",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.5 18.5C14.9183 18.5 18.5 14.9183 18.5 10.5C18.5 6.08172 14.9183 2.5 10.5 2.5C6.08172 2.5 2.5 6.08172 2.5 10.5C2.5 14.9183 6.08172 18.5 10.5 18.5Z",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            })
        ]
    });
};
/* harmony default export */ var Icons_SearchBig = (SearchBig);

;// CONCATENATED MODULE: ./components/icons/Icons/SettingFilled.tsx


const SettingFilled = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M15.135 6.784C13.832 6.458 13.214 4.966 13.905 3.815C14.227 3.279 14.13 2.817 13.811 2.499L13.501 2.189C13.183 1.871 12.721 1.774 12.185 2.095C11.033 2.786 9.541 2.168 9.216 0.865C9.065 0.258 8.669 0 8.219 0H7.781C7.331 0 6.936 0.258 6.784 0.865C6.458 2.168 4.966 2.786 3.815 2.095C3.279 1.773 2.816 1.87 2.498 2.188L2.188 2.498C1.87 2.816 1.773 3.279 2.095 3.815C2.786 4.967 2.168 6.459 0.865 6.784C0.26 6.935 0 7.33 0 7.781V8.219C0 8.669 0.258 9.064 0.865 9.216C2.168 9.542 2.786 11.034 2.095 12.185C1.773 12.721 1.87 13.183 2.189 13.501L2.499 13.811C2.818 14.13 3.281 14.226 3.815 13.905C4.967 13.214 6.459 13.832 6.784 15.135C6.935 15.742 7.331 16 7.781 16H8.219C8.669 16 9.064 15.742 9.216 15.135C9.542 13.832 11.034 13.214 12.185 13.905C12.72 14.226 13.182 14.13 13.501 13.811L13.811 13.501C14.129 13.183 14.226 12.721 13.905 12.185C13.214 11.033 13.832 9.541 15.135 9.216C15.742 9.065 16 8.669 16 8.219V7.781C16 7.33 15.74 6.935 15.135 6.784ZM8 11C6.343 11 5 9.657 5 8C5 6.343 6.343 5 8 5C9.657 5 11 6.343 11 8C11 9.657 9.657 11 8 11Z",
            fill: "black"
        })
    });
};
/* harmony default export */ var Icons_SettingFilled = (SettingFilled);

;// CONCATENATED MODULE: ./components/icons/Icons/SettingOutline.tsx


const SettingOutline = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M23 12C23 10.895 22.105 10 21 10H19.738C19.549 9.268 19.261 8.578 18.886 7.942L19.778 7.05C20.559 6.269 20.559 5.003 19.778 4.222C18.997 3.441 17.731 3.441 16.95 4.222L16.058 5.114C15.422 4.739 14.732 4.451 14 4.262V3C14 1.896 13.105 1 12 1C10.895 1 10 1.895 10 3V4.262C9.268 4.451 8.578 4.739 7.942 5.114L7.05 4.222C6.269 3.441 5.003 3.441 4.222 4.222C3.441 5.003 3.441 6.269 4.222 7.05L5.114 7.942C4.739 8.578 4.451 9.268 4.262 10H3C1.896 10 1 10.895 1 12C1 13.105 1.895 14 3 14H4.262C4.451 14.732 4.739 15.422 5.114 16.058L4.222 16.95C3.441 17.731 3.441 18.997 4.222 19.778C5.003 20.559 6.269 20.559 7.05 19.778L7.942 18.886C8.577 19.261 9.268 19.549 10 19.738V21C10 22.104 10.895 23 12 23C13.105 23 14 22.105 14 21V19.738C14.732 19.549 15.422 19.261 16.058 18.886L16.95 19.778C17.731 20.559 18.997 20.559 19.778 19.778C20.559 18.997 20.559 17.731 19.778 16.95L18.886 16.058C19.261 15.423 19.549 14.732 19.738 14H21C22.104 14 23 13.105 23 12Z",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            })
        ]
    });
};
/* harmony default export */ var Icons_SettingOutline = (SettingOutline);

;// CONCATENATED MODULE: ./components/icons/Icons/Shop.tsx


const Shop = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.5 13.5V22.5H20.5V13.5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.50001 2.5L1.50001 7.5C1.4985 8.17436 1.72485 8.82946 2.14235 9.35905C2.55985 9.88864 3.14402 10.2617 3.8001 10.4176C4.45619 10.5735 5.14572 10.5033 5.75686 10.2182C6.36801 9.93311 6.86492 9.44992 7.16701 8.847C7.41349 9.34349 7.79369 9.76131 8.26479 10.0534C8.7359 10.3455 9.2792 10.5003 9.83351 10.5003C10.3878 10.5003 10.9311 10.3455 11.4022 10.0534C11.8733 9.76131 12.2535 9.34349 12.5 8.847C12.7465 9.34349 13.1267 9.76131 13.5978 10.0534C14.0689 10.3455 14.6122 10.5003 15.1665 10.5003C15.7208 10.5003 16.2641 10.3455 16.7352 10.0534C17.2063 9.76131 17.5865 9.34349 17.833 8.847C18.1351 9.44992 18.632 9.93311 19.2432 10.2182C19.8543 10.5033 20.5438 10.5735 21.1999 10.4176C21.856 10.2617 22.4402 9.88864 22.8577 9.35905C23.2752 8.82946 23.5015 8.17436 23.5 7.5L20.5 2.5H4.50001Z",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.5 22.5V16.5H14.5V22.5",
                stroke: "black",
                strokeMiterlimit: "10"
            })
        ]
    });
};
/* harmony default export */ var Icons_Shop = (Shop);

;// CONCATENATED MODULE: ./components/icons/Icons/ShoppingBag.tsx


const ShoppingBag = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22.5 23.5H2.5L4.5 7.5H20.5L22.5 23.5Z",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.5 10.5V5.5C8.50317 4.44011 8.92561 3.42453 9.67507 2.67507C10.4245 1.92561 11.4401 1.50317 12.5 1.5C13.5599 1.50317 14.5755 1.92561 15.3249 2.67507C16.0744 3.42453 16.4968 4.44011 16.5 5.5V10.5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ var Icons_ShoppingBag = (ShoppingBag);

;// CONCATENATED MODULE: ./components/icons/Icons/Subscribed.tsx


const Subscribed = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "24",
                cy: "24",
                r: "24",
                fill: "black"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M32.6036 16.5622L19.9918 29.1657L15.3964 24.5733C15.0184 24.2085 14.5122 24.0066 13.9867 24.0112C13.4612 24.0158 12.9586 24.2264 12.587 24.5977C12.2154 24.9691 12.0046 25.4714 12.0001 25.9965C11.9955 26.5216 12.1975 27.0275 12.5626 27.4053L18.5749 33.4136C18.9507 33.7891 19.4604 34 19.9918 34C20.5232 34 21.0329 33.7891 21.4087 33.4136L35.4374 19.3941C35.8025 19.0164 36.0045 18.5105 35.9999 17.9854C35.9954 17.4603 35.7846 16.9579 35.413 16.5866C35.0414 16.2153 34.5388 16.0046 34.0133 16.0001C33.4878 15.9955 32.9816 16.1974 32.6036 16.5622Z",
                fill: "white"
            })
        ]
    });
};
/* harmony default export */ var Icons_Subscribed = (Subscribed);

;// CONCATENATED MODULE: ./components/icons/Icons/Support.tsx


const Support = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19.7781 4.22217L15.5361 8.46417",
                stroke: "black",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19.7781 19.7779L15.5361 15.5359",
                stroke: "black",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.22168 19.7779L8.46368 15.5359",
                stroke: "black",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.22168 4.22217L8.46368 8.46417",
                stroke: "black",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19.7775 19.778C24.0732 15.4823 24.0732 8.51752 19.7775 4.22179C15.4817 -0.0739315 8.51704 -0.0739315 4.22131 4.22179C-0.07442 8.51752 -0.07442 15.4823 4.22131 19.778C8.51704 24.0737 15.4817 24.0737 19.7775 19.778Z",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.535 15.5354C17.4876 13.5828 17.4876 10.4171 15.535 8.46445C13.5824 6.51185 10.4166 6.51185 8.46396 8.46445C6.51136 10.4171 6.51136 13.5828 8.46396 15.5354C10.4166 17.488 13.5824 17.488 15.535 15.5354Z",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            })
        ]
    });
};
/* harmony default export */ var Icons_Support = (Support);

;// CONCATENATED MODULE: ./components/icons/Icons/Telegram.tsx


const Telegram = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M15.9683 1.68422C15.9557 1.62517 15.9276 1.57057 15.8868 1.52608C15.846 1.48158 15.794 1.44883 15.7363 1.43122C15.526 1.3893 15.3084 1.40484 15.1063 1.47622C15.1063 1.47622 1.08725 6.51422 0.286252 7.07222C0.114252 7.19322 0.056252 7.26222 0.027252 7.34422C-0.110748 7.74422 0.320252 7.91722 0.320252 7.91722L3.93325 9.09422C3.99426 9.10522 4.05701 9.10145 4.11625 9.08322C4.93825 8.56422 12.3863 3.86122 12.8163 3.70322C12.8843 3.68322 12.9343 3.70322 12.9163 3.75222C12.7443 4.35222 6.31025 10.0712 6.27525 10.1062C6.25818 10.1205 6.2448 10.1387 6.23627 10.1592C6.22774 10.1798 6.2243 10.2021 6.22625 10.2242L5.88925 13.7522C5.88925 13.7522 5.74725 14.8522 6.84525 13.7522C7.62425 12.9732 8.37225 12.3272 8.74525 12.0142C9.98725 12.8722 11.3243 13.8202 11.9013 14.3142C11.9979 14.4083 12.1125 14.4819 12.2383 14.5305C12.3641 14.5792 12.4985 14.6018 12.6333 14.5972C12.7992 14.5767 12.955 14.5062 13.0801 14.3952C13.2051 14.2841 13.2934 14.1376 13.3333 13.9752C13.3333 13.9752 15.8943 3.70022 15.9793 2.31722C15.9873 2.18222 16.0003 2.10022 16.0003 2.00022C16.0039 1.89392 15.9931 1.78762 15.9683 1.68422Z",
                    fill: "black"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Icons_Telegram = (Telegram);

;// CONCATENATED MODULE: ./components/icons/Icons/Trash.tsx


const Trash = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20 9V21C20 21.5304 19.7893 22.0391 19.4142 22.4142C19.0391 22.7893 18.5304 23 18 23H6C5.46957 23 4.96086 22.7893 4.58579 22.4142C4.21071 22.0391 4 21.5304 4 21V9",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1 5H23",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 12V18",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8 12V18",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16 12V18",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8 5V1H16V5",
                stroke: "black",
                strokeMiterlimit: "10"
            })
        ]
    });
};
/* harmony default export */ var Icons_Trash = (Trash);

;// CONCATENATED MODULE: ./components/icons/Icons/TwitterFilled.tsx


const TwitteFilled = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M24 4.5585C23.1075 4.95 22.1565 5.2095 21.165 5.3355C22.185 4.7265 22.9635 3.7695 23.3295 2.616C22.3785 3.183 21.3285 3.5835 20.2095 3.807C19.3065 2.8455 18.0195 2.25 16.6155 2.25C13.8915 2.25 11.6985 4.461 11.6985 7.1715C11.6985 7.5615 11.7315 7.9365 11.8125 8.2935C7.722 8.094 4.1025 6.1335 1.671 3.147C1.2465 3.8835 0.9975 4.7265 0.9975 5.634C0.9975 7.338 1.875 8.8485 3.183 9.723C2.3925 9.708 1.617 9.4785 0.96 9.117C0.96 9.132 0.96 9.1515 0.96 9.171C0.96 11.562 2.6655 13.548 4.902 14.0055C4.5015 14.115 4.065 14.1675 3.612 14.1675C3.297 14.1675 2.979 14.1495 2.6805 14.0835C3.318 16.032 5.127 17.4645 7.278 17.511C5.604 18.8205 3.4785 19.6095 1.1775 19.6095C0.774 19.6095 0.387 19.5915 0 19.542C2.1795 20.9475 4.7625 21.75 7.548 21.75C16.602 21.75 21.552 14.25 21.552 7.749C21.552 7.5315 21.5445 7.3215 21.534 7.113C22.5105 6.42 23.331 5.5545 24 4.5585Z",
                    fill: "#141414"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "24",
                        height: "24",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var TwitterFilled = (TwitteFilled);

;// CONCATENATED MODULE: ./components/icons/Icons/Up.tsx


const Up = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M3 7L6 4L9 7",
            stroke: "black",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
/* harmony default export */ var Icons_Up = (Up);

;// CONCATENATED MODULE: ./components/icons/Icons/WorldFilled.tsx


const WorldFilled = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM13.9 7H12C11.9 5.5 11.6 4.1 11.2 2.9C12.6 3.8 13.6 5.3 13.9 7ZM8 14C7.4 14 6.2 12.1 6 9H10C9.8 12.1 8.6 14 8 14ZM6 7C6.2 3.9 7.3 2 8 2C8.7 2 9.8 3.9 10 7H6ZM4.9 2.9C4.4 4.1 4.1 5.5 4 7H2.1C2.4 5.3 3.4 3.8 4.9 2.9ZM2.1 9H4C4.1 10.5 4.4 11.9 4.8 13.1C3.4 12.2 2.4 10.7 2.1 9ZM11.1 13.1C11.6 11.9 11.8 10.5 11.9 9H13.8C13.6 10.7 12.6 12.2 11.1 13.1Z",
            fill: "black"
        })
    });
};
/* harmony default export */ var Icons_WorldFilled = (WorldFilled);

;// CONCATENATED MODULE: ./components/icons/Icons/LogoClearpay.tsx

const LogoClearpay = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "121",
        height: "24",
        viewBox: "0 0 105 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("pattern", {
                    id: "logo-clearpay",
                    viewBox: "0 0 105 21",
                    width: "100%",
                    height: "100%",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M82.9458 4.64771L75.8063 19.8148H72.8483L75.5158 14.1487L71.3253 4.64771H74.3625L77.0564 11.0119L79.9967 4.64771H82.9458Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M55.7784 10.0328C55.7784 8.29216 54.5019 6.95041 52.9349 6.95041C51.3679 6.95041 50.0914 8.24683 50.0914 10.0328C50.0914 11.8006 51.3679 13.1152 52.9349 13.1152C54.5019 13.1152 55.7784 11.7734 55.7784 10.0328ZM47.4944 19.8148V4.64769H50.065V6.04383C50.8397 5.05565 51.9929 4.44824 53.3663 4.44824C56.1922 4.44824 58.4106 6.84162 58.4106 10.0056C58.4106 13.1696 56.1482 15.5811 53.3046 15.5811C51.9841 15.5811 50.9013 15.0462 50.1442 14.1396V19.8058H47.4944V19.8148Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M67.6896 10.0328C67.6896 8.2196 66.4131 6.95038 64.8461 6.95038C63.2791 6.95038 62.0026 8.2468 62.0026 10.0328C62.0026 11.8006 63.2791 13.1152 64.8461 13.1152C66.4131 13.1152 67.6896 11.8369 67.6896 10.0328ZM67.7072 15.4179V14.0217C66.9325 14.9918 65.7793 15.5901 64.4059 15.5901C61.536 15.5901 59.3616 13.2239 59.3616 10.0328C59.3616 6.86879 61.6241 4.45728 64.4676 4.45728C65.8057 4.45728 66.9325 5.06469 67.7072 6.00753V4.64766H70.2778V15.4179H67.7072Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M42.855 5.7003C42.855 5.7003 43.5065 4.44922 45.1175 4.44922C45.8042 4.44922 46.2444 4.694 46.2444 4.694V7.44094C46.2444 7.44094 45.276 6.82447 44.3868 6.95139C43.4977 7.07831 42.9343 7.91237 42.9343 9.03653V15.4189H40.2756V4.64867H42.8462V5.7003H42.855Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M102.912 4.04039L99.866 2.24535L96.776 0.423117C94.7336 -0.782639 92.1806 0.731354 92.1806 3.161V3.56896C92.1806 3.79561 92.2951 4.00412 92.4888 4.11291L93.9237 4.95604C94.3199 5.19175 94.8129 4.89258 94.8129 4.42115V3.45111C94.8129 2.97062 95.3147 2.67144 95.7196 2.90716L98.5367 4.57527L101.345 6.23432C101.75 6.47003 101.75 7.07744 101.345 7.31315L98.5367 8.9722L95.7196 10.6403C95.3147 10.876 94.8129 10.5769 94.8129 10.0964V9.61588C94.8129 7.18623 92.2599 5.66317 90.2175 6.87799L87.1275 8.70022L84.0815 10.4953C82.0303 11.7101 82.0303 14.7653 84.0815 15.9801L87.1275 17.7751L90.2175 19.5974C92.2599 20.8031 94.8129 19.2891 94.8129 16.8595V16.4515C94.8129 16.2249 94.6984 16.0164 94.5047 15.9076L93.0698 15.0644C92.6736 14.8287 92.1806 15.1279 92.1806 15.5993V16.5694C92.1806 17.0499 91.6789 17.349 91.2739 17.1133L88.4568 15.4452L85.6485 13.7862C85.2435 13.5504 85.2435 12.943 85.6485 12.7073L88.4568 11.0483L91.2739 9.38016C91.6789 9.14445 92.1806 9.44362 92.1806 9.92411V10.4046C92.1806 12.8342 94.7336 14.3573 96.776 13.1425L99.866 11.3203L102.912 9.52522C104.963 8.30133 104.963 5.25521 102.912 4.04039Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M10.7226 11.402C10.1592 13.877 8.09035 15.5813 5.41411 15.5813C2.3241 15.5813 0 13.188 0 10.024C0 6.86 2.35932 4.44849 5.45812 4.44849C8.07274 4.44849 10.1151 6.15286 10.705 8.58251H7.98471C7.50052 7.61246 6.54095 6.96879 5.47573 6.96879C3.92633 6.96879 2.63222 8.28334 2.63222 10.024C2.63222 11.7646 3.92633 13.0792 5.47573 13.0792C6.58496 13.0792 7.54454 12.4355 8.00231 11.402H10.7226Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M11.9462 15.4089V0.2146H14.5784V15.4089H11.9462Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M18.54 10.7401C18.7249 12.3357 19.8341 13.2332 21.2339 13.2332C22.3431 13.2332 23.197 12.6984 23.6988 11.8371H26.3927C25.7676 14.1217 23.778 15.5813 21.1634 15.5813C18.003 15.5813 15.7933 13.2967 15.7933 10.0511C15.7933 6.80557 18.135 4.45752 21.225 4.45752C24.3415 4.45752 26.5951 6.8237 26.5951 10.0511C26.5951 10.2869 26.5775 10.5226 26.5335 10.7401H18.54ZM23.7868 9.0539C23.602 7.65776 22.4927 6.81464 21.1986 6.81464C19.9045 6.81464 18.8393 7.63056 18.5664 9.0539H23.7868Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M35.9972 15.4091V14.0129C35.2225 14.983 34.0781 15.5813 32.696 15.5813C29.8348 15.5813 27.6604 13.2152 27.6604 10.024C27.6604 6.86 29.9141 4.44849 32.7576 4.44849C34.0957 4.44849 35.2225 5.04683 35.9972 5.99875V4.63887H38.5678V15.4H35.9972V15.4091ZM35.9708 10.024C35.9708 8.21987 34.6943 6.94159 33.1273 6.94159C31.5603 6.94159 30.2838 8.22894 30.2838 10.024C30.2838 11.7918 31.5603 13.1064 33.1273 13.1064C34.6943 13.1064 35.9708 11.8371 35.9708 10.024Z",
                            fill: "white"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                fill: "url(#logo-clearpay)",
                width: "100%",
                height: "100%"
            })
        ]
    });
};
/* harmony default export */ var Icons_LogoClearpay = (LogoClearpay);

;// CONCATENATED MODULE: ./components/icons/Icons/Triangle.tsx


const Triangle = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "41",
        height: "47",
        viewBox: "0 0 41 47",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M0.131655 0.537983L40.0226 23.569L0.131656 46.6001L0.131655 0.537983Z",
            fill: "white"
        })
    });
};
/* harmony default export */ var Icons_Triangle = (Triangle);

;// CONCATENATED MODULE: ./components/icons/Icons/Smartphone.tsx


const Smartphone = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "38",
        viewBox: "0 0 24 38",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M23.1006 34.7261L23.1006 2.89848C23.1006 1.84998 22.2506 1 21.2021 1L2.90278 1C1.85428 1 1.0043 1.84998 1.0043 2.89848L1.0043 34.7261C1.0043 35.7746 1.85428 36.6246 2.90278 36.6246H21.2021C22.2506 36.6246 23.1006 35.7746 23.1006 34.7261Z",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1 5.05859H23.0963",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1 34.3699H23.0963",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.019 3.25464H14.0775",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18.2529 14.9884L16.2462 13.852L14.2125 12.6841C13.9051 12.5077 13.5568 12.4152 13.2025 12.416C12.8481 12.4168 12.5002 12.5108 12.1936 12.6885C11.8871 12.8662 11.6326 13.1214 11.4559 13.4286C11.2791 13.7357 11.1863 14.0839 11.1866 14.4383V14.6998C11.1865 14.77 11.2047 14.839 11.2395 14.8999C11.2743 14.9608 11.3245 15.0116 11.385 15.047L12.332 15.5882C12.3913 15.6234 12.4588 15.6423 12.5278 15.6428C12.5967 15.6433 12.6646 15.6253 12.7243 15.5909C12.784 15.5564 12.8335 15.5067 12.8676 15.4468C12.9016 15.3868 12.9192 15.3189 12.9183 15.25V14.6141C12.9185 14.544 12.9372 14.4752 12.9723 14.4146C13.0074 14.3539 13.0579 14.3035 13.1185 14.2684C13.1792 14.2333 13.248 14.2147 13.3181 14.2144C13.3882 14.2142 13.4571 14.2322 13.518 14.2669L15.3759 15.3356L17.2293 16.3999C17.2902 16.4345 17.3409 16.4847 17.3762 16.5453C17.4114 16.6059 17.43 16.6747 17.43 16.7448C17.43 16.8149 17.4114 16.8838 17.3762 16.9444C17.3409 17.005 17.2902 17.0552 17.2293 17.0898L15.3759 18.154L13.518 19.2183C13.4576 19.2542 13.3888 19.2734 13.3186 19.2741C13.2483 19.2747 13.1792 19.2566 13.1182 19.2218C13.0572 19.1869 13.0066 19.1365 12.9714 19.0757C12.9363 19.0149 12.918 18.9458 12.9183 18.8755V18.5644C12.9186 18.21 12.8258 17.8618 12.649 17.5547C12.4723 17.2476 12.2178 16.9923 11.9113 16.8146C11.6047 16.6369 11.2568 16.5429 10.9024 16.5422C10.5481 16.5414 10.1998 16.6338 9.89242 16.8102L7.85866 17.9782L5.85196 19.1281C5.54383 19.3057 5.28793 19.5613 5.10999 19.8693C4.93206 20.1772 4.83838 20.5266 4.83838 20.8823C4.83838 21.2379 4.93206 21.5873 5.10999 21.8952C5.28793 22.2032 5.54383 22.4588 5.85196 22.6364L7.85866 23.7728L9.89242 24.9408C10.1998 25.1171 10.5481 25.2096 10.9024 25.2088C11.2568 25.208 11.6047 25.1141 11.9113 24.9364C12.2178 24.7586 12.4723 24.5034 12.649 24.1963C12.8258 23.8891 12.9186 23.5409 12.9183 23.1866V22.925C12.9189 22.8548 12.9009 22.7856 12.866 22.7246C12.8311 22.6636 12.7807 22.6129 12.7198 22.5778L11.7729 22.0367C11.7136 22.0014 11.6461 21.9825 11.5771 21.9821C11.5082 21.9816 11.4403 21.9995 11.3806 22.0339C11.3209 22.0684 11.2714 22.1182 11.2373 22.1781C11.2032 22.238 11.1857 22.3059 11.1866 22.3749V22.9972C11.1863 23.0673 11.1677 23.1361 11.1326 23.1967C11.0974 23.2574 11.047 23.3078 10.9864 23.3429C10.9257 23.378 10.8569 23.3966 10.7868 23.3969C10.7167 23.3972 10.6478 23.3791 10.5869 23.3444L8.72898 22.2757L6.8756 21.2114C6.81466 21.1768 6.76398 21.1266 6.72873 21.066C6.69348 21.0054 6.67491 20.9366 6.67491 20.8665C6.67491 20.7964 6.69348 20.7275 6.72873 20.6669C6.76398 20.6063 6.81466 20.5561 6.8756 20.5215L8.72898 19.4573L10.5869 18.393C10.6472 18.3571 10.7161 18.3379 10.7863 18.3372C10.8565 18.3366 10.9257 18.3547 10.9867 18.3895C11.0477 18.4244 11.0983 18.4748 11.1335 18.5356C11.1686 18.5964 11.1869 18.6655 11.1866 18.7358V19.0469C11.1863 19.4013 11.2791 19.7495 11.4559 20.0566C11.6326 20.3637 11.8871 20.619 12.1936 20.7967C12.5002 20.9744 12.8481 21.0684 13.2025 21.0691C13.5568 21.0699 13.9051 20.9775 14.2125 20.8011L16.2462 19.6331L18.2529 18.4832C18.5579 18.3047 18.8108 18.0495 18.9866 17.743C19.1624 17.4364 19.2549 17.0892 19.2549 16.7358C19.2549 16.3824 19.1624 16.0352 18.9866 15.7287C18.8108 15.4221 18.5579 15.1669 18.2529 14.9884Z",
                fill: "black"
            })
        ]
    });
};
/* harmony default export */ var Icons_Smartphone = (Smartphone);

;// CONCATENATED MODULE: ./components/icons/Icons/Monitor.tsx


const Monitor = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "37",
        height: "26",
        viewBox: "0 0 37 26",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16 24H21",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.76565 1H32.2343C32.7026 1 33.1517 1.1859 33.4829 1.51681C33.814 1.84771 34 2.29652 34 2.76449V23H3V2.76449C3 2.29652 3.18602 1.84771 3.51715 1.51681C3.84827 1.1859 4.29737 1 4.76565 1V1Z",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24.9575 8.61405L22.8696 7.45927L20.7535 6.27241C20.4337 6.09316 20.0713 5.99922 19.7026 6C19.3339 6.00079 18.9719 6.09628 18.653 6.27688C18.334 6.45748 18.0693 6.71685 17.8854 7.02895C17.7015 7.34105 17.6048 7.6949 17.6052 8.05499V8.32078C17.605 8.39208 17.624 8.46219 17.6602 8.5241C17.6964 8.58602 17.7487 8.63757 17.8116 8.67363L18.797 9.22352C18.8586 9.25938 18.9289 9.27853 19.0006 9.27902C19.0724 9.27951 19.1429 9.26131 19.2051 9.22629C19.2672 9.19128 19.3187 9.14072 19.3542 9.07983C19.3896 9.01893 19.4078 8.9499 19.4069 8.87984V8.23371C19.4072 8.16248 19.4266 8.09257 19.4632 8.03094C19.4997 7.96931 19.5522 7.9181 19.6153 7.88241C19.6784 7.84673 19.75 7.8278 19.8229 7.82753C19.8958 7.82726 19.9676 7.84564 20.0309 7.88086L21.964 8.96691L23.8924 10.0484C23.9558 10.0836 24.0086 10.1346 24.0453 10.1961C24.0819 10.2577 24.1013 10.3277 24.1013 10.3989C24.1013 10.4702 24.0819 10.5401 24.0453 10.6017C24.0086 10.6633 23.9558 10.7143 23.8924 10.7495L21.964 11.831L20.0309 12.9124C19.9681 12.9489 19.8965 12.9685 19.8234 12.9691C19.7504 12.9698 19.6784 12.9514 19.615 12.916C19.5515 12.8806 19.4988 12.8294 19.4622 12.7675C19.4257 12.7057 19.4066 12.6355 19.4069 12.5642V12.248C19.4073 11.8879 19.3107 11.534 19.1268 11.2219C18.9429 10.9098 18.6781 10.6505 18.3592 10.4699C18.0402 10.2892 17.6782 10.1938 17.3095 10.193C16.9408 10.1922 16.5784 10.2861 16.2586 10.4654L14.1425 11.6522L12.0546 12.8208C11.734 13.0013 11.4677 13.261 11.2826 13.574C11.0975 13.8869 11 14.2419 11 14.6034C11 14.9648 11.0975 15.3198 11.2826 15.6327C11.4677 15.9457 11.734 16.2055 12.0546 16.3859L14.1425 17.5407L16.2586 18.7276C16.5784 18.9068 16.9408 19.0008 17.3095 19C17.6782 18.9992 18.0402 18.9037 18.3592 18.7231C18.6781 18.5425 18.9429 18.2832 19.1268 17.9711C19.3107 17.659 19.4073 17.3051 19.4069 16.945V16.6792C19.4076 16.6078 19.3888 16.5375 19.3525 16.4755C19.3163 16.4135 19.2638 16.3621 19.2005 16.3264L18.2152 15.7765C18.1535 15.7406 18.0832 15.7215 18.0115 15.721C17.9397 15.7205 17.8692 15.7387 17.807 15.7737C17.7449 15.8087 17.6934 15.8593 17.658 15.9202C17.6225 15.9811 17.6043 16.0501 17.6052 16.1202V16.7525C17.6049 16.8238 17.5855 16.8937 17.549 16.9553C17.5124 17.0169 17.46 17.0682 17.3968 17.1038C17.3337 17.1395 17.2621 17.1584 17.1892 17.1587C17.1163 17.159 17.0446 17.1406 16.9812 17.1054L15.0481 16.0193L13.1197 14.9379C13.0563 14.9027 13.0035 14.8517 12.9669 14.7901C12.9302 14.7285 12.9109 14.6586 12.9109 14.5873C12.9109 14.5161 12.9302 14.4461 12.9669 14.3845C13.0035 14.323 13.0563 14.272 13.1197 14.2368L15.0481 13.1553L16.9812 12.0738C17.044 12.0373 17.1156 12.0178 17.1887 12.0171C17.2618 12.0165 17.3337 12.0348 17.3972 12.0702C17.4606 12.1057 17.5133 12.1569 17.5499 12.2187C17.5864 12.2805 17.6055 12.3507 17.6052 12.4221V12.7383C17.6048 13.0984 17.7015 13.4522 17.8854 13.7643C18.0693 14.0764 18.334 14.3358 18.653 14.5164C18.9719 14.697 19.3339 14.7925 19.7026 14.7933C20.0713 14.7941 20.4337 14.7001 20.7535 14.5209L22.8696 13.334L24.9575 12.1655C25.2748 11.9841 25.538 11.7247 25.7209 11.4132C25.9038 11.1017 26 10.7489 26 10.3898C26 10.0307 25.9038 9.67783 25.7209 9.36632C25.538 9.0548 25.2748 8.79545 24.9575 8.61405Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M35.1139 23H1.88608C1.39671 23 1 23.4477 1 24C1 24.5523 1.39671 25 1.88608 25H35.1139C35.6033 25 36 24.5523 36 24C36 23.4477 35.6033 23 35.1139 23Z",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ var Icons_Monitor = (Monitor);

;// CONCATENATED MODULE: ./components/icons/Icons/BookOpen.tsx


const BookOpen = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2 3H8C9.06087 3 10.0783 3.42143 10.8284 4.17157C11.5786 4.92172 12 5.93913 12 7V21C12 20.2044 11.6839 19.4413 11.1213 18.8787C10.5587 18.3161 9.79565 18 9 18H2V3Z",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22 3H16C14.9391 3 13.9217 3.42143 13.1716 4.17157C12.4214 4.92172 12 5.93913 12 7V21C12 20.2044 12.3161 19.4413 12.8787 18.8787C13.4413 18.3161 14.2044 18 15 18H22V3Z",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ var Icons_BookOpen = (BookOpen);

;// CONCATENATED MODULE: ./components/icons/Icons/Compass.tsx


const Compass = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.24 7.76001L14.12 14.12L7.76001 16.24L9.88001 9.88001L16.24 7.76001Z",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ var Icons_Compass = (Compass);

;// CONCATENATED MODULE: ./components/icons/Icons/PenTool.tsx


const PenTool = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "28",
        height: "29",
        viewBox: "0 0 28 29",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.9728 20.6484L6.2002 22.6667L8.13635 15.613L22.1637 1L27.0002 6.03951L12.9728 20.6484Z",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.1333 3.6001H1V27.8668H25.2667V15.7334",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ var Icons_PenTool = (PenTool);

;// CONCATENATED MODULE: ./components/icons/Icons/ThumbsUp.tsx


const ThumbsUp = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M7 22H4C3.46957 22 2.96086 21.7893 2.58579 21.4142C2.21071 21.0391 2 20.5304 2 20V13C2 12.4696 2.21071 11.9609 2.58579 11.5858C2.96086 11.2107 3.46957 11 4 11H7M14 9V5C14 4.20435 13.6839 3.44129 13.1213 2.87868C12.5587 2.31607 11.7956 2 11 2L7 11V22H18.28C18.7623 22.0055 19.2304 21.8364 19.5979 21.524C19.9654 21.2116 20.2077 20.7769 20.28 20.3L21.66 11.3C21.7035 11.0134 21.6842 10.7207 21.6033 10.4423C21.5225 10.1638 21.3821 9.90629 21.1919 9.68751C21.0016 9.46873 20.7661 9.29393 20.5016 9.17522C20.2371 9.0565 19.9499 8.99672 19.66 9H14Z",
            stroke: "black",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
/* harmony default export */ var Icons_ThumbsUp = (ThumbsUp);

;// CONCATENATED MODULE: ./components/icons/Icons/Users.tsx


const Users = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M23 20.9999V18.9999C22.9993 18.1136 22.7044 17.2527 22.1614 16.5522C21.6184 15.8517 20.8581 15.3515 20 15.1299",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16 3.12988C16.8604 3.35018 17.623 3.85058 18.1676 4.55219C18.7122 5.2538 19.0078 6.11671 19.0078 7.00488C19.0078 7.89305 18.7122 8.75596 18.1676 9.45757C17.623 10.1592 16.8604 10.6596 16 10.8799",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ var Icons_Users = (Users);

;// CONCATENATED MODULE: ./components/icons/Icons/Download2.tsx


const Download2 = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "25",
        height: "26",
        viewBox: "0 0 25 26",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 1L12 20",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19 13L12 20L5 13",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1 20V25H24V20",
                stroke: "black"
            })
        ]
    });
};
/* harmony default export */ var Icons_Download2 = (Download2);

;// CONCATENATED MODULE: ./components/icons/Icons/Copy.tsx


const Copy = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M7.5 2H2.5V8.5C2.5 8.775 2.275 9 2 9C1.725 9 1.5 8.775 1.5 8.5V2C1.5 1.45 1.95 1 2.5 1H7.5C7.775 1 8 1.225 8 1.5C8 1.775 7.775 2 7.5 2ZM10 4V10C10 10.55 9.55 11 9 11H4.5C3.95 11 3.5 10.55 3.5 10V4C3.5 3.45 3.95 3 4.5 3H9C9.55 3 10 3.45 10 4ZM9 4H4.5V10H9V4Z",
            fill: "black"
        })
    });
};
/* harmony default export */ var Icons_Copy = (Copy);

;// CONCATENATED MODULE: ./components/icons/Icons/AfterpayBadge.tsx


const AfterpayBadge = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "184",
        height: "64",
        viewBox: "0 0 184 64",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M151.982 64H32.0182C14.3337 64 0 49.6744 0 32C0 14.3256 14.3337 0 32.0182 0H151.982C169.666 0 184 14.3256 184 32C184.012 49.6628 169.666 64 151.982 64Z",
                fill: "#B2FCE4"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M156.833 24.3482L148.724 19.7087C146.025 18.1622 142.651 20.1041 142.651 23.2203V23.7436C142.651 24.0343 142.802 24.3017 143.058 24.4413L144.954 25.5227C145.478 25.825 146.129 25.4413 146.129 24.8366V23.5924C146.129 22.9762 146.793 22.5924 147.328 22.8948L151.051 25.0343L154.762 27.1622C155.297 27.4645 155.297 28.2436 154.762 28.5459L151.051 30.6738L147.328 32.8134C146.793 33.1157 146.129 32.732 146.129 32.1157V31.4994C146.129 28.3831 142.755 26.4296 140.056 27.9878L131.947 32.6273C129.236 34.1855 129.236 38.1041 131.947 39.6622L140.056 44.3017C142.755 45.8482 146.129 43.9064 146.129 40.7901V40.2668C146.129 39.9762 145.978 39.7087 145.722 39.5692L143.826 38.4878C143.302 38.1855 142.651 38.5692 142.651 39.1738V40.418C142.651 41.0343 141.988 41.418 141.452 41.1157L137.729 38.9762L134.018 36.8482C133.483 36.5459 133.483 35.7668 134.018 35.4645L137.729 33.3366L141.452 31.1971C141.988 30.8948 142.651 31.2785 142.651 31.8948V32.511C142.651 35.6273 146.025 37.5808 148.724 36.0227L156.833 31.3831C159.544 29.8134 159.544 25.9064 156.833 24.3482Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M130.423 25.1157L120.999 44.5692H117.09L120.615 37.3017L115.065 25.1157H119.079L122.639 33.2785L126.525 25.1157H130.423Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M36.1948 32.0227C36.1948 29.6971 34.5078 28.0692 32.4369 28.0692C30.3659 28.0692 28.6789 29.732 28.6789 32.0227C28.6789 34.2901 30.3659 35.9762 32.4369 35.9762C34.5078 35.9762 36.1948 34.3482 36.1948 32.0227ZM36.2297 38.9296V37.1389C35.2059 38.3831 33.6818 39.1506 31.8668 39.1506C28.0739 39.1506 25.2002 36.1157 25.2002 32.0227C25.2002 27.9645 28.1903 24.8715 31.9482 24.8715C33.7167 24.8715 35.2059 25.6506 36.2297 26.8599V25.1157H39.627V38.9296H36.2297Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M56.148 35.8599C54.9613 35.8599 54.6239 35.418 54.6239 34.2552V28.1273H56.8112V25.1157H54.6239V21.7436H51.1452V25.1157H46.6543V23.7436C46.6543 22.5808 47.0964 22.1389 48.318 22.1389H49.0859V19.4645H47.4105C44.5368 19.4645 43.1755 20.4064 43.1755 23.2785V25.1273H41.2442V28.1273H43.1755V38.9296H46.6543V28.1273H51.1452V34.8948C51.1452 37.7087 52.2272 38.9296 55.0427 38.9296H56.8345V35.8599H56.148Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M68.6435 30.7785C68.3992 28.9878 66.9332 27.9064 65.2113 27.9064C63.501 27.9064 62.0816 28.9529 61.7326 30.7785H68.6435ZM61.6977 32.9296C61.942 34.9762 63.408 36.1389 65.2695 36.1389C66.7354 36.1389 67.864 35.4529 68.5272 34.3482H72.099C71.2729 37.2785 68.6435 39.1506 65.1881 39.1506C61.0113 39.1506 58.0794 36.2203 58.0794 32.0459C58.0794 27.8715 61.1741 24.8599 65.2695 24.8599C69.3881 24.8599 72.3782 27.8948 72.3782 32.0459C72.3782 32.3482 72.3549 32.6506 72.2968 32.9296H61.6977Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M94.5303 32.0227C94.5303 29.7901 92.8433 28.0692 90.7724 28.0692C88.7014 28.0692 87.0144 29.732 87.0144 32.0227C87.0144 34.2901 88.7014 35.9762 90.7724 35.9762C92.8433 35.9762 94.5303 34.2669 94.5303 32.0227ZM83.5822 44.5692V25.1157H86.9795V26.9064C88.0034 25.6389 89.5275 24.8599 91.3425 24.8599C95.0771 24.8599 98.0091 27.9296 98.0091 31.9878C98.0091 36.0459 95.019 39.1389 91.261 39.1389C89.5159 39.1389 88.0848 38.4529 87.0842 37.2901V44.5575H83.5822V44.5692Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M110.26 32.0227C110.26 29.6971 108.573 28.0692 106.502 28.0692C104.431 28.0692 102.744 29.732 102.744 32.0227C102.744 34.2901 104.431 35.9762 106.502 35.9762C108.573 35.9762 110.26 34.3482 110.26 32.0227ZM110.295 38.9296V37.1389C109.271 38.3831 107.747 39.1506 105.932 39.1506C102.139 39.1506 99.2656 36.1157 99.2656 32.0227C99.2656 27.9645 102.256 24.8715 106.014 24.8715C107.782 24.8715 109.271 25.6506 110.295 26.8599V25.1157H113.692V38.9296H110.295Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M77.4508 26.4645C77.4508 26.4645 78.3118 24.8599 80.4409 24.8599C81.3484 24.8599 81.9301 25.1738 81.9301 25.1738V28.6971C81.9301 28.6971 80.6503 27.9064 79.4752 28.0692C78.3002 28.232 77.5555 29.3017 77.5555 30.7436V38.918H74.0419V25.1157H77.4392V26.4645H77.4508Z",
                fill: "black"
            })
        ]
    });
};
/* harmony default export */ var Icons_AfterpayBadge = (AfterpayBadge);

;// CONCATENATED MODULE: ./components/icons/Icons/LogoAfterpayBlack.tsx

const LogoAfterpayBlack = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "29",
        height: "24",
        viewBox: "0 0 29 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M26.9845 4.82595L22.9479 2.69404L18.8568 0.502904C18.2386 0.171994 17.5379 -0.00143998 16.8251 9.00535e-06C16.1123 0.00145799 15.4124 0.177739 14.7957 0.511159C14.179 0.844579 13.6672 1.32341 13.3117 1.89959C12.9561 2.47578 12.7693 3.12904 12.7701 3.79383V4.28451C12.7697 4.41616 12.8064 4.54558 12.8764 4.65988C12.9465 4.77419 13.0474 4.86937 13.1692 4.93593L15.0741 5.95112C15.1933 6.01731 15.3292 6.05268 15.4679 6.05358C15.6066 6.05448 15.743 6.02088 15.8632 5.95624C15.9833 5.8916 16.0828 5.79826 16.1514 5.68583C16.22 5.57341 16.2552 5.44596 16.2534 5.31662V4.12377C16.2539 3.99227 16.2914 3.86321 16.3621 3.74943C16.4328 3.63565 16.5342 3.54111 16.6562 3.47522C16.7782 3.40934 16.9166 3.37441 17.0576 3.3739C17.1986 3.3734 17.3373 3.40734 17.4598 3.47235L21.1971 5.47737L24.9254 7.47392C25.048 7.53892 25.1499 7.63305 25.2208 7.74673C25.2917 7.86041 25.3291 7.98959 25.3291 8.12111C25.3291 8.25262 25.2917 8.3818 25.2208 8.49548C25.1499 8.60916 25.048 8.70329 24.9254 8.76829L21.1971 10.7648L17.4598 12.7614C17.3384 12.8288 17.2 12.8649 17.0587 12.8661C16.9174 12.8672 16.7783 12.8334 16.6556 12.768C16.5329 12.7026 16.431 12.608 16.3603 12.4939C16.2897 12.3798 16.2528 12.2502 16.2534 12.1184V11.5347C16.2541 10.8699 16.0673 10.2166 15.7117 9.64047C15.3562 9.06428 14.8444 8.58545 14.2277 8.25203C13.611 7.91861 12.9112 7.74233 12.1984 7.74088C11.4856 7.73943 10.7849 7.91287 10.1666 8.24378L6.07556 10.4349L2.0389 12.5922C1.41908 12.9254 0.904301 13.405 0.546374 13.9827C0.188448 14.5604 0 15.2159 0 15.8831C0 16.5504 0.188448 17.2058 0.546374 17.7835C0.904301 18.3612 1.41908 18.8408 2.0389 19.1741L6.07556 21.306L10.1666 23.4971C10.7849 23.828 11.4856 24.0014 12.1984 24C12.9112 23.9985 13.611 23.8223 14.2277 23.4888C14.8444 23.1554 15.3562 22.6766 15.7117 22.1004C16.0673 21.5242 16.2541 20.871 16.2534 20.2062V19.7155C16.2546 19.5837 16.2184 19.4539 16.1482 19.3395C16.0781 19.225 15.9766 19.13 15.8542 19.0641L13.9493 18.0489C13.8301 17.9827 13.6942 17.9473 13.5555 17.9464C13.4168 17.9455 13.2804 17.9791 13.1603 18.0438C13.0401 18.1084 12.9406 18.2017 12.8721 18.3142C12.8035 18.4266 12.7683 18.554 12.7701 18.6834V19.8509C12.7695 19.9823 12.732 20.1114 12.6613 20.2252C12.5906 20.339 12.4893 20.4335 12.3672 20.4994C12.2452 20.5653 12.1068 20.6002 11.9658 20.6007C11.8248 20.6012 11.6862 20.5673 11.5636 20.5023L7.82629 18.4973L4.09805 16.5007C3.97546 16.4357 3.87352 16.3416 3.8026 16.2279C3.73169 16.1142 3.69433 15.985 3.69433 15.8535C3.69433 15.722 3.73169 15.5928 3.8026 15.4791C3.87352 15.3655 3.97546 15.2713 4.09805 15.2063L7.82629 13.2098L11.5636 11.2132C11.685 11.1458 11.8235 11.1097 11.9648 11.1085C12.1061 11.1074 12.2452 11.1412 12.3679 11.2066C12.4905 11.272 12.5924 11.3666 12.6631 11.4807C12.7337 11.5948 12.7707 11.7244 12.7701 11.8562V12.4399C12.7693 13.1047 12.9561 13.758 13.3117 14.3342C13.6672 14.9103 14.179 15.3892 14.7957 15.7226C15.4124 16.056 16.1123 16.2323 16.8251 16.2337C17.5379 16.2352 18.2386 16.0618 18.8568 15.7308L22.9479 13.5397L26.9845 11.3824C27.598 11.0475 28.1068 10.5687 28.4604 9.99363C28.814 9.41852 29 8.76713 29 8.10419C29 7.44124 28.814 6.78985 28.4604 6.21474C28.1068 5.63963 27.598 5.16084 26.9845 4.82595Z",
            fill: "black"
        })
    });
};
/* harmony default export */ var Icons_LogoAfterpayBlack = (LogoAfterpayBlack);

;// CONCATENATED MODULE: ./components/icons/Icons/Check.tsx


const Check = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "27",
        height: "18",
        viewBox: "0 0 27 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M1 8.70163L9.52579 17L26 1",
            stroke: "black",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
/* harmony default export */ var Icons_Check = (Check);

;// CONCATENATED MODULE: ./components/icons/Icons/Email.tsx


const Email = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "28",
        height: "20",
        viewBox: "0 0 28 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1 1H27V17.5563C27 17.9392 26.844 18.3064 26.5663 18.5772C26.2885 18.8479 25.9119 19 25.5191 19H2.48087C2.08812 19 1.71145 18.8479 1.43374 18.5772C1.15602 18.3064 1 17.9392 1 17.5563V1Z",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1 1.04899L13.9755 14L27 1",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ var Icons_Email = (Email);

;// CONCATENATED MODULE: ./components/icons/Icons/Store.tsx


const Store = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "33",
        height: "26",
        viewBox: "0 0 33 26",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16 9H8V25H16V9Z",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25 9H19V15H25V9Z",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M28 25V1L4 1V25H28Z",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1 25H32",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1 5H32",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ var Icons_Store = (Store);

;// CONCATENATED MODULE: ./components/icons/Icons/Monitor2.tsx


const Monitor2 = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20 3H4C2.89543 3 2 3.89543 2 5V15C2 16.1046 2.89543 17 4 17H20C21.1046 17 22 16.1046 22 15V5C22 3.89543 21.1046 3 20 3Z",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8 21H16",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 17V21",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ var Icons_Monitor2 = (Monitor2);

;// CONCATENATED MODULE: ./components/icons/index.tsx






















































































var IconType;
(function(IconType) {
    IconType["ArrowBack"] = "Arrow-Back";
    IconType["ArrowDown"] = "Arrow-Down";
    IconType["ArrowRightBig"] = "Arrow-Right-Big";
    IconType["ArrowRightMedium"] = "Arrow-Right-Medium";
    IconType["ArrowRightOutLine"] = "Arrow-Right-Outline";
    IconType["ArrowRightSmall"] = "Arrow-Right-Small";
    IconType["ArrowUpBig"] = "Arrow-Up-Big";
    IconType["Barcode"] = "Barcode";
    IconType["Chat"] = "Chat";
    IconType["CheckIn"] = "Check-In";
    IconType["CheckOut"] = "Check-Out";
    IconType["Close"] = "Close";
    IconType["CreditCard"] = "Credit-Card";
    IconType["CreditCardBig"] = "Credit-Card-Big";
    IconType["CreditCardFilled"] = "Credit-Card-Filled";
    IconType["Dollar"] = "Dollar";
    IconType["Dot"] = "Dot";
    IconType["Down"] = "Down";
    IconType["Download"] = "Download";
    IconType["External"] = "External";
    IconType["FacebookFilled"] = "Facebook-Filled";
    IconType["FChat"] = "F-Chat";
    IconType["FlashFilled"] = "Flash-Filled";
    IconType["HomeFilled"] = "Home-Filled";
    IconType["Info"] = "Info";
    IconType["InfoBig"] = "Info-Big";
    IconType["Instagram"] = "Instagram";
    IconType["Left"] = "Left";
    IconType["Like"] = "Like";
    IconType["LinkedInFilled"] = "LinkedIn-Filled";
    IconType["Menu"] = "Menu";
    IconType["OpeningTime"] = "Opening-Time";
    IconType["PasswordHide"] = "Password-Hide";
    IconType["PasswordShow"] = "Password-Show";
    IconType["PeopleCircle"] = "People-Circle";
    IconType["PeopleCircleFilled"] = "People-Circle-Filled";
    IconType["PeopleCircleOutline"] = "People-Circle-Outline";
    IconType["PieChart"] = "Pie-Chart";
    IconType["ReceiptList"] = "Receipt-List";
    IconType["ReceiptListFilled"] = "Receipt-List-Filled";
    IconType["Remove"] = "Remove";
    IconType["Right"] = "Right";
    IconType["Schedule"] = "Schedule";
    IconType["Search"] = "Search";
    IconType["SearchBig"] = "Search-Big";
    IconType["SettingFilled"] = "Setting-Filled";
    IconType["SettingOutline"] = "Setting-Outline";
    IconType["Shop"] = "Shop";
    IconType["ShoppingBag"] = "Shopping-Bag";
    IconType["Support"] = "Support";
    IconType["Telegram"] = "Telegram";
    IconType["Trash"] = "Trash";
    IconType["TwitterFilled"] = "Twitter-Filled";
    IconType["Up"] = "Up";
    IconType["WorldFilled"] = "World-Filled";
    IconType["Subscribed"] = "Subscribed";
    IconType["Filter"] = "Filter";
    IconType["LogoAfterPay"] = "Logo-AfterPay";
    IconType["LogoAfterPayBusiness"] = "Logo-AfterPay-Business";
    IconType["MenuHeader"] = "Menu-Header";
    IconType["ReadBook"] = "Read-book";
    IconType["Resource"] = "Resource";
    IconType["RemoveCircle"] = "Remove-Circle";
    IconType["Business"] = "Business";
    IconType["AfterPay"] = "AfterPay";
    IconType["BusinessSmall"] = "Business-Small";
    IconType["RemoveBold"] = "Remove-Bold";
    IconType["LogoClearpay"] = "LogoClearpay";
    IconType["Triangle"] = "Triangle";
    IconType["Smartphone"] = "Smartphone";
    IconType["Monitor"] = "Monitor";
    IconType["Monitor2"] = "Monitor2";
    IconType["BookOpen"] = "BookOpen";
    IconType["Compass"] = "Compass";
    IconType["PenTool"] = "PenTool";
    IconType["ThumbsUp"] = "ThumbsUp";
    IconType["Users"] = "Users";
    IconType["Download2"] = "Download2";
    IconType["Copy"] = "Copy";
    IconType["AfterpayBadge"] = "AfterpayBadge";
    IconType["LogoAfterpayBlack"] = "LogoAfterpayBlack";
    IconType["Check"] = "Check";
    IconType["Email"] = "Email";
    IconType["Store"] = "Store";
    IconType["None"] = "None";
})(IconType || (IconType = {}));
const Icon = (param)=>{
    let { type  } = param;
    switch(type){
        case IconType.ArrowBack:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_ArrowBack, {});
        case IconType.ArrowDown:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_ArrowDown, {});
        case IconType.ArrowRightBig:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_ArrowRightBig, {});
        case IconType.ArrowRightMedium:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightMedium/* default */.Z, {});
        case IconType.ArrowRightOutLine:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_ArrowRightOutline, {});
        case IconType.ArrowRightSmall:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_ArrowRightSmall, {});
        case IconType.ArrowUpBig:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_ArrowUpBig, {});
        case IconType.Barcode:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Barcode, {});
        case IconType.Chat:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Chat, {});
        case IconType.CheckIn:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_CheckIn, {});
        case IconType.CheckOut:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_CheckOut, {});
        case IconType.Close:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Close, {});
        case IconType.CreditCard:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_CreditCard, {});
        case IconType.CreditCardBig:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_CreditCardBig, {});
        case IconType.CreditCardFilled:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_CreditCardFilled, {});
        case IconType.Dollar:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Dollar, {});
        case IconType.Dot:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Dot, {});
        case IconType.Down:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Down, {});
        case IconType.Download:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Download/* default */.Z, {});
        case IconType.External:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_External, {});
        case IconType.FacebookFilled:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_FacebookFilled, {});
        case IconType.FChat:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_FChat, {});
        case IconType.FlashFilled:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_FlashFilled, {});
        case IconType.HomeFilled:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_HomeFilled, {});
        case IconType.Info:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Info, {});
        case IconType.InfoBig:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_InfoBig, {});
        case IconType.Instagram:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Instagram, {});
        case IconType.Left:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Left, {});
        case IconType.Like:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Like, {});
        case IconType.LinkedInFilled:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_LinkedInFilled, {});
        case IconType.Menu:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Menu, {});
        case IconType.OpeningTime:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_OpeningTime, {});
        case IconType.PasswordHide:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_PasswordHide, {});
        case IconType.PasswordShow:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_PasswordShow, {});
        case IconType.PeopleCircle:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_PeopleCircle, {});
        case IconType.PeopleCircleFilled:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_PeopleCircleFilled, {});
        case IconType.PeopleCircleOutline:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_PeopleCircleOutline, {});
        case IconType.PieChart:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_PieChart, {});
        case IconType.ReceiptList:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_ReceiptList, {});
        case IconType.ReceiptListFilled:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_ReceiptListFilled, {});
        case IconType.Remove:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Remove, {});
        case IconType.Right:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Right, {});
        case IconType.Schedule:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Schedule, {});
        case IconType.Search:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Search, {});
        case IconType.SearchBig:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_SearchBig, {});
        case IconType.SettingFilled:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_SettingFilled, {});
        case IconType.SettingOutline:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_SettingOutline, {});
        case IconType.Shop:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Shop, {});
        case IconType.ShoppingBag:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_ShoppingBag, {});
        case IconType.Support:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Support, {});
        case IconType.Telegram:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Telegram, {});
        case IconType.Trash:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Trash, {});
        case IconType.TwitterFilled:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(TwitterFilled, {});
        case IconType.Up:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Up, {});
        case IconType.WorldFilled:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_WorldFilled, {});
        case IconType.Subscribed:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Subscribed, {});
        case IconType.Filter:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Filter, {});
        case IconType.LogoAfterPay:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_LogoAfterPay, {});
        case IconType.LogoAfterPayBusiness:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_LogoAfterPayBusiness, {});
        case IconType.MenuHeader:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_MenuHeader, {});
        case IconType.ReadBook:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_ReadBook, {});
        case IconType.Resource:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Resource, {});
        case IconType.RemoveCircle:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_RemoveCircle, {});
        case IconType.Business:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Business, {});
        case IconType.AfterPay:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_AfterPay, {});
        case IconType.BusinessSmall:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_BusinessSmall, {});
        case IconType.RemoveBold:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_RemoveBold, {});
        case IconType.LogoClearpay:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_LogoClearpay, {});
        case IconType.Triangle:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Triangle, {});
        case IconType.Smartphone:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Smartphone, {});
        case IconType.Monitor:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Monitor, {});
        case IconType.Monitor2:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Monitor2, {});
        case IconType.BookOpen:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_BookOpen, {});
        case IconType.Compass:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Compass, {});
        case IconType.PenTool:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_PenTool, {});
        case IconType.ThumbsUp:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_ThumbsUp, {});
        case IconType.Users:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Users, {});
        case IconType.Download2:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Download2, {});
        case IconType.Copy:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Copy, {});
        case IconType.AfterpayBadge:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_AfterpayBadge, {});
        case IconType.LogoAfterpayBlack:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_LogoAfterpayBlack, {});
        case IconType.Check:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Check, {});
        case IconType.Email:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Email, {});
        case IconType.Store:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Store, {});
        default:
            return null;
    }
};
/* harmony default export */ var icons = (Icon);


/***/ }),

/***/ 4670:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ default_layout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(315);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(2991);
// EXTERNAL MODULE: ./contexts/DefaultLayoutContext.tsx
var DefaultLayoutContext = __webpack_require__(1683);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(5407);
// EXTERNAL MODULE: ./helpers/LangHelper.ts
var LangHelper = __webpack_require__(7868);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(6779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/icons/index.tsx + 82 modules
var icons = __webpack_require__(3203);
// EXTERNAL MODULE: ./components/dropdown-selector/dropdown-selector.module.scss
var dropdown_selector_module = __webpack_require__(8099);
var dropdown_selector_module_default = /*#__PURE__*/__webpack_require__.n(dropdown_selector_module);
;// CONCATENATED MODULE: ./components/dropdown-selector/dropdown-selector.tsx





const Dropdown = (props)=>{
    const { defaultValue , dropdownData , onChange  } = props;
    const [isDropdownOpen, setOpen] = (0,react.useState)(false);
    const [selectedItem, setSelectedItem] = (0,react.useState)((defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.id) || dropdownData[0].id);
    if (!dropdownData) {
        return null;
    }
    const handleItemClick = (id)=>{
        selectedItem == id ? setSelectedItem(null) : setSelectedItem(id);
        setOpen(!isDropdownOpen);
        if (onChange) {
            const selectedItem1 = dropdownData.find((item)=>item.id === id);
            onChange(selectedItem1);
        }
    };
    const classDropdownWrapper = classnames_default()({
        "dropdown-warpper": true
    });
    const classDropdownHeader = classnames_default()({
        "dropdown-header": true,
        "dropdown-open": isDropdownOpen
    });
    const classDropdownBody = classnames_default()({
        "dropdown-body": true,
        "dropdown-open": isDropdownOpen
    });
    const classIconRight = classnames_default()({
        "icon-right": true,
        "icon-open": isDropdownOpen
    });
    const renderDefaultItem = (selectedItem)=>{
        if (selectedItem) {
            const defaultItem = dropdownData.find((item)=>item.id == selectedItem);
            return defaultItem === null || defaultItem === void 0 ? void 0 : defaultItem.label;
        } else return dropdownData[0].label;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (dropdown_selector_module_default()).dropdownSelector + " " + classDropdownWrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classDropdownHeader,
                onClick: ()=>setOpen(!isDropdownOpen),
                children: [
                    renderDefaultItem(selectedItem),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classIconRight,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                            type: icons/* IconType.Down */.T.Down
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classDropdownBody,
                onClick: ()=>setOpen(false),
                children: [
                    ...dropdownData || []
                ].map((item)=>{
                    if (item.id !== selectedItem) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "dropdown-item",
                            id: item.id.toString(),
                            onClick: (e)=>handleItemClick(e.target.id),
                            children: item.label
                        }, item.id);
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var dropdown_selector = (Dropdown);

// EXTERNAL MODULE: ./components/business-footer/business-footer.module.scss
var business_footer_module = __webpack_require__(9411);
var business_footer_module_default = /*#__PURE__*/__webpack_require__.n(business_footer_module);
;// CONCATENATED MODULE: ./helpers/NavHelper.ts
/* provided dependency */ var process = __webpack_require__(8584);
var NavItemLocations;
(function(NavItemLocations) {
    NavItemLocations["App"] = "App";
    NavItemLocations["AppChips"] = "App Chips";
    NavItemLocations["AllCategories"] = "All Categories";
    NavItemLocations["Retailers"] = "Retailers";
    NavItemLocations["WebTop"] = "Web top";
    NavItemLocations["Footer"] = "Footer";
    NavItemLocations["FooterRegional"] = "Regional Footer";
})(NavItemLocations || (NavItemLocations = {}));
let cachedFetchedFooterItems = {};
var _AP_STORE_ENDPOINT;
const STORE_API_PATH = (_AP_STORE_ENDPOINT = process.env.AP_STORE_ENDPOINT) !== null && _AP_STORE_ENDPOINT !== void 0 ? _AP_STORE_ENDPOINT : "https://store-directory-api-staging.afterpay.com/api/v1/navigations?locale=";
let storeFetchAPIPromise = {};
async function fetchGlobalNavItems(locale) {
    if (storeFetchAPIPromise[locale]) {
        return await storeFetchAPIPromise[locale];
    }
    if (cachedFetchedFooterItems[locale]) {
        return cachedFetchedFooterItems[locale];
    }
    storeFetchAPIPromise[locale] = (async ()=>{
        const response = await fetch(STORE_API_PATH + locale);
        // TODO: status checks
        const dataResponse = await response.json();
        const regionalFooterItems = {};
        const footerItems = {};
        let regionFooterID;
        let footerID;
        // we only care about Footer & Regional footer, so let's start by filtering the pool
        dataResponse.data.forEach((item)=>{
            if (item.attributes.name === NavItemLocations.Footer) {
                footerID = parseInt(item.id);
            } else if (item.attributes.name === NavItemLocations.FooterRegional) {
                regionFooterID = parseInt(item.id);
            }
        });
        const mappedNavItems = {};
        dataResponse.included.forEach((item)=>{
            if ([
                regionFooterID,
                footerID
            ].includes(item.attributes.navigation_id)) {
                mappedNavItems[item.id] = item;
            }
        });
        const placeNavItemInMatrix = function(item) {
            let isRegional = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            const matrix = isRegional ? regionalFooterItems : footerItems;
            if (matrix[item.attributes.column] === undefined) {
                matrix[item.attributes.column] = {};
            }
            let targetColumn;
            let targetRow;
            let isLead = false;
            if (item.attributes.parent_id) {
                const parentItem = mappedNavItems[item.attributes.parent_id];
                if (!matrix[parentItem.attributes.column][parentItem.attributes.row]) {
                    placeNavItemInMatrix(parentItem, isRegional);
                }
                targetColumn = parentItem.attributes.column;
                targetRow = item.attributes.row + 1;
            } else {
                targetColumn = item.attributes.column;
                targetRow = item.attributes.row;
                if (!isRegional) {
                    isLead = true;
                }
            }
            matrix[targetColumn][targetRow] = {
                name: item.attributes.title,
                id: item.id,
                link: item.attributes.link,
                children: [],
                isLead
            };
        };
        Object.values(mappedNavItems).forEach((item)=>{
            placeNavItemInMatrix(item, item.attributes.navigation_id == regionFooterID);
        });
        return [
            footerItems,
            regionalFooterItems
        ];
    })();
    const response = await storeFetchAPIPromise[locale];
    delete storeFetchAPIPromise[locale];
    cachedFetchedFooterItems[locale] = response;
    return response;
}

;// CONCATENATED MODULE: ./components/business-footer/business-footer.tsx








const renderSingleBlock = (footerCategoryItems)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        className: (business_footer_module_default()).footerBlock,
        children: footerCategoryItems.map((item, index)=>{
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                children: item.isLead ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (business_footer_module_default()).footerTitle,
                    children: item.title
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: item.url,
                    target: "_self",
                    children: item.title
                })
            }, "footer_item_".concat(index));
        })
    });
};
const BusinessFooter = (props)=>{
    var ref, ref1, ref2;
    const route = (0,next_router.useRouter)();
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    var _footerData;
    const [footerItems, setFooterItems] = (0,react.useState)((_footerData = props.footerData) !== null && _footerData !== void 0 ? _footerData : []);
    (0,react.useEffect)(()=>{
        if (!props.footerData) {
            let cancelled = false;
            fetchGlobalNavItems(locale).then((items)=>{
                if (!cancelled) {
                    setFooterItems(items);
                }
            });
            return ()=>{
                cancelled = true;
            };
        }
    }, []);
    const handleOnLocationChange = (location)=>{
        if (!location) return;
        const locale = location.id;
        const oldLocale = (0,LangHelper/* getLocaleFromRoute */._y)(route.asPath);
        let newUrl = route.asPath.replace(oldLocale, locale);
        if (newUrl.indexOf(locale) < 0) {
            newUrl = (0,LangHelper/* replaceOrAddLocale */.yM)(newUrl, locale);
        }
        var _urlRedirect;
        window.location.href = (_urlRedirect = location.urlRedirect) !== null && _urlRedirect !== void 0 ? _urlRedirect : newUrl;
    };
    const dropdownOptions = LangHelper/* LIVE_LOCALES.map */.Fw.map((thisLocale, index)=>{
        var ref;
        let origin = "";
        if (true) {
            var ref1;
            origin = ((ref1 = LangHelper/* LOCALE_LINKS */.kV[thisLocale]) === null || ref1 === void 0 ? void 0 : ref1.host) || "";
        }
        let urlRedirect = "".concat(origin, "/").concat(thisLocale, "/").concat((ref = LangHelper/* LOCALE_LINKS */.kV[thisLocale]) === null || ref === void 0 ? void 0 : ref.businessRoot, "/access");
        return {
            id: thisLocale,
            label: (0,LangHelper/* getLocalePrettyName */.FZ)(thisLocale),
            urlRedirect
        };
    });
    const getDefaultLocaleOption = ()=>dropdownOptions.find((option)=>option.id === locale);
    if (!footerItems || footerItems.length < 1) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (business_footer_module_default()).articleFooterContainer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (business_footer_module_default()).articleFooterInner,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (business_footer_module_default()).footerTop,
                    children: [
                        (ref = Object.values(footerItems[0])) === null || ref === void 0 ? void 0 : ref.map((item, index)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                children: renderSingleBlock(Object.values(item).map((item)=>({
                                        title: item.name,
                                        url: item.link,
                                        isLead: item.isLead
                                    })))
                            }, index);
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (business_footer_module_default()).footerLocation,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (business_footer_module_default()).footerTitle,
                                    children: "Location"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown_selector, {
                                    defaultValue: getDefaultLocaleOption(),
                                    dropdownData: dropdownOptions,
                                    onChange: handleOnLocationChange
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (business_footer_module_default()).footerBottom,
                    children: (ref1 = Object.values(footerItems[1])) === null || ref1 === void 0 ? void 0 : ref1.map((item, index)=>{
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                            children: renderSingleBlock(Object.values(item).map((item)=>({
                                    title: item.name,
                                    url: item.link,
                                    isLead: item.isLead
                                })))
                        }, index);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: (ref2 = LangHelper/* LOCALE_LINKS */.kV[locale]) === null || ref2 === void 0 ? void 0 : ref2.home,
                    target: "_self",
                    className: (business_footer_module_default()).logoAfterPay,
                    children: locale === LangHelper/* Locale.GreatBritain */.go.GreatBritain ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                        type: icons/* IconType.LogoClearpay */.T.LogoClearpay
                    }, Math.random()) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                        type: icons/* IconType.AfterPay */.T.AfterPay
                    }, Math.random())
                })
            ]
        })
    });
};
/* harmony default export */ var business_footer = (BusinessFooter);

;// CONCATENATED MODULE: ./hook/useOutsideClick.ts

function useOnClickOutside(ref, handler) {
    (0,react.useEffect)(()=>{
        const listener = (event)=>{
            const el = ref === null || ref === void 0 ? void 0 : ref.current;
            if (!el || el.contains(event.target)) {
                return;
            }
            handler(event);
        };
        document.addEventListener("mousedown", listener);
        document.addEventListener("touchstart", listener);
        document.addEventListener("click", listener);
        return ()=>{
            document.removeEventListener("mousedown", listener);
            document.removeEventListener("touchstart", listener);
            document.addEventListener("click", listener);
        };
    }, [
        ref,
        handler
    ]);
}
/* harmony default export */ var useOutsideClick = (useOnClickOutside);

// EXTERNAL MODULE: ./hook/useWindowSize.ts
var useWindowSize = __webpack_require__(8766);
// EXTERNAL MODULE: ./helpers/BuilderHelper.ts
var BuilderHelper = __webpack_require__(1198);
// EXTERNAL MODULE: ./components/auto-complete-form/business-header-autocomplete-list.module.scss
var business_header_autocomplete_list_module = __webpack_require__(2090);
var business_header_autocomplete_list_module_default = /*#__PURE__*/__webpack_require__.n(business_header_autocomplete_list_module);
;// CONCATENATED MODULE: ./components/auto-complete-form/business-header-autocomplete-list.tsx







let debounceTimeout;
const BusinessHeaderAutoCompleteList = (props)=>{
    const router = (0,next_router.useRouter)();
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    const { isShown , onClickButtonSearch  } = props;
    const [searchSuggestions, setSearchSuggestions] = (0,react.useState)();
    const [showSuggestions, setShowSuggestions] = (0,react.useState)(false);
    const [inputSearchValue, setInputValueSearch] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        let cancelled = false;
        if (inputSearchValue) {
            setShowSuggestions(true);
        }
        setSearchSuggestions(undefined);
        if (debounceTimeout) {
            clearTimeout(debounceTimeout);
            debounceTimeout = undefined;
        }
        debounceTimeout = setTimeout(()=>{
            if (!inputSearchValue) return;
            (0,BuilderHelper/* getQuickSearchResponses */.Af)(locale, inputSearchValue).then((suggestions)=>{
                if (!cancelled) {
                    setSearchSuggestions(suggestions);
                }
            });
        }, 400);
        return ()=>{
            if (debounceTimeout) {
                clearTimeout(debounceTimeout);
            }
            cancelled = true;
        };
    }, [
        inputSearchValue
    ]);
    const handleChangeInputSearch = (e)=>{
        setInputValueSearch(e.currentTarget.value);
    };
    const freeTextSearchTargetLink = (0,LangHelper/* localifyLink */.Bj)("/".concat(locale, "/business/resources/search/?q=").concat(encodeURIComponent(inputSearchValue)), locale);
    const renderSuggestionsListComponent = ()=>{
        if (!showSuggestions || !inputSearchValue) {
            return null;
        }
        const renderResultsFor = (name, items)=>{
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (business_header_autocomplete_list_module_default()).suggestionCategoryGroup,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (business_header_autocomplete_list_module_default()).suggestionCategoryTitle,
                        children: [
                            "Results for ",
                            name
                        ]
                    }),
                    items === undefined ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (business_header_autocomplete_list_module_default()).spinnerLoadMore
                    }) : !!items.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: (business_header_autocomplete_list_module_default()).suggestionCategoryList,
                        children: items.map((item)=>{
                            const searchMatch = new RegExp(inputSearchValue, "i");
                            const regexMatch = item.name.match(searchMatch);
                            const targetMatch = regexMatch ? regexMatch[0] : inputSearchValue;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    href: (0,LangHelper/* replaceOrAddLocale */.yM)(item.link, locale),
                                    target: "_self",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                                            type: icons/* IconType.Search */.T.Search
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (business_header_autocomplete_list_module_default()).suggestionCategoryListText,
                                            dangerouslySetInnerHTML: {
                                                __html: item.name.replace(targetMatch, '<span class="'.concat((business_header_autocomplete_list_module_default()).suggestionMatch, '">').concat(targetMatch, "</span>"))
                                            }
                                        })
                                    ]
                                })
                            }, item.id);
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (business_header_autocomplete_list_module_default()).suggestionCategoryNoneFound,
                        children: [
                            "No ",
                            name,
                            " found"
                        ]
                    })
                ]
            });
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (business_header_autocomplete_list_module_default()).suggestionsContainer,
            children: [
                renderResultsFor("Categories", searchSuggestions === null || searchSuggestions === void 0 ? void 0 : searchSuggestions.categories),
                renderResultsFor("Articles", searchSuggestions === null || searchSuggestions === void 0 ? void 0 : searchSuggestions.articles),
                renderResultsFor("Word", [
                    {
                        name: inputSearchValue,
                        link: freeTextSearchTargetLink,
                        id: ""
                    }
                ])
            ]
        });
    };
    const onKeyUp = (e)=>{
        if (e.code === "Enter" || e.code === "NumpadEnter") {
            router.push(freeTextSearchTargetLink);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (business_header_autocomplete_list_module_default()).formSearchBlog + " " + (isShown ? (business_header_autocomplete_list_module_default()).formShown : ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_header_autocomplete_list_module_default()).buttonSearch + " " + (business_header_autocomplete_list_module_default()).clicked,
                onClick: onClickButtonSearch,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                    type: icons/* IconType.Search */.T.Search
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                type: "text",
                placeholder: "eg: SEO",
                onChange: handleChangeInputSearch,
                value: inputSearchValue,
                className: (business_header_autocomplete_list_module_default()).inputSearch,
                onKeyUp: onKeyUp
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: (business_header_autocomplete_list_module_default()).clearInput + " " + (isShown ? (business_header_autocomplete_list_module_default()).formShown : ""),
                onClick: onClickButtonSearch,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                    type: icons/* IconType.RemoveCircle */.T.RemoveCircle
                })
            }),
            renderSuggestionsListComponent()
        ]
    });
};
/* harmony default export */ var business_header_autocomplete_list = (BusinessHeaderAutoCompleteList);

// EXTERNAL MODULE: ./components/dropdown-explore/dropdown-explore.module.scss
var dropdown_explore_module = __webpack_require__(9336);
var dropdown_explore_module_default = /*#__PURE__*/__webpack_require__.n(dropdown_explore_module);
;// CONCATENATED MODULE: ./components/dropdown-explore/dropdown-explore.tsx





const dummyResources = [
    {
        name: "Marketing Resources",
        description: "",
        resourceUrl: "/business/resources/marketing",
        locale: LangHelper/* ALL_LOCALES */.En
    },
    {
        name: "Training",
        description: "",
        resourceUrl: "/business/resources/training",
        locale: LangHelper/* ALL_LOCALES.filter */.En.filter((location)=>location !== LangHelper/* Locale.GreatBritain */.go.GreatBritain && location !== LangHelper/* Locale.USA */.go.USA)
    },
    {
        name: "Product Updates",
        description: "",
        resourceUrl: "/business/resources/product-updates",
        locale: LangHelper/* ALL_LOCALES */.En
    },
    {
        name: "Customer Service",
        description: "",
        resourceUrl: "/business/resources/customer-service",
        locale: LangHelper/* ALL_LOCALES.filter */.En.filter((location)=>[
                LangHelper/* Locale.USA */.go.USA,
                LangHelper/* Locale.GreatBritain */.go.GreatBritain
            ].includes(location))
    }
];
const GUIDE_ORDER = (/* unused pure expression or super */ null && ([
    "Meet Gen Z & Millennials",
    "Growing with Afterpay",
    "Social Media Tips",
    "Content Marketing",
    "SEO Tips"
]));
const DropdownExplore = (props)=>{
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    const [sortedGuides, setGuides] = (0,react.useState)([]);
    const { isToggle , categories , guides  } = props;
    (0,react.useEffect)(()=>{
        // You're welcome
        const dummyGuides = [
            {
                name: "Meet Gen Z & Millenials",
                guideUrl: "/business/access/meet-gen-z---millennials"
            },
            {
                name: "Growing with ".concat(locale === LangHelper/* Locale.GreatBritain */.go.GreatBritain ? "Clearpay" : "Afterpay"),
                guideUrl: "/business/access/growing-with-".concat(locale === LangHelper/* Locale.GreatBritain */.go.GreatBritain ? "clearpay" : "afterpay")
            },
            {
                name: "Social Media Tips",
                guideUrl: "/business/access/social-media-tips"
            },
            {
                name: "Content Marketing ",
                guideUrl: "/business/access/content-marketing"
            },
            {
                name: "SEO Tips",
                guideUrl: "/business/access/seo-tips"
            }
        ];
        setGuides(dummyGuides);
        return;
    }, [
        guides
    ]);
    if (!categories) {
        return null;
    }
    const accessHref = (0,LangHelper/* localifyLink */.Bj)("/".concat(locale, "/business/access"), locale);
    const guidePageHref = (0,LangHelper/* localifyLink */.Bj)("/".concat(locale, "/business/access/guides"), locale);
    //TODO make these business resource pages come from a generalized location.
    const renderCategories = ()=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
            className: (dropdown_explore_module_default()).latestArticlesListWrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: (dropdown_explore_module_default()).articleTypeTitle,
                    href: accessHref,
                    children: "Topics"
                }),
                categories.map((category)=>{
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: (0,LangHelper/* localifyLink */.Bj)("/".concat(locale).concat(category.categoryUrl), locale),
                            className: (dropdown_explore_module_default()).articleTypeName,
                            children: category.name
                        })
                    }, category.name);
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (dropdown_explore_module_default()).exploreButtonWrapper,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (dropdown_explore_module_default()).exploreButtonText,
                            children: "View all articles"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                            type: icons/* IconType.ArrowRightMedium */.T.ArrowRightMedium
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: accessHref,
                            target: "_self"
                        })
                    ]
                })
            ]
        });
    };
    const renderGuides = ()=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
            className: (dropdown_explore_module_default()).latestArticlesListWrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: (dropdown_explore_module_default()).articleTypeTitle,
                    href: guidePageHref,
                    children: "Guides"
                }),
                sortedGuides.slice(0, 5).map((series)=>{
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: (0,LangHelper/* localifyLink */.Bj)("/".concat(locale).concat(series.guideUrl), locale),
                            className: (dropdown_explore_module_default()).articleTypeName,
                            children: series.name
                        })
                    }, series.name);
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (dropdown_explore_module_default()).exploreButtonWrapper,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (dropdown_explore_module_default()).exploreButtonText,
                            children: "View all guides"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                            type: icons/* IconType.ArrowRightMedium */.T.ArrowRightMedium
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: guidePageHref,
                            target: "_self"
                        })
                    ]
                })
            ]
        });
    };
    const renderMoreResources = ()=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (dropdown_explore_module_default()).moreResourceWrapper,
            children: dummyResources.map((resource)=>{
                if (!resource.locale.includes(locale)) return null;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    className: (dropdown_explore_module_default()).moreResourceContainer,
                    href: (0,LangHelper/* localifyLink */.Bj)("/".concat(locale).concat(resource.resourceUrl), locale),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (dropdown_explore_module_default()).moreResourceName,
                                    children: resource.name
                                }),
                                resource.description ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (dropdown_explore_module_default()).moreResourceDescription,
                                    children: resource.description
                                }) : null
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (dropdown_explore_module_default()).moreResourceViewMoreIcon,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                                type: icons/* IconType.ArrowRightMedium */.T.ArrowRightMedium
                            })
                        })
                    ]
                }, resource.name);
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (dropdown_explore_module_default()).dropdownExplore + " " + (isToggle ? (dropdown_explore_module_default()).toggleExploreOn : ""),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (dropdown_explore_module_default()).dropdownContainer,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (dropdown_explore_module_default()).latestArticles,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: (0,LangHelper/* localifyLink */.Bj)("/".concat(locale, "/business/access"), locale),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (dropdown_explore_module_default()).dropdownTitle,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                                        type: icons/* IconType.ReadBook */.T.ReadBook
                                    }),
                                    locale === LangHelper/* Locale.GreatBritain */.go.GreatBritain ? "Clearpay Access" : "Afterpay Access"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (dropdown_explore_module_default()).latestArticlesContainer,
                            children: [
                                renderCategories(),
                                renderGuides()
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (dropdown_explore_module_default()).moreResource,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: (0,LangHelper/* localifyLink */.Bj)("/".concat(locale, "/business/resources/"), locale),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (dropdown_explore_module_default()).dropdownTitle,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                                        type: icons/* IconType.Resource */.T.Resource
                                    }),
                                    "More Resources"
                                ]
                            })
                        }),
                        renderMoreResources()
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var dropdown_explore = (DropdownExplore);

// EXTERNAL MODULE: ./components/business-header/business-header.module.scss
var business_header_module = __webpack_require__(8239);
var business_header_module_default = /*#__PURE__*/__webpack_require__.n(business_header_module);
;// CONCATENATED MODULE: ./components/business-header/business-header.tsx









const BusinessHeader = (props)=>{
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    const windowSize = (0,useWindowSize/* useWindowSize */.i)();
    const [isMobile, setIsMobile] = (0,react.useState)(false);
    const [isShowDrawerContent, setShowMenu] = (0,react.useState)(false);
    const [isShowExplore, setShowExplore] = (0,react.useState)(false);
    const [isShowFormSearch, setShowFormSearch] = (0,react.useState)(false);
    const windowWidth = windowSize.width || 0;
    const [categories, setMappedCategories] = (0,react.useState)([]);
    const navRef = (0,react.useRef)(null);
    (0,react.useEffect)(()=>{
        if (windowWidth < 1112) {
            setIsMobile(true);
        } else {
            setIsMobile(false);
        }
    }, [
        windowWidth
    ]);
    (0,react.useEffect)(()=>{
        getCategories(props.categories);
    }, [
        props.categories
    ]);
    (0,react.useEffect)(()=>{
        const body = document.body;
        if (!body) {
            return;
        }
        if (isShowDrawerContent) {
            body.classList.add("lock-scroll");
        } else {
            body.classList.remove("lock-scroll");
        }
    }, [
        isShowDrawerContent
    ]);
    const categoryOrder = [
        "News",
        "Success Stories",
        "Marketing",
        "Operations",
        "Finance"
    ];
    const getCategories = (categories)=>{
        if (categories && categories.length > 0) {
            categories.sort((a, b)=>{
                const indexOfA = categoryOrder.indexOf(a.name);
                const indexOfB = categoryOrder.indexOf(b.name);
                if (indexOfA !== -1 && indexOfA !== indexOfB) {
                    return indexOfA - indexOfB;
                }
                return a.name.localeCompare(b.name);
            });
            const indx = categories.map((c)=>c.name).indexOf(categoryOrder[0]);
            const priorityCategory = categories.slice(indx);
            const normalCategory = categories.slice(0, indx);
            setMappedCategories([
                ...priorityCategory,
                ...normalCategory
            ]);
        }
    };
    const getGuides = ()=>{
        var _categoryUrl;
        return categories.filter((category)=>{
            if (category.isSeries) {
                return category;
            }
        }).map((category)=>({
                name: category.name,
                guideUrl: (_categoryUrl = category.categoryUrl) !== null && _categoryUrl !== void 0 ? _categoryUrl : ""
            }));
    };
    const sortCategoriesForDropdown = (categories)=>{
        if (categories && categories.length > 0) {
            let categoriesMap = [];
            for(let i = 0; i < categoryOrder.length; i++){
                const categoryFilter = categories.find((category)=>category.name === categoryOrder[i]);
                categoriesMap.push(categoryFilter);
            }
            return categoriesMap;
        }
    };
    useOutsideClick(navRef, ()=>{
        setShowExplore(false);
    });
    const toggleShowHideExplore = ()=>{
        setShowExplore(!isShowExplore);
    };
    const handleClickToggleMenu = ()=>{
        setShowMenu((oldState)=>!oldState);
    };
    const handleToggleFormSearch = ()=>{
        setShowFormSearch(!isShowFormSearch);
    };
    const signupButton = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            rel: "noreferrer",
            href: (LangHelper/* LOCALE_LINKS */.kV[locale] || LangHelper/* LOCALE_LINKS */.kV[LangHelper/* DEFAULT_LANG */.Hj]).signup,
            className: (business_header_module_default()).buttonSignUp,
            children: "Sign up"
        });
    const renderDropDownExplore = ()=>{
        if (isMobile) {
            return null;
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (business_header_module_default()).buttonExplore + " " + (isShowExplore ? (business_header_module_default()).buttonActive : ""),
                    onClick: ()=>toggleShowHideExplore(),
                    children: [
                        "Explore",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (business_header_module_default()).iconDown,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                                type: icons/* IconType.Down */.T.Down
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown_explore, {
                    isToggle: isShowExplore,
                    categories: sortCategoriesForDropdown(categories),
                    guides: getGuides()
                })
            ]
        });
    };
    const renderButtonToggleDrawer = ()=>{
        if (isMobile) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_header_module_default()).buttonToggleDrawer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (business_header_module_default()).iconMenu,
                    onClick: ()=>handleClickToggleMenu(),
                    children: isShowDrawerContent ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                        type: icons/* IconType.RemoveBold */.T.RemoveBold
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                        type: icons/* IconType.MenuHeader */.T.MenuHeader
                    })
                })
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (business_header_module_default()).menuRight,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(business_header_autocomplete_list, {
                    isShown: isShowFormSearch,
                    onClickButtonSearch: ()=>handleToggleFormSearch()
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (business_header_module_default()).verticalLine
                }),
                signupButton()
            ]
        });
    };
    const renderDrawerContent = ()=>{
        if (!isShowDrawerContent) {
            return null;
        }
        const { width =0 , height =0  } = windowSize;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (business_header_module_default()).drawerMenu,
            style: {
                height: width <= 1112 ? height - 64 : undefined
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (business_header_module_default()).drawerMenuButton,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(business_header_autocomplete_list, {
                            isShown: isShowFormSearch,
                            onClickButtonSearch: ()=>handleToggleFormSearch()
                        }),
                        !isShowFormSearch && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (business_header_module_default()).accountGroup,
                            children: signupButton()
                        })
                    ]
                }),
                !isShowFormSearch && /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown_explore, {
                    isToggle: true,
                    categories: sortCategoriesForDropdown(categories)
                })
            ]
        });
    };
    const renderLogo = ()=>{
        if (locale === LangHelper/* Locale.GreatBritain */.go.GreatBritain) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                type: icons/* IconType.LogoClearpay */.T.LogoClearpay
            }, Math.random());
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
            type: icons/* IconType.AfterPay */.T.AfterPay
        }, Math.random());
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (business_header_module_default()).articleHeaderWrapper,
        ref: navRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (business_header_module_default()).articleHeaderContainer + " " + (isShowDrawerContent ? (business_header_module_default()).toggleMenu : ""),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (business_header_module_default()).logoWrapper,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: (LangHelper/* LOCALE_LINKS */.kV[locale] || LangHelper/* LOCALE_LINKS */.kV[LangHelper/* Locale.USA */.go.USA]).home,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                                    type: icons/* IconType.LogoAfterPay */.T.LogoAfterPay
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                href: (0,LangHelper/* localifyLink */.Bj)("/".concat(locale, "/business/access"), locale),
                                className: (business_header_module_default()).businessHomepageLinks,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (business_header_module_default()).iconAfterPay,
                                        children: renderLogo()
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (business_header_module_default()).businessIcon,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                                                type: icons/* IconType.BusinessSmall */.T.BusinessSmall
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                                                type: icons/* IconType.Business */.T.Business
                                            })
                                        ]
                                    })
                                ]
                            }),
                            renderDropDownExplore()
                        ]
                    }),
                    renderButtonToggleDrawer()
                ]
            }),
            renderDrawerContent()
        ]
    });
};
/* harmony default export */ var business_header = (BusinessHeader);

;// CONCATENATED MODULE: ./components/layouts/default-layout.tsx





const DefaultLayout = (props)=>{
    const [type, setType] = react.useState();
    var _breadcrumbs;
    const defaultContextValue = {
        breadcrumbs: (_breadcrumbs = props.breadcrumbs) !== null && _breadcrumbs !== void 0 ? _breadcrumbs : [],
        type,
        setType
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DefaultLayoutContext/* DefaultLayoutContext.Provider */.V.Provider, {
            value: defaultContextValue,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(business_header, {
                    categories: props.categories
                }),
                props.children,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(business_footer, {
                    footerData: props.footerItems
                })
            ]
        })
    });
};
/* harmony default export */ var default_layout = (DefaultLayout);


/***/ }),

/***/ 204:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ LazyBackgroundImage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(315);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2991);
/* harmony import */ var _helpers_BuilderHelper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1198);
/* harmony import */ var react_intersection_observer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7650);




const LazyBackgroundImage = (props)=>{
    const { className ="" , imageUrl , imageWidth , ...rest } = props;
    const { ref , inView  } = (0,react_intersection_observer__WEBPACK_IMPORTED_MODULE_3__/* .useInView */ .YD)();
    const [wasSeen, setWasSeen] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [currentImage, setCurrentImage] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)((0,_helpers_BuilderHelper__WEBPACK_IMPORTED_MODULE_2__/* .getPlaceholderBuilderImage */ .W)(imageUrl));
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (inView && !wasSeen) {
            setWasSeen(true);
        }
    }, [
        inView
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        let cancelled = false;
        const resizeParams = {};
        if (imageWidth && imageWidth > 1) {
            resizeParams.width = imageWidth;
        }
        if (wasSeen) {
            const resizedImage = (0,_helpers_BuilderHelper__WEBPACK_IMPORTED_MODULE_2__/* .getResizedBuilderImage */ .bs)(imageUrl, resizeParams);
            const loadingImage = new Image();
            loadingImage.onload = ()=>{
                if (!cancelled) {
                    setCurrentImage(resizedImage);
                }
            };
            loadingImage.src = resizedImage !== null && resizedImage !== void 0 ? resizedImage : "";
        }
        return ()=>{
            cancelled = true;
        };
    }, [
        wasSeen,
        imageUrl,
        imageWidth
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: ref,
        className: className,
        ...rest,
        style: {
            ...rest === null || rest === void 0 ? void 0 : rest.style,
            backgroundImage: "url('".concat(currentImage, "')")
        }
    });
};


/***/ }),

/***/ 5338:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ sign_up_card; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(315);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(2991);
// EXTERNAL MODULE: ./helpers/LangHelper.ts
var LangHelper = __webpack_require__(7868);
// EXTERNAL MODULE: ./components/icons/index.tsx + 82 modules
var icons = __webpack_require__(3203);
;// CONCATENATED MODULE: ./components/sign-up-card/image-background-sign-up-card.tsx


const ImageBackgroundSignUpCard = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "557",
        height: "487",
        viewBox: "0 0 557 487",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M520.647 102.133L355.519 9.5642C307.048 -17.6079 246.46 16.3473 246.46 70.7315V80.2278C246.46 88.8063 251.184 96.7465 258.824 101.016L290.001 118.492C299.161 123.639 310.581 117.215 310.581 106.961V83.34C310.581 71.5295 323.725 64.1479 334.241 70.0532L477.27 150.253C487.786 156.158 487.786 170.921 477.27 176.787L334.241 256.986C323.725 262.892 310.581 255.51 310.581 243.699V231.131C310.581 176.747 249.993 142.752 201.481 169.964L36.3529 262.532C-12.1176 289.705 -12.1176 357.695 36.3529 384.867L201.481 477.436C249.952 504.608 310.581 470.653 310.581 416.269V406.772C310.581 398.194 305.857 390.293 298.217 385.984L267.04 368.468C257.879 363.321 246.46 369.745 246.46 379.999V403.62C246.46 415.431 233.316 422.812 222.8 416.907L79.7708 336.707C69.2551 330.802 69.2551 316.039 79.7708 310.134L222.8 229.934C233.316 224.029 246.46 231.41 246.46 243.221V255.789C246.46 310.173 307.048 344.169 355.519 316.957L520.647 224.388C569.118 197.295 569.118 129.305 520.647 102.133Z",
            fill: "white"
        })
    });
};
/* harmony default export */ var image_background_sign_up_card = (ImageBackgroundSignUpCard);

// EXTERNAL MODULE: ./components/sign-up-card/sign-up-card.module.scss
var sign_up_card_module = __webpack_require__(1170);
var sign_up_card_module_default = /*#__PURE__*/__webpack_require__.n(sign_up_card_module);
;// CONCATENATED MODULE: ./components/sign-up-card/sign-up-card.tsx






const SignUpCard = (props)=>{
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
        href: (LangHelper/* LOCALE_LINKS */.kV[locale] || LangHelper/* LOCALE_LINKS */.kV[LangHelper/* Locale.USA */.go.USA]).signup,
        rel: "noreferrer",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (sign_up_card_module_default()).signUpCard,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (sign_up_card_module_default()).backgroundImage,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_background_sign_up_card, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (sign_up_card_module_default()).infoDetail,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: (sign_up_card_module_default()).title,
                            children: [
                                "Sign up for ",
                                (0,LangHelper/* getCompanyName */.Yd)(locale),
                                " Now!"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: (sign_up_card_module_default()).description,
                            children: [
                                "Get ",
                                (0,LangHelper/* getCompanyName */.Yd)(locale),
                                " for your business."
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (sign_up_card_module_default()).buttonSubscribe,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "Sign up"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                            type: icons/* IconType.ArrowRightMedium */.T.ArrowRightMedium
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var sign_up_card = (SignUpCard);


/***/ }),

/***/ 8533:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ article_card_skeleton; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(315);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(2991);
// EXTERNAL MODULE: ./hook/useWindowSize.ts
var useWindowSize = __webpack_require__(8766);
// EXTERNAL MODULE: ./components/article-card/article-card.tsx
var article_card = __webpack_require__(2790);
// EXTERNAL MODULE: ./components/skeleton-load/image-skeleton/image-skeleton.module.scss
var image_skeleton_module = __webpack_require__(87);
var image_skeleton_module_default = /*#__PURE__*/__webpack_require__.n(image_skeleton_module);
;// CONCATENATED MODULE: ./components/skeleton-load/image-skeleton/image-skeleton.tsx



const ImageSkeleton = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (image_skeleton_module_default()).imageSkeleton
    });
};
/* harmony default export */ var image_skeleton = (ImageSkeleton);

// EXTERNAL MODULE: ./components/skeleton-load/text-skeleton/text-skeleton.module.scss
var text_skeleton_module = __webpack_require__(7751);
var text_skeleton_module_default = /*#__PURE__*/__webpack_require__.n(text_skeleton_module);
;// CONCATENATED MODULE: ./components/skeleton-load/text-skeleton/text-skeleton.tsx



const TextSkeleton = (props)=>{
    const [widthText, heightText] = props.size;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (text_skeleton_module_default()).textSkeleton,
        style: {
            height: heightText,
            width: widthText
        }
    });
};
/* harmony default export */ var text_skeleton = (TextSkeleton);

// EXTERNAL MODULE: ./components/skeleton-load/article-card-skeleton/article-card-skeleton.module.scss
var article_card_skeleton_module = __webpack_require__(4494);
var article_card_skeleton_module_default = /*#__PURE__*/__webpack_require__.n(article_card_skeleton_module);
;// CONCATENATED MODULE: ./components/skeleton-load/article-card-skeleton/article-card-skeleton.tsx







const ArticleCardSkeleton = (props)=>{
    const { type  } = props;
    const windowSize = (0,useWindowSize/* useWindowSize */.i)();
    const isMobile = ()=>{
        const windowWidth = windowSize.width || 0;
        if (windowWidth < 768) {
            return true;
        } else {
            return false;
        }
    };
    const renderSmallContent = ()=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (article_card_skeleton_module_default()).articleCardSkeletonLeftContent,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(text_skeleton, {
                    size: [
                        80,
                        24
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (article_card_skeleton_module_default()).articleCardSkeletonLeftContentTitle,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(text_skeleton, {
                            size: [
                                "100%",
                                isMobile() ? 24 : 32
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(text_skeleton, {
                            size: [
                                "100%",
                                isMobile() ? 24 : 32
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(text_skeleton, {
                            size: [
                                180,
                                isMobile() ? 24 : 32
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (article_card_skeleton_module_default()).articleCardSkeletonLeftContentDescription,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(text_skeleton, {
                            size: [
                                "100%",
                                16
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(text_skeleton, {
                            size: [
                                isMobile() ? 67 : 90,
                                16
                            ]
                        })
                    ]
                })
            ]
        });
    };
    const renderLargeContent = ()=>{
        if (isMobile()) {
            return renderSmallContent();
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (article_card_skeleton_module_default()).articleCardSkeletonLeftContent,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(text_skeleton, {
                    size: [
                        80,
                        24
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (article_card_skeleton_module_default()).articleCardSkeletonLeftContentTitle,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(text_skeleton, {
                            size: [
                                "100%",
                                40
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(text_skeleton, {
                            size: [
                                "100%",
                                40
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(text_skeleton, {
                            size: [
                                "100%",
                                40
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(text_skeleton, {
                            size: [
                                180,
                                40
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (article_card_skeleton_module_default()).articleCardSkeletonLeftContentDescription,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(text_skeleton, {
                            size: [
                                "100%",
                                24
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(text_skeleton, {
                            size: [
                                "100%",
                                24
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(text_skeleton, {
                            size: [
                                90,
                                24
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (article_card_skeleton_module_default()).articleCardSkeletonLeftContentButton,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(text_skeleton, {
                        size: [
                            154,
                            48
                        ]
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (article_card_skeleton_module_default()).articleCardSkeleton + " " + (article_card_skeleton_module_default())[isMobile() ? "small" : type],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (article_card_skeleton_module_default()).articleCardSkeletonImage,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_skeleton, {})
            }),
            type === article_card/* ArticleCardType.Large */._.Large ? renderLargeContent() : renderSmallContent()
        ]
    });
};
/* harmony default export */ var article_card_skeleton = (ArticleCardSkeleton);


/***/ }),

/***/ 1683:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ DefaultLayoutContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2991);

const DefaultLayoutContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});


/***/ }),

/***/ 1198:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Af": function() { return /* binding */ getQuickSearchResponses; },
/* harmony export */   "CN": function() { return /* binding */ getPageFromPageID; },
/* harmony export */   "Jq": function() { return /* binding */ mapBuilderObjectToArticle; },
/* harmony export */   "NE": function() { return /* binding */ getArticleFromID; },
/* harmony export */   "W": function() { return /* binding */ getPlaceholderBuilderImage; },
/* harmony export */   "WA": function() { return /* binding */ resourcesInput; },
/* harmony export */   "Zd": function() { return /* binding */ getArticlesByCategory; },
/* harmony export */   "bs": function() { return /* binding */ getResizedBuilderImage; },
/* harmony export */   "cA": function() { return /* binding */ getArticleSearchResults; },
/* harmony export */   "eA": function() { return /* binding */ getRelatedArticles; },
/* harmony export */   "gg": function() { return /* binding */ getLatestArticles; },
/* harmony export */   "nq": function() { return /* binding */ getCategoriesFromIDs; },
/* harmony export */   "s$": function() { return /* binding */ getCategoryFromID; },
/* harmony export */   "yP": function() { return /* binding */ mapBuilderObjectToCategory; },
/* harmony export */   "zC": function() { return /* binding */ getAllArticles; }
/* harmony export */ });
/* unused harmony exports excludedArticleIds, getBuilderPage, getArticlePageFromUrl, getCategoryFromName, getAllCategories, getAllArticlePaths */
/* harmony import */ var _builder_io_react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5102);
/* harmony import */ var algoliasearch__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6441);
/* harmony import */ var algoliasearch__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(algoliasearch__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _shared_env__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9771);
/* harmony import */ var _LangHelper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7868);
/* harmony import */ var _types_Resource__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3366);





_builder_io_react__WEBPACK_IMPORTED_MODULE_0__/* ["default"].init */ .ZP.init(_shared_env__WEBPACK_IMPORTED_MODULE_1__/* .BUILDER_API_KEY */ .uT);
const client = algoliasearch__WEBPACK_IMPORTED_MODULE_4___default()(_shared_env__WEBPACK_IMPORTED_MODULE_1__/* .ALGOLIA_APP_ID */ .$A, _shared_env__WEBPACK_IMPORTED_MODULE_1__/* .ALGOLIA_API_KEY */ .vd);
const articleIndex = client.initIndex("builder-article");
const CATEGORY_ROOT = "/business/access/";
/**
 * https://dijitally.atlassian.net/browse/APB-212
 * https://dijitally.atlassian.net/browse/APB-257
 */ const excludedArticleIds = [
    "03c8d98acf1341a1a78668a42f76f342",
    "6500a1b582874d038178ffca459b35b4",
    "9b182828368a49a6b0872ec7119b36c0",
    "e7d6577785ca4e35ae3a13f0ba811e2d",
    "9647e35f141a4d73aac1367e9093c6ce",
    "98980189fa414d4b8042b099ef9be739",
    "d258b5ff845a46ce8da8b549c5774023",
    "3813f56a18a44646bb94543fd3684ba7",
    "fcd0925629d44c73b60ac65b8d9196af",
    "3d5f6f728a8e480fae7507f2f82a64d4",
    "74fbbf2c675d44479f0df5ff6a95e7b1",
    "a1a6b180b0c440c99b9ad86d925db1c6",
    "e3d02593db2f4cd09c9caf6bd61cd8dc",
    "a0c28c5496ba4cefb7539ed335075a84",
    "957e67c8b8f54c95b1eed46e2615bc55",
    "c4d5b594468f4b63b9a0d36e9a236434",
    "e1f67ee797944b449e8db3b49b125558",
    "87ca4620882d4b04937f7921724c8c87",
    "1cc3c604bd514519b8f4a6bb2c1ab200",
    "237989ea7b774f20987ff8003ef88cc1",
    "4c2ee6ee27e84417a4e650e78bf6cc37"
];
function mapBuilderObjectToArticle(object) {
    var ref, ref1, ref2, ref3;
    const oData = object.data;
    const categories = (ref = oData.categories) === null || ref === void 0 ? void 0 : ref.map((category)=>mapBuilderObjectToCategory(category.category.value));
    const author = oData === null || oData === void 0 ? void 0 : (ref1 = oData.author) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.value) === null || ref2 === void 0 ? void 0 : ref2.data;
    var ref4;
    const articleSlug = (ref4 = (ref3 = oData.url) === null || ref3 === void 0 ? void 0 : ref3.replace("/builder/", "")) !== null && ref4 !== void 0 ? ref4 : "";
    const articleUrl = categories && categories.length ? "".concat(categories[0].categoryUrl, "/").concat(articleSlug).replace(/\/{2,}/, "/") : null;
    var _title, _description, _contributors, _leadImage, _leadPortraitImage, _priority, _seoTitle, ref5, _seoDescription, ref6, _leadVideo, _lastUpdated;
    return {
        title: (_title = oData.title) !== null && _title !== void 0 ? _title : "",
        description: (_description = oData.description) !== null && _description !== void 0 ? _description : "",
        categories: categories !== null && categories !== void 0 ? categories : null,
        author: author !== null && author !== void 0 ? author : null,
        contributors: (_contributors = oData.contributors) !== null && _contributors !== void 0 ? _contributors : [],
        leadImage: (_leadImage = oData.leadImage) !== null && _leadImage !== void 0 ? _leadImage : null,
        leadPortraitImage: (_leadPortraitImage = oData.leadPortraitImage) !== null && _leadPortraitImage !== void 0 ? _leadPortraitImage : null,
        url: articleUrl !== null && articleUrl !== void 0 ? articleUrl : "",
        articleUrl: articleUrl !== null && articleUrl !== void 0 ? articleUrl : "",
        articleSlug,
        priority: (_priority = oData.priority) !== null && _priority !== void 0 ? _priority : 0,
        builderModel: object !== null && object !== void 0 ? object : null,
        seoTitle: (ref5 = (_seoTitle = oData.seoTitle) !== null && _seoTitle !== void 0 ? _seoTitle : oData.title) !== null && ref5 !== void 0 ? ref5 : "",
        seoDescription: (ref6 = (_seoDescription = oData.seoDescription) !== null && _seoDescription !== void 0 ? _seoDescription : oData.description) !== null && ref6 !== void 0 ? ref6 : "",
        leadVideo: (_leadVideo = oData.leadVideo) !== null && _leadVideo !== void 0 ? _leadVideo : null,
        lastUpdated: (_lastUpdated = object.lastUpdated) !== null && _lastUpdated !== void 0 ? _lastUpdated : null
    };
}
function mapBuilderObjectToCategory(item) {
    if (!item) {
        return {
            id: "",
            name: "",
            longName: null,
            description: "",
            categoryUrl: "",
            isSeries: false,
            image: "",
            lastUpdated: "",
            exclusiveForLocales: []
        };
    }
    let name;
    let category = item;
    if (item.data === undefined) {
        var _name;
        name = (_name = item.name) !== null && _name !== void 0 ? _name : "";
    } else {
        category = item.data;
        var _name1;
        name = (_name1 = item.name) !== null && _name1 !== void 0 ? _name1 : item.data.name;
    }
    const categorySlug = categoryNameToUrlSlug(name);
    var _longName, _exclusiveForLocales;
    // TODO generalize this parser here
    return {
        id: item.id,
        name,
        longName: (_longName = category.longName) !== null && _longName !== void 0 ? _longName : null,
        categoryUrl: (CATEGORY_ROOT + categorySlug).replace(/\/{2,}/g, "/"),
        isSeries: !!category.isSeries || false,
        categorySlug,
        description: category.description || "",
        image: category.image || "",
        lastUpdated: item.lastUpdated || "",
        exclusiveForLocales: (_exclusiveForLocales = category.exclusiveForLocales) !== null && _exclusiveForLocales !== void 0 ? _exclusiveForLocales : []
    };
}
const categoryNameToUrlSlug = (name)=>{
    return name.trim().toLowerCase().replace(/[^A-z]/g, "-").trimEnd();
};
const getAllArticles = async function(locale, filters, sort) {
    let includeUnpublished = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, limitFields = arguments.length > 4 ? arguments[4] : void 0;
    var ref;
    const getConfig = {
        query: {},
        options: {
            noTargeting: true,
            includeUnpublished
        }
    };
    if (filters === null || filters === void 0 ? void 0 : filters.extra) {
        getConfig.query = filters === null || filters === void 0 ? void 0 : filters.extra;
    }
    if (locale) {
        getConfig.query.query = {
            $elemMatch: {
                property: {
                    $eq: "locale"
                },
                value: locale
            }
        };
    }
    if (filters === null || filters === void 0 ? void 0 : (ref = filters.categoryIds) === null || ref === void 0 ? void 0 : ref.length) {
        getConfig.query["data.categories"] = {
            $elemMatch: {
                "category.id": {
                    $in: filters.categoryIds
                }
            }
        };
    }
    if (sort && getConfig.options) {
        getConfig.options.sort = sort;
    }
    if (limitFields) {
        getConfig.fields = limitFields;
    }
    getConfig.limit = filters === null || filters === void 0 ? void 0 : filters.limit;
    if (getConfig.options) {
        if (typeof (filters === null || filters === void 0 ? void 0 : filters.offset) === "string") {
            var ref1;
            getConfig.options.offset = parseInt((ref1 = filters === null || filters === void 0 ? void 0 : filters.offset) !== null && ref1 !== void 0 ? ref1 : "0");
        } else {
            getConfig.options.offset = filters === null || filters === void 0 ? void 0 : filters.offset;
        }
    }
    const articles = await _builder_io_react__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getAll */ .ZP.getAll("article", getConfig);
    return articles.map((page)=>{
        return mapBuilderObjectToArticle(page);
    });
};
const getArticlePage = async function(params) {
    let includeUnpublished = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getBuilderPage("article", params, includeUnpublished);
};
const getBuilderPage = async function(model, params) {
    let includeUnpublished = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    const query = {
        userAttributes: {},
        options: {
            includeUnpublished,
            noTargeting: false
        }
    };
    if (params.url) {
        query.userAttributes.urlPath = params.url;
        if (params.locale) {
            query.userAttributes.locale = params.locale;
        } else {
            query.userAttributes.locale = _LangHelper__WEBPACK_IMPORTED_MODULE_2__/* .ALL_LOCALES */ .En;
        }
    }
    if (params.modelId) {
        query.entry = params.modelId;
    }
    // TODO replace these string entries with constants
    const article = await _builder_io_react__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get(model, query).toPromise() || null;
    return article;
};
const getArticlePageFromUrl = async function() {
    let path = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", locale = arguments.length > 1 ? arguments[1] : void 0, includeUnpublished = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return getArticlePage({
        url: "/builder/" + path,
        locale
    }, includeUnpublished);
};
const getArticleFromID = async function(modelId) {
    let includeUnpublished = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getArticlePage({
        modelId
    }, includeUnpublished);
};
const getCategoryFromName = async (name)=>{
    const slug = categoryNameToUrlSlug(name);
    const allPossibleCategories = await getAllCategories();
    for (const category of allPossibleCategories){
        if ("".concat(CATEGORY_ROOT).concat(slug) === category.categoryUrl) {
            // TODO refactor check to come from a generic place
            return category;
        }
    }
    return null;
};
const getCategoryFromID = async (modelId)=>{
    const foundCategory = await getBuilderPage("category", {
        modelId
    }, true);
    if (foundCategory) {
        return mapBuilderObjectToCategory(foundCategory);
    }
    return null;
};
const getArticlesByCategory = async (param)=>{
    let { locale , offset , limit =9 , categoryIds =[]  } = param;
    return await getAllArticles(locale, {
        categoryIds,
        limit,
        offset,
        extra: {
            id: {
                $nin: excludedArticleIds
            }
        }
    });
};
const getRelatedArticles = async (article, locale)=>{
    if (!article) {
        return [];
    }
    const categoryIds = article.categories ? [
        ...article.categories
    ].map((item)=>{
        return item.id;
    }) : [];
    const config = {
        options: {
            noTargeting: true
        },
        query: {
            id: {
                $nin: excludedArticleIds.concat([
                    article.builderModel.id
                ])
            },
            "data.categories": {
                $elemMatch: {
                    "category.id": {
                        $in: [
                            categoryIds[0]
                        ]
                    }
                }
            }
        },
        limit: 3
    };
    if (locale) {
        config.query.query = {
            $elemMatch: {
                property: {
                    $eq: "locale"
                },
                value: locale
            }
        };
    }
    const relatedPages = await _builder_io_react__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getAll */ .ZP.getAll("article", config);
    const relatedArticles = relatedPages.map((page)=>{
        return mapBuilderObjectToArticle(page);
    });
    return relatedArticles;
};
const getLatestArticles = async (param)=>{
    let { locale , offset , limit =4 , categoryIds =[]  } = param;
    return getAllArticles(locale, {
        extra: {
            data: {
                "leadVideo.videoUrl": {
                    $exists: false
                }
            }
        },
        categoryIds,
        offset,
        limit
    }, {
        "data.priority": -1,
        lastUpdated: -1
    });
};
let cachedCategoryList = [];
const getAllCategories = async ()=>{
    // TODO add caching mechanism to avoid loading this over and over again
    if (cachedCategoryList.length !== 0) {
        return cachedCategoryList;
    }
    const allCategory = await _builder_io_react__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getAll */ .ZP.getAll("category", {
        options: {
            noTargeting: true,
            includeUnpublished: false
        }
    });
    const categoriesData = allCategory.map((item)=>mapBuilderObjectToCategory(item));
    if (cachedCategoryList.length === 0) {
        cachedCategoryList = categoriesData;
    }
    return categoriesData;
};
const getCategoriesFromIDs = async function() {
    let categoryIds = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    const allCategory = await _builder_io_react__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getAll */ .ZP.getAll("category", {
        options: {
            noTargeting: true,
            includeUnpublished: false
        },
        query: {
            id: {
                $in: categoryIds
            }
        }
    });
    const categoriesData = allCategory.map((item)=>mapBuilderObjectToCategory(item));
    return categoriesData;
};
const getPageFromPageID = async (id)=>{
    return getBuilderPage("page", {
        modelId: id
    }, true);
};
const getArticleSearchResults = async (param)=>{
    let { locale , keyword , limit =25 , offset =0 , onlyFields  } = param;
    try {
        const { hits: articles  } = await articleIndex.search(keyword, {
            hitsPerPage: limit,
            offset: offset,
            attributesToRetrieve: [
                "*"
            ],
            removeWordsIfNoResults: "none",
            exactOnSingleWordQuery: "word",
            facets: [
                "published",
                "query.value"
            ],
            facetFilters: [
                [
                    "query.value:".concat(locale)
                ],
                [
                    "published:published"
                ]
            ]
        });
        const ids = articles.map((article)=>article.objectID);
        return getAllArticles(locale, {
            extra: {
                id: {
                    $in: ids
                }
            },
            limit,
            offset
        }, undefined, false, onlyFields);
    } catch (ex) {
        console.error(ex);
        return getAllArticles(locale, {
            extra: {
                $or: [
                    {
                        name: {
                            $regex: keyword,
                            $options: "i"
                        }
                    },
                    {
                        description: {
                            $regex: keyword,
                            $options: "i"
                        }
                    },
                    {
                        "data.title": {
                            $regex: keyword,
                            $options: "i"
                        }
                    },
                    {
                        "data.blocks.$elemMatch.component.options.text": {
                            $regex: keyword,
                            $options: "i"
                        }
                    }
                ]
            },
            limit,
            offset
        }, undefined, false, onlyFields);
    }
};
/**
 * Function used for fetching paths for Static Path mapping
 *
 * @returns Promise
 */ const getAllArticlePaths = async ()=>{
    const pathArray = [];
    let currentOffset = 0;
    const fetchArticles = async (offset)=>{
        const currentArticles = await getAllArticles(undefined, {
            offset,
            limit: 100
        });
        currentArticles.map((page)=>{
            const queryFilters = page.builderModel.query;
            // Check if page has lang
            if (queryFilters.length > 0 && queryFilters[1].property == "locale") {
                queryFilters[1].value.forEach((lang)=>{
                    page.categories.forEach((category)=>{
                        if (category.categoryUrl) {
                            var ref;
                            const businessPath = (ref = LOCALE_LINKS[lang]) === null || ref === void 0 ? void 0 : ref.businessRoot;
                            var _categorySlug;
                            pathArray.push({
                                lang,
                                category: (_categorySlug = category.categorySlug) !== null && _categorySlug !== void 0 ? _categorySlug : "",
                                article: page.articleSlug,
                                business: businessPath !== null && businessPath !== void 0 ? businessPath : BusinessUrlPrefix.Business
                            });
                        }
                    });
                });
            }
        });
        if (currentArticles.length === 100) {
            await fetchArticles(currentOffset += 100);
        }
    };
    await fetchArticles(currentOffset);
    return pathArray;
};
/**
 * Function will return a promise, with suggestions for category, and articles
 */ const getQuickSearchResponses = async (locale, query)=>{
    const articles = [];
    const categories = [];
    const queryPromises = [
        (async ()=>{
            const foundCategories = await getAllCategories();
            const includesRegex = new RegExp(query, "i");
            if (foundCategories.length) {
                for (const category of foundCategories){
                    var ref;
                    if (((ref = category.exclusiveForLocales) === null || ref === void 0 ? void 0 : ref.length) && !category.exclusiveForLocales.includes(locale)) {
                        continue;
                    }
                    if (includesRegex.test(category.name)) {
                        var _categoryUrl;
                        categories.push({
                            name: category.name,
                            link: (_categoryUrl = category.categoryUrl) !== null && _categoryUrl !== void 0 ? _categoryUrl : "",
                            id: category.id
                        });
                        if (categories.length >= 5) {
                            break;
                        }
                    }
                }
            }
        })(),
        (async ()=>{
            const foundArticles = await getArticleSearchResults({
                locale,
                keyword: query,
                limit: 5
            });
            if (foundArticles.length) {
                foundArticles.forEach((article)=>{
                    var _articleUrl;
                    articles.push({
                        name: article.title,
                        link: (_articleUrl = article.articleUrl) !== null && _articleUrl !== void 0 ? _articleUrl : "",
                        id: article.builderModel.id
                    });
                });
            }
        })()
    ];
    await Promise.all(queryPromises);
    return {
        categories,
        articles
    };
};
const resourcesInput = {
    name: "resources",
    type: "list",
    copyOnAdd: false,
    subFields: [
        {
            name: "type",
            type: "string"
        },
        {
            name: "title",
            type: "string"
        },
        {
            name: "description",
            type: "richText"
        },
        {
            name: "description2",
            type: "richText"
        },
        {
            name: "assets",
            type: "list",
            copyOnAdd: false,
            subFields: [
                {
                    name: "name",
                    type: "string"
                },
                {
                    name: "keyMessages",
                    type: "Tags"
                },
                {
                    name: "hide",
                    type: "boolean"
                },
                {
                    name: "skipDownload",
                    type: "boolean"
                },
                // {
                //     name: 'themedAssets',
                //     type: 'Tags',
                // },
                {
                    name: "variants",
                    type: "list",
                    copyOnAdd: false,
                    subFields: [
                        {
                            name: "variantName",
                            type: "string"
                        },
                        {
                            name: "colors",
                            type: "list",
                            copyOnAdd: false,
                            subFields: [
                                {
                                    name: "color",
                                    type: "string",
                                    enum: Object.values(_types_Resource__WEBPACK_IMPORTED_MODULE_3__/* .COLORS */ .D)
                                }
                            ]
                        },
                        {
                            name: "backgroundColor",
                            type: "color"
                        },
                        {
                            name: "previewUrl",
                            type: "url"
                        },
                        {
                            name: "downloadUrl",
                            type: "url"
                        },
                        {
                            name: "fileName",
                            type: "string"
                        },
                        {
                            name: "extension",
                            type: "string"
                        },
                        {
                            name: "hide",
                            type: "boolean"
                        }
                    ]
                }
            ]
        }
    ]
};
const getResizedBuilderImage = (source, parameters)=>{
    if (source && source.startsWith("https://cdn.builder.io/api/v1/image/")) {
        let queryArray = [];
        if (parameters) {
            var _quality;
            parameters.quality = (_quality = parameters.quality) !== null && _quality !== void 0 ? _quality : 85;
            parameters.format = "webp";
            const parameterKeys = Object.keys(parameters);
            parameterKeys.forEach((paramKey)=>{
                const paramValue = parameters[paramKey];
                if (paramValue) {
                    queryArray.push("".concat(paramKey, "=").concat(paramValue));
                }
            });
        }
        return "".concat(source, "?").concat(queryArray.join("&"));
    }
    return source;
};
const getPlaceholderBuilderImage = (source)=>{
    return getResizedBuilderImage(source, {
        width: 1,
        height: 1
    });
};


/***/ }),

/***/ 7868:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bj": function() { return /* binding */ localifyLink; },
/* harmony export */   "CB": function() { return /* binding */ isUrl; },
/* harmony export */   "En": function() { return /* binding */ ALL_LOCALES; },
/* harmony export */   "FZ": function() { return /* binding */ getLocalePrettyName; },
/* harmony export */   "Fw": function() { return /* binding */ LIVE_LOCALES; },
/* harmony export */   "Hj": function() { return /* binding */ DEFAULT_LANG; },
/* harmony export */   "RO": function() { return /* binding */ doesContainLocale; },
/* harmony export */   "Yd": function() { return /* binding */ getCompanyName; },
/* harmony export */   "_y": function() { return /* binding */ getLocaleFromRoute; },
/* harmony export */   "bU": function() { return /* binding */ useLocale; },
/* harmony export */   "go": function() { return /* binding */ Locale; },
/* harmony export */   "kV": function() { return /* binding */ LOCALE_LINKS; },
/* harmony export */   "mC": function() { return /* binding */ replaceLocale; },
/* harmony export */   "yM": function() { return /* binding */ replaceOrAddLocale; }
/* harmony export */ });
/* unused harmony exports BusinessUrlPrefix, MARKETING_RESOURCE_CENTRE_PREFIX, ALL_BUSINESS_PREFIXES, EXCLUDE_PAGES, stripLocaleFromURL */
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5407);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);

var BusinessUrlPrefix;
(function(BusinessUrlPrefix) {
    BusinessUrlPrefix["ForRetail"] = "for-retailers";
    BusinessUrlPrefix["Business"] = "business";
})(BusinessUrlPrefix || (BusinessUrlPrefix = {}));
const MARKETING_RESOURCE_CENTRE_PREFIX = "/business/resources/marketing";
const ALL_BUSINESS_PREFIXES = Object.values(BusinessUrlPrefix);
var Locale;
(function(Locale) {
    Locale["USA"] = "en-US";
    Locale["GreatBritain"] = "en-GB";
    Locale["Australia"] = "en-AU";
    Locale["NewZealand"] = "en-NZ";
    Locale["CanadaEnglish"] = "en-CA";
    Locale["CanadaFrench"] = "fr-CA";
})(Locale || (Locale = {}));
const DEFAULT_LANG = Locale.Australia;
const LIVE_LOCALES = [
    Locale.USA,
    Locale.GreatBritain,
    Locale.Australia,
    Locale.NewZealand
];
const EXCLUDE_PAGES = (/* unused pure expression or super */ null && ([
    "/business/access/guides",
    "/for-retailers/access/guides",
    "/for-retailers/resources"
])); // TODO this is a hack to make sure Guides page works as it matches a Category URL otherwise
const ALL_LOCALES = Object.values(Locale);
const LOCALE_LINKS = {
    [Locale.USA]: {
        signup: "https://get.afterpay.com/app/",
        home: "https://afterpay.com/en-US",
        businessRoot: BusinessUrlPrefix.ForRetail,
        host: "https://afterpay.com"
    },
    [Locale.GreatBritain]: {
        signup: "https://get.clearpay.co.uk/app",
        home: "https://www.clearpay.co.uk/en-GB",
        businessRoot: BusinessUrlPrefix.ForRetail,
        host: "https://www.clearpay.com"
    },
    [Locale.Australia]: {
        signup: "https://get.afterpay.com/app/",
        home: "https://www.afterpay.com/en-AU",
        businessRoot: BusinessUrlPrefix.Business,
        host: "https://afterpay.com"
    },
    [Locale.NewZealand]: {
        signup: "https://get.afterpay.com/app/",
        home: "https://www.afterpay.com/en-NZ",
        businessRoot: BusinessUrlPrefix.Business,
        host: "https://afterpay.com"
    },
    [Locale.CanadaEnglish]: {
        signup: "https://portal.afterpay.com/nz/login-email",
        home: "https://www.afterpay.com/en-CA",
        businessRoot: BusinessUrlPrefix.Business,
        host: "https://afterpay.com"
    },
    [Locale.CanadaFrench]: {
        signup: "https://portal.afterpay.com/nz/login-email",
        home: "https://www.afterpay.com/fr-CA",
        businessRoot: BusinessUrlPrefix.Business,
        host: "https://afterpay.com"
    }
};
const getLocalePrettyName = (local)=>{
    switch(local){
        case Locale.USA:
            return "United States";
        case Locale.Australia:
            return "Australia";
        case Locale.GreatBritain:
            return "Great Britain";
        case Locale.NewZealand:
            return "New Zealand";
        case Locale.CanadaEnglish:
            return "Canada - English";
        case Locale.CanadaFrench:
            return "Canada - Fran\xe7ais";
    }
};
const LOCALE_MATCH_REGEX = /(\/|).{1,3}\-.{1,3}\//;
const URL_REGREX = /^(http|https):\/\//;
const isUrl = (url)=>URL_REGREX.test(url);
const doesContainLocale = (url)=>{
    const regex = new RegExp(LOCALE_MATCH_REGEX);
    return regex.test(url);
};
const getCompanyName = (locale)=>{
    if (locale === Locale.GreatBritain) {
        return "Clearpay";
    }
    return "Afterpay";
};
const stripLocaleFromURL = (url)=>{
    return url.replace(LOCALE_MATCH_REGEX, "/");
};
const replaceLocale = (url, newLocale)=>{
    return url.replace(LOCALE_MATCH_REGEX, newLocale);
};
const replaceOrAddLocale = (url, newLocale)=>{
    if (!url.match(/^(([a-z.\-+])+|(\/\/))(:?).+$/gim)) {
        let newTarget;
        if (doesContainLocale(url)) {
            newTarget = url;
        } else {
            newTarget = "/".concat(newLocale).concat(url);
        }
        return localifyLink(newTarget, newLocale);
    }
    return url;
};
const localifyLink = (url, locale)=>{
    const matchingRegex = new RegExp("/(".concat(ALL_BUSINESS_PREFIXES.join("|"), ")"));
    if (locale) {
        var ref;
        var ref1;
        return url.replace(matchingRegex, (ref1 = "/" + ((ref = LOCALE_LINKS[locale]) === null || ref === void 0 ? void 0 : ref.businessRoot)) !== null && ref1 !== void 0 ? ref1 : "");
    } else {
    // TODO do some magic to figure out the current locale
    }
    return url;
};
const getLocaleFromRoute = (path)=>{
    for (const locale of ALL_LOCALES){
        if (path.startsWith("/".concat(locale))) {
            return locale;
        }
    }
    // Default
    return Locale.Australia;
};
const useLocale = ()=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    const locale = getLocaleFromRoute(router.asPath);
    return {
        locale
    };
};


/***/ }),

/***/ 5443:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d8": function() { return /* binding */ setCookie; },
/* harmony export */   "ej": function() { return /* binding */ getCookie; }
/* harmony export */ });
/* unused harmony export deleteCookie */
const setCookie = (name, value, days)=>{
    let date;
    if (days !== undefined) {
        date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    } else {
        // trick: no expiration date
        date = new Date(2147483647 * 1000);
    }
    const expires = "expires=".concat(date.toUTCString());
    document.cookie = "".concat(name, "=").concat(value, "; expires=").concat(expires, "; path=/");
};
const getCookie = (name)=>{
    const value = "; " + document.cookie;
    const parts = value.split("; " + name + "=");
    if (parts && parts.length == 2) {
        const partFist = parts === null || parts === void 0 ? void 0 : parts.pop();
        if (partFist) {
            return partFist.split(";").shift();
        }
        return undefined;
    } else {
        return undefined;
    }
};
const deleteCookie = (name)=>{
    const date = new Date();
    date.setTime(date.getTime() + -1 * 24 * 60 * 60 * 1000);
    document.cookie = name + "=; expires=" + date.toUTCString() + "; path=/";
};


/***/ }),

/***/ 8766:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ useWindowSize; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2991);

function useWindowSize() {
    const [windowSize, setWindowSize] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        width: undefined,
        height: undefined
    });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        function handleResize() {
            var ref, ref1, ref2, ref3;
            setWindowSize({
                width: (document === null || document === void 0 ? void 0 : (ref = document.documentElement) === null || ref === void 0 ? void 0 : ref.clientWidth) || (document === null || document === void 0 ? void 0 : (ref1 = document.body) === null || ref1 === void 0 ? void 0 : ref1.clientWidth) || (window === null || window === void 0 ? void 0 : window.innerWidth),
                height: (document === null || document === void 0 ? void 0 : (ref2 = document.documentElement) === null || ref2 === void 0 ? void 0 : ref2.clientHeight) || (document === null || document === void 0 ? void 0 : (ref3 = document.body) === null || ref3 === void 0 ? void 0 : ref3.clientHeight) || (window === null || window === void 0 ? void 0 : window.innerHeight)
            });
        }
        handleResize();
        window.addEventListener("resize", handleResize);
        return ()=>window.removeEventListener("resize", handleResize);
    }, []);
    return windowSize;
}


/***/ }),

/***/ 6224:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ CategoryCtx; }
/* harmony export */ });
/* unused harmony export LocationCtx */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2991);

const CategoryCtx = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});
const LocationCtx = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});


/***/ }),

/***/ 3366:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ COLORS; }
/* harmony export */ });
var COLORS;
(function(COLORS) {
    COLORS["Mint"] = "Mint";
    COLORS["Black"] = "Black";
    COLORS["White"] = "White";
    COLORS["Grey"] = "Grey";
})(COLORS || (COLORS = {}));


/***/ }),

/***/ 2316:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"threeLinesLimit":"article-card_threeLinesLimit__prFUq","articleCard":"article-card_articleCard__HFkhe","fixedWidth":"article-card_fixedWidth__vXjkU","articleCardImage":"article-card_articleCardImage__fg3ta","articleCardImageWrapper":"article-card_articleCardImageWrapper__icPpM","loading":"article-card_loading__5rwx9","articleCardContentWrapper":"article-card_articleCardContentWrapper__8r6BV","categoriesList":"article-card_categoriesList__PRHah","articleCardContent":"article-card_articleCardContent___c9mF","articleCardContentTitle":"article-card_articleCardContentTitle__N7OBs","articleCardContentDescription":"article-card_articleCardContentDescription__WBryE","articleCardButtonReadMore":"article-card_articleCardButtonReadMore__CCSn9","small":"article-card_small__QuBQy","large":"article-card_large__tyR2F","articleCardLink":"article-card_articleCardLink__AKN6Y","video-spin":"article-card_video-spin__dgTcO","expand":"article-card_expand__D1L5l"};

/***/ }),

/***/ 4688:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"articleGrid":"article-grid_articleGrid__h5gxn","articlesContainer":"article-grid_articlesContainer__0_Gqg","articleLarge":"article-grid_articleLarge__wKq6N","buttonLoadMore":"article-grid_buttonLoadMore__tOrmA","buttonLoadMoreContent":"article-grid_buttonLoadMoreContent__Clnq0","loading":"article-grid_loading__vRiUm","loaded":"article-grid_loaded___t6kZ","spinnerLoadMore":"article-grid_spinnerLoadMore__tY_1b","video-spin":"article-grid_video-spin__PD195","loadMoreContainer":"article-grid_loadMoreContainer__V0lck"};

/***/ }),

/***/ 2090:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"formSearchBlog":"business-header-autocomplete-list_formSearchBlog__kwAkJ","inputSearch":"business-header-autocomplete-list_inputSearch__gnCxg","clearInput":"business-header-autocomplete-list_clearInput__pxKzP","buttonSearch":"business-header-autocomplete-list_buttonSearch__Xt1EF","formShown":"business-header-autocomplete-list_formShown__JLNRt","suggestionsContainer":"business-header-autocomplete-list_suggestionsContainer__c0WhZ","noSuggestions":"business-header-autocomplete-list_noSuggestions__b5U__","suggestionCategoryTitle":"business-header-autocomplete-list_suggestionCategoryTitle__Uaa_C","suggestionCategoryNoneFound":"business-header-autocomplete-list_suggestionCategoryNoneFound__3OOkC","suggestionCategoryList":"business-header-autocomplete-list_suggestionCategoryList__4_71K","suggestionCategoryListText":"business-header-autocomplete-list_suggestionCategoryListText__qIvPb","suggestionMatch":"business-header-autocomplete-list_suggestionMatch__OyXap","spinnerLoadMore":"business-header-autocomplete-list_spinnerLoadMore__rvXiq","video-spin":"business-header-autocomplete-list_video-spin__1cY8h","clicked":"business-header-autocomplete-list_clicked__YTnNl"};

/***/ }),

/***/ 9411:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"articleFooterContainer":"business-footer_articleFooterContainer__xBUa5","articleFooterInner":"business-footer_articleFooterInner__Ss2ro","footerTitle":"business-footer_footerTitle__W_ldb","footerBlock":"business-footer_footerBlock__LW7Gc","footerTop":"business-footer_footerTop__nLgDX","footerBottom":"business-footer_footerBottom__iFotX","footerLocation":"business-footer_footerLocation___OkKA","logoAfterPay":"business-footer_logoAfterPay__mkjQq"};

/***/ }),

/***/ 8239:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"articleHeaderWrapper":"business-header_articleHeaderWrapper__y0Hpo","articleHeaderContainer":"business-header_articleHeaderContainer__uWF82","logoWrapper":"business-header_logoWrapper__mtAXk","iconAfterPay":"business-header_iconAfterPay__ALrh8","businessIcon":"business-header_businessIcon__vjJW4","buttonExplore":"business-header_buttonExplore__ZmuU_","iconDown":"business-header_iconDown__IAgiI","businessHomepageLinks":"business-header_businessHomepageLinks__2iR_3","buttonActive":"business-header_buttonActive__u7PXa","menuRight":"business-header_menuRight__Kg_W_","buttonSignIn":"business-header_buttonSignIn__E12nO","iconSearch":"business-header_iconSearch__KZ_ZA","verticalLine":"business-header_verticalLine__F6sMe","buttonSignUp":"business-header_buttonSignUp__RhqKP","buttonToggleDrawer":"business-header_buttonToggleDrawer__HVtXT","iconMenu":"business-header_iconMenu___FELk","logoAfterPayBusiness":"business-header_logoAfterPayBusiness__yAcee","toggleMenu":"business-header_toggleMenu__SQdvv","drawerMenu":"business-header_drawerMenu__q9BhM","display-none-transition":"business-header_display-none-transition__A5DKe","drawerMenuButton":"business-header_drawerMenuButton__9FgME","accountGroup":"business-header_accountGroup__FRAV_","video-spin":"business-header_video-spin__8nkNT"};

/***/ }),

/***/ 8625:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"categoriesList":"categories_categoriesList__oIEue","categoryName":"categories_categoryName__p1rIr","SMALL":"categories_SMALL__ljgjZ","white":"categories_white__ursPF"};

/***/ }),

/***/ 9336:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"dropdownExplore":"dropdown-explore_dropdownExplore__Gdnix","dropdownContainer":"dropdown-explore_dropdownContainer__RYUrw","dropdownTitle":"dropdown-explore_dropdownTitle__3IC8h","latestArticles":"dropdown-explore_latestArticles__GB6uJ","latestArticlesContainer":"dropdown-explore_latestArticlesContainer__eRUOY","latestArticlesListWrapper":"dropdown-explore_latestArticlesListWrapper__A50FY","articleTypeTitle":"dropdown-explore_articleTypeTitle__RBM0C","articleTypeName":"dropdown-explore_articleTypeName__RN7GD","exploreButtonWrapper":"dropdown-explore_exploreButtonWrapper__cchKa","exploreButtonText":"dropdown-explore_exploreButtonText__Bplxg","moreResource":"dropdown-explore_moreResource__k8Rso","moreResourceWrapper":"dropdown-explore_moreResourceWrapper__RAESl","moreResourceContainer":"dropdown-explore_moreResourceContainer__hWW6Y","moreResourceViewMoreIcon":"dropdown-explore_moreResourceViewMoreIcon__4w31g","moreResourceName":"dropdown-explore_moreResourceName__OpJTw","moreResourceDescription":"dropdown-explore_moreResourceDescription__38mIE","toggleExploreOn":"dropdown-explore_toggleExploreOn__hwhtN"};

/***/ }),

/***/ 8099:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"dropdownSelector":"dropdown-selector_dropdownSelector__8Ng7S"};

/***/ }),

/***/ 1170:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"signUpCard":"sign-up-card_signUpCard__ZOF8_","backgroundImage":"sign-up-card_backgroundImage__iHLpd","title":"sign-up-card_title__h2wdj","description":"sign-up-card_description__4PAdM","buttonSubscribe":"sign-up-card_buttonSubscribe__tejMp","video-spin":"sign-up-card_video-spin__ug_iU"};

/***/ }),

/***/ 4494:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"articleCardSkeleton":"article-card-skeleton_articleCardSkeleton__NjLPl","articleCardSkeletonImage":"article-card-skeleton_articleCardSkeletonImage__4BY1w","articleCardSkeletonLeftContent":"article-card-skeleton_articleCardSkeletonLeftContent__ohasg","articleCardSkeletonLeftContentButton":"article-card-skeleton_articleCardSkeletonLeftContentButton__VxQah","articleCardSkeletonLeftContentTitle":"article-card-skeleton_articleCardSkeletonLeftContentTitle__V1ORu","articleCardSkeletonLeftContentDescription":"article-card-skeleton_articleCardSkeletonLeftContentDescription__iRuGz","small":"article-card-skeleton_small__9BU_u"};

/***/ }),

/***/ 3551:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"articleGridSkeleton":"article-grid-skeleton_articleGridSkeleton__2q0XE"};

/***/ }),

/***/ 87:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"imageSkeleton":"image-skeleton_imageSkeleton__qVtcU","shimmer":"image-skeleton_shimmer__iv_Tj","video-spin":"image-skeleton_video-spin__UZLsz","fadeIn":"image-skeleton_fadeIn__eOp5w"};

/***/ }),

/***/ 7751:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"textSkeleton":"text-skeleton_textSkeleton__4DoZV","shimmer":"text-skeleton_shimmer__sZS7G","video-spin":"text-skeleton_video-spin__HP3Ds","fadeIn":"text-skeleton_fadeIn__YNUIA"};

/***/ })

}]);